angular.module('templates-app', ['auth/forgot/change-password.tpl.html', 'auth/forgot/forgot.tpl.html', 'auth/login/auth.tpl.html', 'auth/registration/signup.tpl.html', 'auth/registration/user-validation.tpl.html', 'auth/sign-in-question/sign.in.question.tpl.html', 'main/category/category.tpl.html', 'main/category/dialog/category-dialog.tpl.html', 'main/category/directive/template.tpl.html', 'main/category/em-category-menu/em-category-menu.tpl.html', 'main/contact-form.tpl.html', 'main/footer.tpl.html', 'main/home/all-offer-premium.tpl.html', 'main/home/home.tpl.html', 'main/home/latest-desktop.tpl.html', 'main/home/promotional-products.tpl.html', 'main/home/welcome.tpl.html', 'main/main.tpl.html', 'main/navigation-bar/categories/category-big-menu.tpl.html', 'main/navigation-bar/favorite-sidenav.tpl.html', 'main/navigation-bar/mobile/tabs.bottom.tpl.html', 'main/navigation-bar/navigation-desktop.tpl.html', 'main/navigation-bar/navigation-mobile.tpl.html', 'main/navigation-bar/navigation-tabs.tpl.html', 'main/navigation-bar/navigation.tpl.html', 'main/navigation-bar/notification-sidenav.tpl.html', 'main/navigation-bar/profile/profile-sidenav.tpl.html', 'main/navigation-bar/profile/profile.tpl.html', 'main/plan/plan.tpl.html', 'main/post/create/add.picture.panel.tpl.html', 'main/post/create/ask.authenticate.dialog/ask.for.authentication.dialog.tpl.html', 'main/post/create/create-desktop.tpl.html', 'main/post/create/create-mobile.tpl.html', 'main/post/create/success.tpl.html', 'main/post/detail.tpl.html', 'main/post/detail/detail.panel.tpl.html', 'main/post/detail/detail.tpl.html', 'main/post/detail/seller-contact-dialog.tpl.html', 'main/post/detail/seller-contact.tpl.html', 'main/post/detail/seller-info.tpl.html', 'main/post/detail/share.tpl.html', 'main/post/em-product-list/em-product-list.tpl.html', 'main/post/em-product/large.tpl.html', 'main/post/em-product/small.tpl.html', 'main/post/offer/offer-list.tpl.html', 'main/post/offer/offer-manage.tpl.html', 'main/post/premium-product-list/premium.product.list.tpl.html', 'main/post/report/report.tpl.html', 'main/post/search/filter_old.tpl.html', 'main/post/search/filter/custom-filter.tpl.html', 'main/post/search/filter/filter.container.tpl.html', 'main/post/search/filter/filter.panel.container.tpl.html', 'main/post/search/filter/filter.tpl.html', 'main/post/search/search-list-old.tpl.html', 'main/post/search/search-list.tpl.html', 'main/post/search/search.tpl.html', 'main/post/share-sheet/share.sheet.tpl.html', 'main/profile/buy/buy.dialog.tpl.html', 'main/profile/card/profile-card.tpl.html', 'main/profile/change-password-dialog/change.password.dialog.tpl.html', 'main/profile/chat/chat-detail.tpl.html', 'main/profile/chat/chat.tpl.html', 'main/profile/chat/dialog/chat-dialog.tpl.html', 'main/profile/detail/detail.tpl.html', 'main/profile/edit-dialog/edit-dialog.tpl.html', 'main/profile/edit-dialog/phone-validation-dialog.tpl.html', 'main/profile/edit/main.advertising.panel.tpl.html', 'main/profile/edit/main.advertising.tpl.html', 'main/profile/edit/profile-edit.tpl.html', 'main/profile/edit/profile.edit.image.tpl.html', 'main/profile/edit/profile.edit.phone.tpl.html', 'main/profile/favorites/favorite.tpl.html', 'main/profile/favorites/list.tpl.html', 'main/profile/favorites/post.tpl.html', 'main/profile/favorites/seller.tpl.html', 'main/profile/menu/menu.tpl.html', 'main/profile/phone-validation-dialog/phone-validation.tpl.html', 'main/profile/products/products.mobile.tpl.html', 'main/profile/products/products.tpl.html', 'main/profile/profile.tpl.html', 'main/profile/transaction/add.balance.dialog.tpl.html', 'main/profile/transaction/transaction.tpl.html', 'main/statics/faqs/faqs.tpl.html', 'main/store/store.tpl.html', 'search/search.tpl.html', 'store/bottom.navigation.tpl.html', 'store/breadcrumbs.tpl.html', 'store/home/store-home.tpl.html', 'store/post/store-post.tpl.html', 'store/search/search-filter.tpl.html', 'store/search/store-search-results.tpl.html', 'store/search/store-search.tpl.html', 'store/statics/store-static-contact.tpl.html', 'store/statics/store-static.tpl.html', 'store/store-categories-menu/store.categories.menu.panel.tpl.html', 'store/store-categories-menu/store.categories.menu.tpl.html', 'store/store-categories/store-categories.tpl.html', 'store/store-product-list/store-product-list.tpl.html', 'store/store-product/store-product.tpl.html', 'store/store-product/store.product.horizontal.tpl.html', 'store/template.tpl.html']);

angular.module("auth/forgot/change-password.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/forgot/change-password.tpl.html",
    "<div class=\"auth forgot\" layout=\"row\" layout-align=\"center center\" layout-align-xs=\"start start\" layout-wrap>\n" +
    "\n" +
    "	<div class=\"logo-wrapper\" flex=\"100\" hide-xs>\n" +
    "		<a>\n" +
    "			<img src=\"assets/logo-slogan.png\" alt=\"\">\n" +
    "		</a>\n" +
    "	</div>\n" +
    "	<div class=\"login-container\" layout=\"row\" flex-gt-sm=\"40\" flex=\"100\">\n" +
    "		<md-card class=\"login\">\n" +
    "			<div class=\"logo-wrapper\" hide-gt-xs>\n" +
    "				<a href=\"\" ui-sref=\"main.home\">\n" +
    "					<img src=\"assets/logo-slogan.png\" alt=\"\">\n" +
    "				</a>\n" +
    "			</div>\n" +
    "			<md-content layout-padding class=\"md-transparent\">\n" +
    "				<form ng-submit=\"authForm.$valid && model.validate()\" layout=\"row\" name=\"authForm\" novalidate layout-wrap>\n" +
    "					<div class=\"email-login\" flex=\"100\" layout=\"row\" layout-wrap>\n" +
    "						<h3 class=\"md-headline\">Reinicio de la contraseña</h3>\n" +
    "						<md-input-container flex=\"100\">\n" +
    "							<label>Nueva Contraseña</label>\n" +
    "							<input type=\"password\" ng-model=\"model.password\" name=\"password\" required>\n" +
    "							<div ng-messages=\"authForm.password.$error\">\n" +
    "								<div ng-message=\"required\">Debes de escribir una contraseña</div>\n" +
    "							</div>\n" +
    "						</md-input-container>\n" +
    "						<md-input-container flex=\"100\">\n" +
    "							<label>Repetir Nueva Contraseña</label>\n" +
    "							<input type=\"password\" name=\"retypePassword\" ng-pattern=\"model.escape(model.password)\" ng-model=\"model.repeatPassword\" required>\n" +
    "							<div ng-messages=\"authForm.retypePassword.$error\">\n" +
    "								<div ng-message=\"required\">Debes de confirmar la contraseña</div>\n" +
    "								<div ng-message=\"pattern\">Las contraseñas no coinciden</div>\n" +
    "							</div>\n" +
    "						</md-input-container>\n" +
    "						<em-button loading-text=\"auth.loadingText\" loading-icon=\"\" is-loading=\"auth.isLoading\" class=\"md-accent md-raised\" type=\"submit\">Cambiar Contraseña</em-button>\n" +
    "					</div>\n" +
    "				</form>\n" +
    "			</md-content>\n" +
    "		</md-card>\n" +
    "	</div>\n" +
    "	<div class=\"login-footer\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"center start\">\n" +
    "		<a ui-sref=\"auth\" flex=\"100\">Iniciar Sesión</a>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("auth/forgot/forgot.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/forgot/forgot.tpl.html",
    "<div class=\"auth forgot\" layout=\"row\" layout=\"row\" flex layout-align=\"center start\">\n" +
    "  <div class=\"auth__container\" flex=\"70\" flex-sm=\"100\" flex-xs=\"100\" flex-md=\"50\" flex-gt-md=\"40\" layout=\"column\">\n" +
    "    <div class=\"logo__container\">\n" +
    "      <a href=\"\" ui-sref=\"main.home\">\n" +
    "      <img src=\"assets/logo-slogan.png\" alt=\"\">\n" +
    "    </a>\n" +
    "    </div>\n" +
    "    <div class=\"form__container\" layout=\"row\">\n" +
    "      <form ng-submit=\"authForm.$valid && model.sendForgotPassword()\" layout=\"row\" name=\"authForm\" novalidate layout-wrap flex>\n" +
    "        <h3 class=\"em-title\">Reinicio de contraseña</h3>\n" +
    "\n" +
    "        <md-input-container class=\"clasic-input\">\n" +
    "					<label>Escriba su correo Electronico o Nombre de Usuario</label>\n" +
    "					<input type=\"text\" ng-model=\"model.email\" name=\"email\" required>\n" +
    "					<div ng-messages=\"authForm.email.$error\">\n" +
    "						<div ng-message=\"required\">No olvides tu correo eléctronico o usuario</div>\n" +
    "					</div>\n" +
    "        </md-input-container>\n" +
    "        <md-button type=\"submit\" class=\"md-accent md-raised md-button--action\">\n" +
    "					Enviar Cambio de Contraseña\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "        </md-button>\n" +
    "\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- <div class=\"auth forgot\" layout=\"row\" layout-align=\"center center\" layout-align-xs=\"start start\" layout-wrap>\n" +
    "\n" +
    "	<div class=\"logo-wrapper\" flex=\"100\" hide-xs>\n" +
    "		<a href=\"\" ui-sref=\"main.home\"><img src=\"assets/logo-slogan.png\" alt=\"\"></a>\n" +
    "	</div>\n" +
    "	<div class=\"login-container\" layout=\"row\" flex-gt-sm=\"40\" flex=\"100\">\n" +
    "		<md-card class=\"login\">\n" +
    "			<div class=\"logo-wrapper\" hide-gt-xs>\n" +
    "				<a href=\"\" ui-sref=\"main.home\">\n" +
    "					<img src=\"assets/logo-slogan.png\" alt=\"\">\n" +
    "				</a>\n" +
    "			</div>\n" +
    "			<md-content layout-padding class=\"md-transparent\">\n" +
    "				<form ng-submit=\"authForm.$valid && model.sendForgotPassword()\" layout=\"row\" name=\"authForm\" novalidate layout-wrap>\n" +
    "					<div class=\"email-login\" flex=\"100\" layout=\"row\" layout-wrap>\n" +
    "            <h3 class=\"md-headline\">Reinicio de la contraseña</h3>\n" +
    "						<md-input-container flex=\"100\">\n" +
    "              <label>Escriba su correo Electronico o Nombre de Usuario</label>\n" +
    "              <input type=\"text\" ng-model=\"model.email\" name=\"email\" required>\n" +
    "							<div ng-messages=\"authForm.email.$error\">\n" +
    "								<div ng-message=\"required\">No olvides tu correo eléctronico o usuario</div>\n" +
    "							</div>\n" +
    "            </md-input-container>\n" +
    "						<em-button loading-text=\"auth.loadingText\" loading-icon=\"\" is-loading=\"auth.isLoading\" class=\"md-accent md-raised\" type=\"submit\">Cambiar Contraseña</em-button>\n" +
    "					</div>\n" +
    "					</form>\n" +
    "				</md-content>\n" +
    "			</md-card>\n" +
    "		</div>\n" +
    "		<div class=\"login-footer\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"center start\">\n" +
    "			<a ui-sref=\"auth\" flex=\"100\">Iniciar Sesión</a>\n" +
    "		</div>\n" +
    "	</div> -->\n" +
    "");
}]);

angular.module("auth/login/auth.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/login/auth.tpl.html",
    "<div class=\"auth\" layout=\"row\" layout=\"row\" flex layout-align=\"center center\">\n" +
    "  <md-toolbar class=\"md-toolbar--simple\" hide-gt-sm>\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button class=\"md-icon-button\" ui-sref=\"main.home\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <span flex></span>\n" +
    "\n" +
    "      <md-button ui-sref=\"signup\">Registrarse</md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <div class=\"auth__container\" flex=\"70\" flex-sm=\"100\" flex-xs=\"100\" flex-md=\"70\" flex-gt-md=\"50\" layout=\"row\" layout-wrap>\n" +
    "    <div class=\"logo__container\" flex=\"100\">\n" +
    "      <a href=\"\" ui-sref=\"main.home\">\n" +
    "        <img src=\"assets/logo-slogan.png\" alt=\"\" />\n" +
    "      </a>\n" +
    "    </div>\n" +
    "    <div class=\"form__container\" layout=\"row\" flex=\"100\">\n" +
    "\n" +
    "      <form ng-submit=\"authForm.$valid && auth.login(auth.user)\" name=\"authForm\" layout=\"column\" novalidate flex flex-gt-sm=\"50\"\n" +
    "        focus-input-invalid>\n" +
    "        <h3 class=\"em-title\">Accede a Tu Cuenta</h3>\n" +
    "\n" +
    "        <p class=\"em-body\">Introduciendo tu correo electrónico y contraseña:</p>\n" +
    "        <md-input-container class=\"clasic-input\">\n" +
    "          <label for=\"\">Usuario</label>\n" +
    "          <input type=\"text\" name=\"username\" ng-model=\"auth.user.username\" required>\n" +
    "          <div ng-messages=\"authForm.username.$error\">\n" +
    "            <div ng-message=\"required\">Debe de escribir un nombre de usuario o correo electronico</div>\n" +
    "          </div>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container class=\"clasic-input\">\n" +
    "          <label for=\"\">Contraseña</label>\n" +
    "          <input ng-keypress=\"auth.invalidCredentials=false\" type=\"password\" tab name=\"password\" ng-model=\"auth.user.password\" required>\n" +
    "          <div ng-messages=\"authForm.password.$error\">\n" +
    "            <div ng-message=\"required\">Por favor no olvides agregar tu contraseña</div>\n" +
    "            <div ng-message=\"wrongcredentials\">El nombre de usuario y/o contraseña es invalido</div>\n" +
    "          </div>\n" +
    "          <div class=\"md-input-messages-animation\" aria-live=\"assertive\" ng-show=\"auth.invalidCredentials\">\n" +
    "            <div class=\"md-input-message-animation\">{{auth.errorMessage}}</div>\n" +
    "          </div>\n" +
    "        </md-input-container>\n" +
    "        <div class=\"extra-actions\" layout=\"row\">\n" +
    "          <md-checkbox ng-model=\"data.cb1\" aria-label=\"recordarme\">\n" +
    "            Recordarme\n" +
    "          </md-checkbox>\n" +
    "          <span flex></span>\n" +
    "          <a href ui-sref=\"forgot\">Olvidé mi contraseña</a>\n" +
    "        </div>\n" +
    "        <md-button type=\"submit\" class=\"md-accent md-raised md-button--action md-large\">Acceder\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <div class=\"social-auth\">\n" +
    "          <md-divider></md-divider>\n" +
    "          <p>ó</p>\n" +
    "          <div class=\"social-auth__buttons\" layout=\"column\">\n" +
    "            <em-social-button network='facebook'></em-social-button>\n" +
    "            <em-social-button network='google'></em-social-button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <p hide-gt-sm class=\"text-center\">¿No tienes cuenta?\n" +
    "          <a href=\"\" ui-sref=\"signup\">Registrate Aquí</a>, solo te tomará un minuto</p>\n" +
    "      </form>\n" +
    "      <div flex layout=\"row\" class=\"auth__art\" layout-align=\"center center\">\n" +
    "        <img src=\"assets/login-art.png\" alt=\"\">\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("auth/registration/signup.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/registration/signup.tpl.html",
    "<div class=\"auth\" layout=\"row\" layout=\"row\" flex layout-align=\"center center\">\n" +
    "	<md-toolbar class=\"md-toolbar--simple\" hide-gt-sm>\n" +
    "		<div class=\"md-toolbar-tools\">\n" +
    "			<md-button class=\"md-icon-button\" ui-sref=\"main.home\">\n" +
    "				<md-icon md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n" +
    "			</md-button>\n" +
    "			<span flex></span>\n" +
    "			<md-button ui-sref=\"auth\">Iniciar Sesión</md-button>\n" +
    "		</div>\n" +
    "	</md-toolbar>\n" +
    "	<div class=\"auth__container\" flex=\"70\" flex-sm=\"100\" flex-xs=\"100\" flex-md=\"70\" flex-gt-md=\"50\" flex layout=\"row\" layout-wrap>\n" +
    "		<div class=\"logo__container\" flex=\"100\">\n" +
    "			<a href=\"\" ui-sref=\"main.home\">\n" +
    "				<img src=\"assets/logo-slogan.png\" alt=\"\">\n" +
    "			</a>\n" +
    "		</div>\n" +
    "		<div class=\"form__container\" layout=\"row\" flex=\"100\">\n" +
    "			<form ng-submit=\"signupForm.$valid && register.signup(register.user)\" name=\"signupForm\" layout=\"column\" novalidate flex flex-gt-sm=\"50\">\n" +
    "				<h3 class=\"em-title\">Crea tu Cuenta</h3>\n" +
    "				<p class=\"em-body\">Introduciendo tu correo electrónico y contraseña:</p>\n" +
    "				<md-input-container class=\"clasic-input\">\n" +
    "					<label>Nombre Completo</label>\n" +
    "					<input autofocus type=\"text\" name=\"fullName\" ng-model=\"register.user.fullName\" required/>\n" +
    "					<div ng-messages=\"signupForm.fullName.$error\">\n" +
    "						<div ng-message=\"required\">Tu nombre es requerido, debemos saber quien eres</div>\n" +
    "					</div>\n" +
    "				</md-input-container>\n" +
    "				<md-input-container class=\"clasic-input\">\n" +
    "					<label>Correo Eléctronico</label>\n" +
    "					<input unique=\"'email'\" type=\"email\" name=\"email\" ng-model=\"register.user.email\" required/>\n" +
    "					<div ng-messages=\"signupForm.email.$error\">\n" +
    "						<div ng-message=\"required\">Tu correo es requerido</div>\n" +
    "						<div ng-message=\"email\">Debes de escribir un correo electronico valido</div>\n" +
    "						<div ng-message=\"unique\">Este correo eléctronico ya está en uso</div>\n" +
    "					</div>\n" +
    "					<md-progress-circular ng-if=\"signupForm.email.$pending\" md-diameter=\"15\"></md-progress-circular>\n" +
    "				</md-input-container>\n" +
    "				<md-input-container class=\"clasic-input\">\n" +
    "					<label>Contraseña</label>\n" +
    "					<input type=\"password\" name=\"password\" ng-model=\"register.user.password\" required/>\n" +
    "					<div ng-messages=\"signupForm.password.$error\">\n" +
    "						<div ng-message=\"required\">Por favor no olvides agregar tu contraseña</div>\n" +
    "					</div>\n" +
    "				</md-input-container>\n" +
    "				<md-input-container class=\"clasic-input\">\n" +
    "					<label>Nombre de Usuario</label>\n" +
    "					<input unique=\"'username'\" pattern=\"^[A-Za-z_][A-Za-z_0-9]{2,19}\" min-length=\"3\" type=\"text\" name=\"username\" ng-model=\"register.user.username\"\n" +
    "					 required/>\n" +
    "					<div ng-messages=\"signupForm.username.$error\">\n" +
    "						<div ng-message=\"required\">Debes de escojer un nombre de usuario</div>\n" +
    "						<div ng-message=\"pattern\">Solo es permitido un usuario de 3 a 20 carácteres, comenzar con una letra y letras alfanúmericas sin espacios ni guión</div>\n" +
    "						<div ng-message=\"unique\">Este usuario ya esta en uso</div>\n" +
    "					</div>\n" +
    "					<md-progress-circular ng-if=\"signupForm.username.$pending\" md-diameter=\"15\"></md-progress-circular>\n" +
    "				</md-input-container>\n" +
    "				<em-button loading-text=\"register.loadingText\" loading-icon=\"\" is-loading=\"register.isLoading\" class=\"md-accent md-raised md-button--action md-large\"\n" +
    "				 type=\"submit\">\n" +
    "					Crear mi cuenta\n" +
    "					<md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "				</em-button>\n" +
    "				<div class=\"social-auth\">\n" +
    "					<md-divider></md-divider>\n" +
    "					<p>ó</p>\n" +
    "					<div class=\"social-auth__buttons\" layout=\"column\">\n" +
    "						<em-social-button network='facebook'></em-social-button>\n" +
    "						<em-social-button network='google'></em-social-button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<p flex=\"100\" hide-gt-sm class=\"text-center suggestion-place-change\">Ya tienes una cuenta?\n" +
    "					<a href=\"\" ui-sref=\"auth\">Inicia Sesión Aquí</a>\n" +
    "				</p>\n" +
    "			</form>\n" +
    "			<div flex layout=\"row\" class=\"auth__art\" layout-align=\"center center\">\n" +
    "				<img src=\"assets/login-art.png\" alt=\"\">\n" +
    "			</div>\n" +
    "\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("auth/registration/user-validation.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/registration/user-validation.tpl.html",
    "<div layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"user-register-validation\">	\n" +
    "	<md-card flex=\"50\">\n" +
    "		<md-card-content layout-align=\"center center\" layout=\"column\" flex=\"grow\">\n" +
    "			 <md-progress-circular  md-diameter=\"70px\" md-mode=\"indeterminate\" ng-if=\"!validate.isNewToken && !validate.errorMessage\"></md-progress-circular>\n" +
    "\n" +
    "			 <h4 flex=\"100\" ng-if=\"!validate.isNewToken && !validate.errorMessage\">Validando espere</h4>\n" +
    "			 <h4 flex=\"100\" ng-if=\"validate.isNewToken\">Este token ha expirado. Se le ha enviado un nuevo token a su cuenta de correo</h4>\n" +
    "\n" +
    "			 <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" ng-if=\"validate.errorMessage\"></md-icon>\n" +
    "			 <h4 flex=\"100\" ng-if=\"validate.errorMessage\">{{ validate.errorMessage }}</h4>\n" +
    "		</md-card-content>	\n" +
    "	</md-card>\n" +
    "</div>");
}]);

angular.module("auth/sign-in-question/sign.in.question.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("auth/sign-in-question/sign.in.question.tpl.html",
    "<div class=\"signin__question\">\n" +
    "  <div class=\"signin__question__image-container\">\n" +
    "    <img src=\"../assets/signin__question-background.png\" alt=\"\">\n" +
    "  </div>\n" +
    "  <h4>¿Tienes cuenta en eMarket?</h4>\n" +
    "  <div class=\"question__container\">\n" +
    "    <md-button class=\"md-raised md-accent\" ui-sref-opts=\"{location: 'replace'}\" ui-sref=\"auth\">Si</md-button>\n" +
    "    <md-button class=\"md-raised md-accent\" ui-sref-opts=\"{location: 'replace'}\" ui-sref=\"signup\">No</md-button>\n" +
    "  </div>\n" +
    "  <md-button ui-sref-opts=\"{location: 'replace'}\" ui-sref=\"main.home\" class=\"cancel-btn\">Cancelar y Salir</md-button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/category/category.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/category/category.tpl.html",
    "<div class=\"categories\" layout=\"row\" layout-align=\"center\">\n" +
    "  <div flex=\"100\" layout=\"column\" flex-gt-sm=\"80\">\n" +
    "\n" +
    "    <h3 class=\"headline\" ng-class=\"{'parent-category': vm.parent}\">\n" +
    "      <md-button class=\"md-icon-button\" go-back>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      {{vm.parent.name || 'Lista de Categorías'}}\n" +
    "    </h3>\n" +
    "\n" +
    "    <md-list hide-gt-sm>\n" +
    "      <md-list-item ng-click=\"vm.onCategoryChoose(category)\" ng-repeat-start=\"category in vm.categories\">\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <h4>{{category.name}}</h4>\n" +
    "        </div>\n" +
    "        <md-icon class=\"md-secondary\" md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "      </md-list-item>\n" +
    "      <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "    </md-list>\n" +
    "    <div class=\"category-big-menu__body\" hide-xs hide-sm ng-if=\"!vm.isMobile\">\n" +
    "      <div class=\"categories\" ng-repeat=\"category in vm.categories\">\n" +
    "        <h4><a ui-sref=\"main.post.search({categoria:category.slug})\">{{category.name}}</a></h4>\n" +
    "        <p ng-repeat=\"cat in vm.getChilds(category)\"><a ui-sref=\"main.post.search({categoria:cat.slug})\">{{cat.name}}</a></p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/category/dialog/category-dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/category/dialog/category-dialog.tpl.html",
    "<md-dialog class=\"category-dialog\">\n" +
    "  <md-toolbar class=\"md-transparent\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button ng-if=\"!model.showBack\" class=\"md-icon-button\" ng-click=\"model.cancel()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <md-button ng-show=\"model.showBack\" class=\"md-icon-button\" ng-click=\"model.goBack()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <h3>{{model.title}}</h3>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-list>\n" +
    "    <md-list-item ng-repeat=\"category in model.categories\" ng-click=\"model.searchChild(category)\">\n" +
    "      <p>{{category.name}}</p>\n" +
    "    </md-list-item>\n" +
    "  </md-list>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/category/directive/template.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/category/directive/template.tpl.html",
    "<md-input-container ng-class=\"{'md-no-float': !$first}\" class=\"em-categories-directive\" ng-repeat=\"categories in categoryList\" ng-if=\"categoryList.length > 0\" flex=\"{{(100 / categoryList.length).toFixed(0)}}\">\n" +
    "	<label ng-if=\"$first\">Categorias</label>	\n" +
    "	<md-select ng-required=\"isRequired && $first\" placeholder=\"{{!$first ? 'Subcategoria' : ''}}\" ng-model=\"cats[$index]\" ng-change=\"updateCategory(cats[$index], $index)\">\n" +
    "		<md-option ng-repeat=\"category in categories\" ng-value=\"category._id\">{{category.name}}</md-option>\n" +
    "	</md-select>\n" +
    "</md-input-container>");
}]);

angular.module("main/category/em-category-menu/em-category-menu.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/category/em-category-menu/em-category-menu.tpl.html",
    "<div class=\"em-category-menu__clickable\"></div>\n" +
    "<div class=\"em-category-menu\" ng-class=\"{'active':isActive}\">\n" +
    "    <md-card class=\"category-menu\">\n" +
    "      <md-card-content>\n" +
    "        <h4>test</h4>\n" +
    "      </md-card-content>\n" +
    "    </md-card>\n" +
    "    <div class=\"category-backdrop\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/contact-form.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/contact-form.tpl.html",
    "<md-dialog flex=\"50\">\n" +
    "  <form ng-cloak class=\"contact-form\" ng-submit=\"send()\">\n" +
    "    <md-toolbar>\n" +
    "      <div class=\"md-toolbar-tools\">\n" +
    "        <h2>Formulario de Contacto</h2>\n" +
    "        <span flex></span>\n" +
    "        <md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "        </md-button>\n" +
    "      </div>\n" +
    "    </md-toolbar>\n" +
    "\n" +
    "    <md-dialog-content>\n" +
    "      <div class=\"md-dialog-content\" flex layout=\"column\">\n" +
    "        <p>\n" +
    "          Si tienes alguna duda, queja o sugerencia solo debes llenar\n" +
    "          este formulario con tus datos y nos pondremos en contacto contigo\n" +
    "          lo más pronto posible.\n" +
    "        </p>\n" +
    "        <md-input-container>\n" +
    "          <label for=\"\">Nombre</label>\n" +
    "          <input type=\"text\" name=\"name\" ng-model=\"form.name\" required>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container>\n" +
    "          <label for=\"\">Email</label>\n" +
    "          <input type=\"text\" name=\"email\" ng-model=\"form.email\" required>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container>\n" +
    "          <label for=\"\">Asunto</label>\n" +
    "          <input type=\"text\" name=\"subject\" ng-model=\"form.subject\" required>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container>\n" +
    "          <label for=\"\">Detalles</label>\n" +
    "          <textarea\n" +
    "            name=\"details\"\n" +
    "            ng-model=\"form.details\"\n" +
    "            required\n" +
    "          ></textarea>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container\n" +
    "          layout=\"row\"\n" +
    "          layout-align=\"end\"\n" +
    "        >\n" +
    "          <md-button ng-click=\"cancel()\">\n" +
    "            Cancelar\n" +
    "          </md-button>\n" +
    "          <md-button\n" +
    "            type=\"submit\"\n" +
    "            class=\"md-accent md-raised\"\n" +
    "          >\n" +
    "            Enviar\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n" +
    "          </md-button>\n" +
    "        </md-input-container>\n" +
    "      </div>\n" +
    "    </md-dialog-content>\n" +
    "  </form>\n" +
    "</md-dialog>");
}]);

angular.module("main/footer.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/footer.tpl.html",
    "<div class=\"footer\" hide-sm hide-xs layout=\"row\" layout-align=\"center\" layout-wrap>\n" +
    "  <div class=\"menu\" layout=\"row\" flex=\"80\">\n" +
    "    <section flex=\"20\">\n" +
    "      <h5>Comprar y Vender</h5>\n" +
    "      <ul>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"signup\">Regístrate</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'aprende-comprar', a:'use'})\">Aprende a Comprar</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'aprende-vender', a:'use'})\">Aprende a Vender</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.post.create\">Publicar un Producto</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </section>\n" +
    "\n" +
    "    <section flex=\"20\">\n" +
    "      <h5>Soporte</h5>\n" +
    "      <ul>\n" +
    "        <!-- <li>\n" +
    "          <a href=\"#\">Soporte Técnico</a>\n" +
    "        </li> -->\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs\">FAQs</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </section>\n" +
    "\n" +
    "    <section flex=\"20\">\n" +
    "      <h5>Metodos de Pago</h5>\n" +
    "      <ul>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'metodo-pago',a:'precios'})\">VisaNET</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'metodo-pago',a:'precios'})\">Paypal</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'metodo-pago',a:'precios'})\">Banco Popular</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </section>\n" +
    "    <section flex=\"20\">\n" +
    "      <h5>Publicidad</h5>\n" +
    "      <ul>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.plan\">Planes</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'banners',a:'precios'})\">Banners</a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <a ui-sref=\"main.statics.faqs({t:'premiums',a:'precios'})\">Productos Premiums</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </section>\n" +
    "\n" +
    "    <section flex=\"20\">\n" +
    "      <h5>Contacto</h5>\n" +
    "      <ul>\n" +
    "        <li>\n" +
    "          <a ng-click=\"model.openContactDialog()\">Formulario de contacto</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <h5>Redes Sociales</h5>\n" +
    "      <md-button aria-label=\"emarket twitter\" class=\"md-icon-button md-social-button__twitter\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <md-button aria-label=\"emarket facebook\" class=\"md-icon-button md-social-button__facebook\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-facebook-box\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <md-button aria-label=\"emarket instangram\" class=\"md-icon-button md-social-button__instagram\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon>\n" +
    "      </md-button>\n" +
    "\n" +
    "    </section>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"sub-footer\" layout=\"column\" flex>\n" +
    "  <p flex hide-xs hide-sm>\n" +
    "    Copyright 1995-{{model.year}}\n" +
    "    <a ui-sref=\"main.home\">eMarket.do</a> Todos los Derechos Reservados\n" +
    "    <a ui-sref=\"main.statics.faqs({t:'politica', a:'seguridad'})\">Políticas de la Institución</a>. Hosted by\n" +
    "    <a href=\"http://dominet.net\">DomiNET.net</a>\n" +
    "  </p>\n" +
    "  <p hide-gt-sm flex>\n" +
    "    <a ng-click=\"model.openContactDialog()\" class=\"tel\">Formulario de contacto</a>\n" +
    "    <span>\n" +
    "      <a ui-sref=\"main.statics.faqs({t:'politica', a:'seguridad'})\">Políticas de la Institución</a> |\n" +
    "      <a ui-sref=\"main.plan\">Nuestros Planes</a>\n" +
    "    </span>\n" +
    "  </p>\n" +
    "  <p flex>\n" +
    "    Este sitio web se encuentra protegido con reCAPTCHA y Google por lo que aplican sus\n" +
    "    <a href=\"https://policies.google.com/privacy\">Políticas de privacidad</a> y\n" +
    "    <a href=\"https://policies.google.com/terms\">Términos de servicio</a>.\n" +
    "  </p>\n" +
    "</div>");
}]);

angular.module("main/home/all-offer-premium.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/home/all-offer-premium.tpl.html",
    "<md-dialog flex=\"60\">\n" +
    "    <md-toolbar class=\"md-transparent\">\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <md-button class=\"md-icon-button\" ng-click=\"hide()\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "            </md-button>\n" +
    "            <h3>Todas las Ofertas Especiales</h3>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-dialog-content layout=\"row\" layout-wrap layout-margin layout-align=\"space-between\">\n" +
    "        <div class=\"product\" ng-repeat=\"premium in posts\">\n" +
    "            <div style=\"max-width:180px\" ui-sref=\"main.post.detail({title:premium.post._id})\" em-product=\"premium.post\"></div>\n" +
    "        </div>\n" +
    "    </md-dialog-content>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/home/home.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/home/home.tpl.html",
    "<div class=\"home\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\">\n" +
    "  <div class=\"home__header\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"center start\">\n" +
    "    <div hide-gt-sm class=\"premium-products premium-products--mobile\" flex=\"100\">\n" +
    "      <div class=\"premium-products__art\">\n" +
    "        <p>Ofertas Especiales</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div loader=\"home.loaders.premiums\" class=\"premium-products\" flex-xs=\"100\" flex-sm=\"100\" flex=\"55\" flex-md=\"70\" layout=\"row\"\n" +
    "      layout-padding hide-gt-sm>\n" +
    "      <!-- <p class=\"md-subhead\" flex=\"100\" hide-sm hide-xs>Productos Destacados</p> -->\n" +
    "      <div class=\"product\" flex-gt-sm=\"25\" ng-repeat=\"premium in home.premiums.front\">\n" +
    "        <div ui-sref=\"main.post.detail({title:premium.post._id})\" em-product=\"premium.post\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div hide-xs hide-sm class=\"premium-products\" flex=\"55\" flex-md=\"70\" layout=\"column\" layout-margin>\n" +
    "      <div class=\"premium-products__art\" layout=\"row\" layout-wrap flex=\"100\">\n" +
    "        <div class=\"product-text\" flex=\"45\" layout=\"column\" layout-align=\"end start\">\n" +
    "          <h3>Ofertas\n" +
    "            <span>Especiales</span>\n" +
    "          </h3>\n" +
    "          <p>Aprovecha las ofertas que tienen nuestros patrocinadores</p>\n" +
    "          <!-- <span flex></span> -->\n" +
    "          <md-button ui-sref=\"main.post.search({premium:1})\" class=\"md-raised md-primary\">\n" +
    "            Ver todas las ofertas\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "          </md-button>\n" +
    "        </div>\n" +
    "        <div class=\"product-list\" flex=\"55\" layout=\"row\" layout-wrap loader=\"home.loaders.premiums\" layout-align=\"end start\">\n" +
    "          <div class=\"product\" flex-gt-sm=\"50\" ng-repeat=\"premium in home.premiums.front | limitTo:4:home.startAt\">\n" +
    "            <a ui-sref=\"main.post.detail({title:premium.post._id})\" em-product=\"premium.post\"></a>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div loader=\"home.loaders.premiums\" flex=\"25\" class=\"premium-stores\" layout=\"row\" layout-wrap hide-xs hide-sm>\n" +
    "      <em-premium-stores flex=\"100\" stores=\"home.premiums.store\"></em-premium-stores>\n" +
    "    </div>\n" +
    "\n" +
    "    <div flex=\"80\" layout=\"row\" class=\"premium-latest\" hide-xs hide-sm>\n" +
    "      <a sponsor=\"true\" ui-sref=\"main.post.detail({title:product.post._id})\" flex=\"25\" ng-repeat=\"product in home.premiums.latest | limitTo:4\"\n" +
    "        em-product=\"product.post\" size=\"large\"></a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div hide-gt-sm class=\"promotional-products\" flex=\"100\" ng-include=\"'main/home/promotional-products.tpl.html'\"></div>\n" +
    "  <!-- latest product on desktop -->\n" +
    "  <div class=\"home__content\" flex=\"100\" layout=\"row\" layout-align=\"center\">\n" +
    "    <div loader=\"home.loaders.last\" flex=\"80\" flex-md=\"95\" hide-sm hide-xs class=\"latest-products\" layout=\"row\" layout-wrap layout-padding>\n" +
    "      <div layout=\"row\" flex=\"100\" ng-include=\"'main/home/latest-desktop.tpl.html'\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <!-- latest product on mobile -->\n" +
    "  <md-content flex=\"100\" hide-gt-sm class=\"latest-products\" loader=\"home.loaders.last\">\n" +
    "    <md-subheader ng-repeat-start=\"categories in home.products.categories\">\n" +
    "      {{categories.category.name}}\n" +
    "      <md-button ui-sref=\"main.post.search({category:categories.category.slug})\" class=\"md-small md-primary md-raised\">Ver más</md-button>\n" +
    "    </md-subheader>\n" +
    "    <md-list ng-repeat-end>\n" +
    "      <md-list-item ng-repeat-start=\"product in categories.posts\" ui-sref=\"main.post.detail({title:product._id})\" class=\"md-2-line\">\n" +
    "        <img em-src-image=\"product.images[0]\" small alt=\"\" class=\"md-avatar\">\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <h3>{{product.title}}</h3>\n" +
    "          <p class=\"em-product-list__price\">{{product.prices.list | currency:'RD$':2}}</p>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "      <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "    </md-list>\n" +
    "    <md-subheader>\n" +
    "      Otros productos\n" +
    "      <md-button class=\"md-small md-primary md-raised\" ui-sref=\"main.post.search\">Ver más</md-button>\n" +
    "    </md-subheader>\n" +
    "    <md-list>\n" +
    "      <md-list-item ui-sref=\"main.post.detail({title:product._id})\" class=\"md-2-line\" ng-repeat-start=\"product in home.products.latest\">\n" +
    "        <img em-src-image=\"product.images[0]\" small alt=\"\" class=\"md-avatar\">\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <h3>{{product.title}}</h3>\n" +
    "          <p class=\"em-product-list__price\">{{product.prices.list | currency:'RD$':2}}</p>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "      <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "    </md-list>\n" +
    "    <!-- <em-product-list products=\"home.products.categories\"></em-product-list> -->\n" +
    "  </md-content>\n" +
    "</div>");
}]);

angular.module("main/home/latest-desktop.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/home/latest-desktop.tpl.html",
    "<div class=\"latest__wrapper\" layout=\"row\" layout-wrap flex>\n" +
    "  <div class=\"latest latest__desktop\" ng-repeat-start=\"categories in home.products.categories\" layout=\"row\" layout-wrap flex=\"100\">\n" +
    "    <div class=\"latest__header\" flex=\"100\" layout=\"row\">\n" +
    "      <p class=\"md-title\">\n" +
    "        {{categories.category.name}}\n" +
    "      </p>\n" +
    "      <span flex></span>\n" +
    "      <md-button ui-sref=\"main.post.search({categoria:categories.category.slug})\" class=\"md-small md-primary md-raised\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n" +
    "        Ver todos\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "    <div class=\"latest__block\" layout=\"row\" flex=\"100\">\n" +
    "      <a ui-sref=\"main.post.detail({title:categories.posts[0]._id})\" flex=\"30\" size=\"large\" em-product=\"categories.posts[0]\" class=\"em-product--light\"></a>\n" +
    "      <div class=\"latest__list\" flex layout=\"row\" layout-wrap>\n" +
    "        <a ui-sref=\"main.post.detail({title:product._id})\" ng-repeat=\"product in categories.posts | limitTo:6:1\" flex=\"50\">\n" +
    "          <div class=\"product-list\" layout=\"row\">\n" +
    "            <div class=\"product__image\">\n" +
    "              <img src=\"\" em-src-image=\"product.images[0]\" thumbnail alt=\"\">\n" +
    "            </div>\n" +
    "            <div class=\"product__content\" flex>\n" +
    "              <p class=\"product__title\">{{product.title}}</p>\n" +
    "              <p class=\"product__price\">{{product.prices.list | currency:product.currency.symbol:2}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <md-divider flex=\"100\" ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "</div>\n" +
    "<div class=\"banners\" layout=\"row\" layout-wrap>\n" +
    "  <h3 class=\"md-title\">Otros Productos Recientes</h3>\n" +
    "  <div flex=\"100\" class=\"other-latest\">\n" +
    "    <md-list>\n" +
    "      <md-list-item ui-sref=\"main.post.detail({title:product._id})\" class=\"md-2-line\" ng-repeat-start=\"product in home.products.latest | limitTo:7\">\n" +
    "        <img class=\"md-avatar\" thumbnail em-src-image=\"product.images[0]\" alt=\"\">\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <p>{{product.title}}</p>\n" +
    "          <h3>{{product.price | currency:product.currency.symbol:2}}</h3>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "      <md-divider md-inset ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "    </md-list>\n" +
    "  </div>\n" +
    "  <em-banner size=\"300x250\" slot=\"1747645617\"></em-banner>\n" +
    "  <em-banner image=\"'/assets/images/web/banner/lucy-muebles.gif'\" size=\"300x250\"></em-banner>\n" +
    "</div>");
}]);

angular.module("main/home/promotional-products.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/home/promotional-products.tpl.html",
    "<h4>Productos Promocionales</h4>\n" +
    "<div class=\"product-list\" layout=\"row\" layout-wrap>\n" +
    "    <a flex=\"50\" ui-sref=\"main.post.detail({title:product.post._id})\" ng-repeat=\"product in home.premiums.latest\" em-product=\"product.post\"></a>\n" +
    "</div>");
}]);

angular.module("main/home/welcome.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/home/welcome.tpl.html",
    "<md-dialog flex-gt-sm=\"40\" flex=\"90\">\n" +
    "\n" +
    "    <md-dialog-content class=\"md-dialog-content\">\n" +
    "\n" +
    "        <h2 class=\"md-title\">Bienvenido a eMarket</h2>\n" +
    "        <div class=\"md-dialog-content-body\">\n" +
    "            <p>Felicidades, ya eres parte de nuestro equipo de eMarket, recuerda que debes de validar tu correo eléctronico\n" +
    "                para poder publicar productos, no te olvides de revisar tu bandeja de no deseados (spam) en caso de que no\n" +
    "                puedas verlo\n" +
    "            </p>\n" +
    "        </div>\n" +
    "\n" +
    "    </md-dialog-content>\n" +
    "    <md-dialog-actions>\n" +
    "        <md-button ng-click=\"vm.close()\" ui-sref=\"main.home({bienvenido:null})\" ui-sref-opts=\"{location:'replace'}\">SEGUIR NAVENGANDO</md-button>\n" +
    "        <md-button ng-click=\"vm.close()\" ui-sref=\"main.post.create\" ui-sref-opts=\"{location:'replace'}\" class=\"md-primary\">PUBLICAR PRODUCTO</md-button>\n" +
    "    </md-dialog-actions>\n" +
    "</md-dialog>");
}]);

angular.module("main/main.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/main.tpl.html",
    "<div layout=\"column\" flex class=\"main-wrapper\">\n" +
    "  <div class=\"main-toolbar-container\" ng-include=\"'main/navigation-bar/navigation.tpl.html'\"></div>\n" +
    "  <section flex-xs flex-sm class=\"main-wrapper-section\" ng-class=\"{'transparent-toolbar':actions.transparentToolbar}\" scroll-top='\"main-wrapper\"'>\n" +
    "    <div class=\"top-banner-wrapper\" layout=\"row\" layout-align=\"center\">\n" +
    "      <span ng-if=\"model.timestamp > 1541736000000\">\n" +
    "        <em-banner slot=\"9270912410\" size=\"728x90\"></em-banner>\n" +
    "      </span>\n" +
    "      <span ng-if=\"model.timestamp <= 1541736000000\" style=\"margin: 10px auto;\">\n" +
    "        <a href=https://invmanuelcabrera.com/las-cayenas\"\" target=\"_blank\">\n" +
    "          <img src=\"/assets/images/banners/Residencial-Las-Cayenas-banner-728x90.gif\" alt=\"Publicidad Residencial Las Cayenas\" style=\"max-width: 100%\">\n" +
    "        </a>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <div ui-view=\"main\" style=\"overflow-y:visible\" class=\"main-view\" layout=\"column\" flex></div>\n" +
    "    <div ng-include=\"'main/footer.tpl.html'\"></div>\n" +
    "  </section>\n" +
    "\n" +
    "</div>");
}]);

angular.module("main/navigation-bar/categories/category-big-menu.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/categories/category-big-menu.tpl.html",
    "<div class=\"category-big-menu__container\" flex>\n" +
    "\n" +
    "  <div class=\"category-big-menu__header\" ng-hide=\"true\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "    <h3>Listado de categorías</h3>\n" +
    "    <md-button ng-click=\"model.close()\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      Cerrar\n" +
    "    </md-button>\n" +
    "  </div>\n" +
    "  <div class=\"category-big-menu__body\">\n" +
    "    <div class=\"categories\" ng-repeat=\"category in model.parents\">\n" +
    "      <h4>\n" +
    "        <a ng-click=\"model.close()\" ui-sref=\"main.post.search({categoria:category.slug})\" ui-sref-opts=\"{reload: true}\">{{category.name}}</a>\n" +
    "      </h4>\n" +
    "      <p ng-repeat=\"cat in model.getChilds(category) | limitTo:10\">\n" +
    "        <a ng-click=\"model.close()\" ui-sref=\"main.post.search({categoria:cat.slug})\" ui-sref-opts=\"{reload: true}\">{{cat.name}}</a>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"category-big-menu__footer\" layout=\"row\" layout-align=\"end\">\n" +
    "    <md-button ui-sref=\"main.category\">\n" +
    "      Ver listado completo de categorias\n" +
    "    </md-button>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("main/navigation-bar/favorite-sidenav.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/favorite-sidenav.tpl.html",
    "<md-sidenav class=\"sidenav-notification md-sidenav-right\" md-whiteframe=\"4\" md-component-id=\"sidenav-favorite\" layout=\"column\">\n" +
    "    <md-toolbar>\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <md-button class=\"md-icon-button\" ng-click=\"model.showFavoriteSidenav()\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                <md-tooltip>Cerrar</md-tooltip>\n" +
    "            </md-button>\n" +
    "            <h3>Mis Favoritos</h3>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-content flex>\n" +
    "        <md-card ng-click=\"model.showFavoriteSidenav()\" ui-sref=\"main.post.detail({title:favorite.post._id})\" flex=\"100\" md-ink-ripple ng-repeat=\"favorite in model.favorites\">\n" +
    "            <div layout=\"row\" class=\"header\">\n" +
    "              <p class=\"md-subhead\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "                <span duration=\"favorite.createdAt\">{{favorite.createdAt}}</span>\n" +
    "              </p>\n" +
    "                <span flex></span>\n" +
    "                <md-button aria-label=\"eliminar favorito\" class=\"md-icon-button\">\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                </md-button>\n" +
    "            </div>\n" +
    "            <md-card-title>\n" +
    "                <md-card-title-text layout-wrap layout=\"row\" layout-align=\"end space-between\">\n" +
    "                    <span flex=\"100\" class=\"md-title\">{{favorite.post.title | limitTo:40}}</span>\n" +
    "                    <span flex=\"100\" class=\"md-headline md-warn\">{{favorite.post.prices.list | currency:'RD$':2}}</span>\n" +
    "                </md-card-title-text>\n" +
    "                <md-card-title-media>\n" +
    "                    <img class=\"md-media-sm card-media\" square em-src-image=\"favorite.post.images[0].path\" alt=\"\"/>\n" +
    "                </md-card-title-media>\n" +
    "            </md-card-title>\n" +
    "        </md-card>\n" +
    "    </md-content>\n" +
    "</md-sidenav>\n" +
    "");
}]);

angular.module("main/navigation-bar/mobile/tabs.bottom.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/mobile/tabs.bottom.tpl.html",
    "<div class=\"tabs-navigation-bottom\">\n" +
    "  <md-button ui-sref=\"main.home\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-home\"></md-icon>\n" +
    "    Inicio\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"main.category\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-assignment\"></md-icon>\n" +
    "    Categorias\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"main.store\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-store\"></md-icon>\n" +
    "    Tiendas\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"auth\" ng-hide=\"model.user\">\n" +
    "    <!-- <div class=\"badge__container\">\n" +
    "      <div class=\"badge badge--notify badge--warn\"></div>\n" +
    "    </div> -->\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n" +
    "    Acceder\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"main.profile.menu\" ng-show=\"model.user\">\n" +
    "    <div class=\"badge__container\" ng-show=\"model.unreadMessages\">\n" +
    "      <div class=\"badge badge--notify badge--warn\"></div>\n" +
    "    </div>\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n" +
    "    Mi Perfil\n" +
    "  </md-button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/navigation-bar/navigation-desktop.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/navigation-desktop.tpl.html",
    "<!-- //mini navigation -->\n" +
    "<md-toolbar class=\"small\">\n" +
    "  <div class=\"md-toolbar-tools\" layout-align=\"center center\">\n" +
    "    <div layout=\"row\" flex=\"80\">\n" +
    "      <div class=\"social-network\">\n" +
    "        <h4 class=\"assistance-number\">\n" +
    "          <a ng-click=\"model.openContactDialog()\">Formulario de contacto</a>\n" +
    "        </h4>\n" +
    "      </div>\n" +
    "      <div class=\"main-navigation\" flex ng-include=\"'main/navigation-bar/navigation-tabs.tpl.html'\">\n" +
    "\n" +
    "      </div>\n" +
    "      <div ng-include=\"'main/navigation-bar/profile/profile.tpl.html'\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</md-toolbar>\n" +
    "<!--  large navigation-->\n" +
    "<md-toolbar class=\"large md-whiteframe-1dp\">\n" +
    "  <div class=\"md-toolbar-tools\" layout-align=\"center center\">\n" +
    "    <div flex=\"100\" layout=\"row\" layout-align=\"center center\">\n" +
    "      <div class=\"logo\">\n" +
    "        <a href ui-sref=\"main.home\">\n" +
    "          <img class=\"img-responsive\" src=\"assets/logo-slogan-white.png\" alt=\"\">\n" +
    "        </a>\n" +
    "      </div>\n" +
    "      <div class=\"categories-menu\" md-ink-ripple>\n" +
    "        <a class=\"categories-btn\" href ng-click=\"model.showCategories($event)\">\n" +
    "          <span>Buscar por</span> Categorías\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "      <form flex layout=\"row\" class=\"search-form\" ng-submit=\"model.makeSearch(model.searchText)\">\n" +
    "        <md-autocomplete ng-blur=\"model.onBlurInput()\" md-selected-item-change=\"model.makeSearch(model.selectedSuggestion.value)\"\n" +
    "          id=\"md-search-autocomplete\" md-require-match=\"false\" md-min-length=\"0\" md-selected-item=\"model.selectedSuggestion\"\n" +
    "          md-search-text=\"model.searchText\" md-search-text-change=\"model.search(model.searchText)\" md-match-case-insensitive\n" +
    "          placeholder=\"Buscar\" md-items=\"item in model.suggestions\" flex md-item-text=\"item.display\">\n" +
    "          <md-item-template>\n" +
    "            <span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span>\n" +
    "          </md-item-template>\n" +
    "        </md-autocomplete>\n" +
    "\n" +
    "        <md-button aria-label=\"iniciar busqueda\" type=\"submit\" class=\"md-raised search-button\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "        </md-button>\n" +
    "      </form>\n" +
    "      <div class=\"province__chooser\" province-chooser=\"model.province\">\n" +
    "        <span>\n" +
    "          En {{model.province.name}}\n" +
    "        </span>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon>\n" +
    "      </div>\n" +
    "      <md-button ng-hide=\"actions.hideFabActionMobile\" ui-sref=\"main.post.create\" class=\"md-raised md-accent publish-btn\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n" +
    "        Publicar\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</md-toolbar>");
}]);

angular.module("main/navigation-bar/navigation-mobile.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/navigation-mobile.tpl.html",
    "<md-toolbar md-scroll-shrink class=\"mobile md-whiteframe-1dp\">\n" +
    "  <div class=\"md-toolbar-tools\">\n" +
    "    <md-button go-back ng-show=\"model.showBackButton\" hide-gt-sm aria-label=\"regresar\" class=\"toolbar__back-button\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "    </md-button>\n" +
    "    <img class=\"logo\" ui-sref=\"main.home\" src=\"assets/logo-slogan-white.png\" alt=\"\">\n" +
    "    <span flex hide-gt-sm></span>\n" +
    "    <md-button ui-sref=\"main.post.create\" class=\"md-raised md-small md-accent publish-btn\">\n" +
    "      Publicar\n" +
    "    </md-button>\n" +
    "    <!-- <md-button hide-xs ng-hide=\"model.user\" ui-sref=\"auth\">\n" +
    "            Iniciar Sesión / Registrarse\n" +
    "        </md-button>\n" +
    "        <md-button ui-sref=\"auth\" hide-gt-xs ng-hide=\"model.user\" class=\"md-icon-button\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n" +
    "            <md-tooltip md-delay=\"400\">Iniciar Sesión</md-tooltip>\n" +
    "        </md-button> -->\n" +
    "    <!-- <md-button ng-if=\"model.favorites.length\" ng-click=\"model.showFavoriteSidenav()\" aria-label=\"notificaciones\" class=\"md-icon-button badge__container\" ng-show=\"model.user\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-favorite\"></md-icon>\n" +
    "            <md-icon class=\"badge\">{{model.favorites.length}}</md-icon>\n" +
    "            <md-tooltip md-delay=\"400\">Mis productos favoritos</md-tooltip>\n" +
    "        </md-button>\n" +
    "        -->\n" +
    "    <!-- TODO: Uncommend notification when ready -->\n" +
    "    <!-- <md-button ng-click=\"model.showNotificationSidenav()\" aria-label=\"notificaciones\" class=\"md-icon-button\" ng-show=\"model.user\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-notifications\"></md-icon>\n" +
    "            </md-button> -->\n" +
    "    <!-- <md-button ui-sref=\"search\" hide-gt-sm aria-label=\"busqueda\" class=\"md-icon-button\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "        </md-button> -->\n" +
    "\n" +
    "  </div>\n" +
    "</md-toolbar>\n" +
    "<form flex layout=\"row\" class=\"search-form search-form--mobile\" ng-submit=\"model.makeSearch(model.searchText)\" ng-class=\"{searching:model.searchText}\"\n" +
    "  ng-hide=\"model.hideSearchBar\">\n" +
    "  <md-autocomplete md-escape-options=\"\" ng-blur=\"model.onBlurInput()\" md-selected-item-change=\"model.makeSearch(model.selectedSuggestion.value)\"\n" +
    "    id=\"md-search-autocomplete\" md-require-match=\"false\" md-min-length=\"0\" md-selected-item=\"model.selectedSuggestion\" md-search-text=\"model.searchText\"\n" +
    "    md-search-text-change=\"model.search(model.searchText)\" md-match-case-insensitive placeholder=\"Buscar en {{model.province.name}}\"\n" +
    "    md-items=\"item in []\" flex md-item-text=\"item.display\">\n" +
    "    <md-item-template>\n" +
    "      <span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">\n" +
    "        {{item.display}}\n" +
    "      </span>\n" +
    "    </md-item-template>\n" +
    "  </md-autocomplete>\n" +
    "  <md-button aria-label=\"iniciar busqueda\" type=\"submit\" class=\"md-raised search-button\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "  </md-button>\n" +
    "  <md-button province-chooser=\"model.province\" ng-hide=\"model.showFilterButton\" class=\"filter md-raised\" ng-click=\"model.showFilter()\">\n" +
    "    <img src=\"assets/do_map.png\" alt=\"\">\n" +
    "  </md-button>\n" +
    "  <md-button ng-show=\"model.showFilterButton\" class=\"filter md-raised\" ng-click=\"model.showFilter()\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-filter-list\"></md-icon>\n" +
    "    Filtrar\n" +
    "  </md-button>\n" +
    "</form>\n" +
    "<!-- <div ng-include=\"'main/navigation-bar/profile-sidenav.tpl.html'\"></div>\n" +
    "<div ng-include=\"'main/navigation-bar/notification-sidenav.tpl.html'\"></div> -->\n" +
    "<!-- <div ng-include=\"'main/navigation-bar/favorite-sidenav.tpl.html'\"></div> -->\n" +
    "<div ng-include=\"'main/navigation-bar/mobile/tabs.bottom.tpl.html'\"></div>\n" +
    "\n" +
    "<md-progress-linear ng-show=\"model.isLoading\" md-mode=\"query\" ng-show=\"\"></md-progress-linear>");
}]);

angular.module("main/navigation-bar/navigation-tabs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/navigation-tabs.tpl.html",
    "<md-nav-bar aria-label=\"menú principal\" md-theme=\"dark-navigation\" md-selected-nav-item=\"model.currentNavigation\" ng-class=\"{'hide-publish-btn':hideFabAction}\">\n" +
    "	<md-nav-item md-nav-sref=\"main.home\" name=\"main.home\">Inicio</md-nav-item>\n" +
    "	<md-nav-item md-nav-sref=\"main.store\" name=\"main.store\">Tiendas</md-nav-item>\n" +
    "	<md-nav-item md-nav-sref=\"main.category\" name=\"main.category\">Categorias</md-nav-item>\n" +
    "	<!-- <md-nav-item hide-sm hide-xs md-nav-sref=\"main.help\" name=\"main.help\">Ayuda</md-nav-item> -->\n" +
    "</md-nav-bar>\n" +
    "");
}]);

angular.module("main/navigation-bar/navigation.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/navigation.tpl.html",
    "<div class=\"navigation\" ng-controller=\"NavigationController as model\" ng-include=\"model.navigationTemplate\">\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/navigation-bar/notification-sidenav.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/notification-sidenav.tpl.html",
    "<md-sidenav class=\"sidenav-notification md-sidenav-right\" md-whiteframe=\"4\" md-component-id=\"sidenav-notification\" layout=\"column\">\n" +
    "    <md-toolbar>\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <md-button class=\"md-icon-button\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>\n" +
    "                <md-tooltip>Cerrar</md-tooltip>\n" +
    "            </md-button>\n" +
    "            <h3>Notificaciones</h3>\n" +
    "            <span flex></span>\n" +
    "            <md-button class=\"md-icon-button\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-format-clear-all\"></md-icon>\n" +
    "                <md-tooltip>Descartar todas</md-tooltip>\n" +
    "            </md-button>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-content flex>\n" +
    "        <md-card flex=\"100\" md-ink-ripple>\n" +
    "            <div class=\"\" layout=\"row\">\n" +
    "                <span flex></span>\n" +
    "                <md-button aria-label=\"Eliminar notificacion\" class=\"md-icon-button\">\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                </md-button>\n" +
    "            </div>\n" +
    "            <md-card-title>\n" +
    "                <md-card-title-text>\n" +
    "                    <span class=\"md-title\">Jorge Perez te ha enviado un mensaje</span>\n" +
    "                    <span class=\"md-subhead\">Hey mano, me lo dejas un poco mas barato?</span>\n" +
    "                </md-card-title-text>\n" +
    "                <md-card-title-media>\n" +
    "                    <img class=\"md-media-sm card-media\" src=\"https://pickaface.net/gallery/avatar/Opi51c7dccf270e0.png\" alt=\"\"/>\n" +
    "                </md-card-title-media>\n" +
    "            </md-card-title>\n" +
    "        </md-card>\n" +
    "    </md-content>\n" +
    "</md-sidenav>\n" +
    "");
}]);

angular.module("main/navigation-bar/profile/profile-sidenav.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/profile/profile-sidenav.tpl.html",
    "<md-sidenav class=\"sidenav-profile\" md-whiteframe=\"4\" md-component-id=\"sidenav-profile\" layout=\"column\">\n" +
    "\n" +
    "    <md-content flex>\n" +
    "        <div class=\"profile\">\n" +
    "          <img square class=\"md-avatar\" em-src-image=\"model.user.picture.path\" alt=\"{{model.user.displayName}}\" />\n" +
    "          <h3 class=\"md-title\">{{user.displayName}}</h3>\n" +
    "          <a ng-click=\"model.showProfileSidenav()\" ui-sref=\"main.profile.products({editar:true})\">Ver Pefil</a>\n" +
    "        </div>\n" +
    "        <md-list>\n" +
    "          <md-list-item ng-click=\"model.showProfileSidenav()\" ui-sref=\"main.profile.products\">Mis anuncios</md-list-item>\n" +
    "        </md-list>\n" +
    "        <md-list>\n" +
    "          <md-list-item ng-click=\"model.showProfileSidenav()\" ui-sref=\"main.profile.favorite\">Favoritos</md-list-item>\n" +
    "        </md-list>\n" +
    "        <md-list>\n" +
    "          <md-list-item ng-click=\"model.showProfileSidenav()\" ui-sref=\"main.profile.chat\">Mensajes</md-list-item>\n" +
    "        </md-list>\n" +
    "        <md-list>\n" +
    "          <md-list-item ng-click=\"model.logout();model.showProfileSidenav()\">Salir</md-list-item>\n" +
    "        </md-list>\n" +
    "    </md-content>\n" +
    "</md-sidenav>\n" +
    "");
}]);

angular.module("main/navigation-bar/profile/profile.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/navigation-bar/profile/profile.tpl.html",
    "<div ng-controller=\"ProfileNavigationController as vm\" class=\"profile-navigation\">\n" +
    "\n" +
    "  <div ng-hide=\"vm.user\" hide-sm hide-xs class=\"user-section\" layout=\"row\">\n" +
    "    <md-button ui-sref=\"auth\">Iniciar Sesión</md-button>\n" +
    "    <div class=\"vertical-divider\"></div>\n" +
    "    <md-button ui-sref=\"signup\">Registrarse</md-button>\n" +
    "  </div>\n" +
    "  <md-button ng-hide=\"user\" ui-sref=\"auth\" hide-gt-sm class=\"md-icon-button profile-button\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n" +
    "  </md-button>\n" +
    "  <div ng-show=\"vm.user\">\n" +
    "    <md-menu>\n" +
    "      <md-button class=\"md-button-avatar\" ng-class=\"{'md-icon-button':$mdMedia('gt-sm')}\" aria-label=\"Open demo menu\" ng-click=\"$mdMenu.open($event)\">\n" +
    "        <img em-src-image=\"vm.user.picture\" thumbnail class=\"md-avatar\" alt=\"\">\n" +
    "        <div class=\"badge__container\" ng-show=\"$parent.model.unreadMessages\">\n" +
    "          <div class=\"badge badge--notify badge--warn\">\n" +
    "            <p>{{$parent.model.unreadMessages > 9 ? '9+' : $parent.model.unreadMessages}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <span class=\"display-name\" hide-xs hide-sm>\n" +
    "          <span>\n" +
    "            {{vm.user.displayName}}\n" +
    "          </span>\n" +
    "          <span class=\"display-name__balance\" ng-if=\"vm.user.balance > 0\">\n" +
    "            <strong>balance: </strong>{{vm.user.balance | currency:'$':2}}\n" +
    "          </span>\n" +
    "        </span>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <md-menu-content width=4>\n" +
    "        <md-menu-item ui-sref=\"main.profile.products\">\n" +
    "          <md-button>Mis Anuncios\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "        <md-menu-item ui-sref=\"main.profile.chat\">\n" +
    "          <md-button>\n" +
    "            <div layout=\"row\" flex>\n" +
    "              <p flex>Mis Mensajes</p>\n" +
    "              <md-icon ng-if=\"$parent.model.unreadMessages\" class=\"badge badge--warn\" md-menu-align-target>{{$parent.model.unreadMessages}}</md-icon>\n" +
    "            </div>\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "        <md-menu-item ui-sref=\"main.profile.favorite.post\">\n" +
    "          <md-button>\n" +
    "            Productos Favoritos\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "        <md-menu-item ui-sref=\"main.profile.favorite.seller\">\n" +
    "          <md-button>\n" +
    "            Tiendas Favoritas\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "        <md-menu-item ui-sref=\"main.profile.edit\">\n" +
    "          <md-button>\n" +
    "            Editar Perfil\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "        <md-divider></md-divider>\n" +
    "        <md-menu-item>\n" +
    "          <md-button ng-click=\"vm.logout()\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-arrow-left\" aria-label=\"Salir\"></md-icon>Salir\n" +
    "          </md-button>\n" +
    "        </md-menu-item>\n" +
    "\n" +
    "      </md-menu-content>\n" +
    "    </md-menu>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("main/plan/plan.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/plan/plan.tpl.html",
    "<div class=\"plans\" layout=\"row\" flex layout-align=\"center start\">\n" +
    "    <div flex=\"80\" layout=\"row\" layout-align=\"space-between\" layout-wrap>\n" +
    "        <div class=\"free-plan\">\n" +
    "            <h4>Cuenta Gratuita</h4>\n" +
    "            <div class=\"free-plan__content\">\n" +
    "                <p>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                    <strong>{{model.freePlan.characteristics.post}}</strong> Productos</p>\n" +
    "                <p>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                    <strong>{{model.freePlan.characteristics.images}}</strong> Fotos por producto</p>\n" +
    "                <p>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                    <strong>25</strong> Días</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"plan\" ng-class=\"{'plan--recommended': $index===1}\" ng-repeat=\"plan in vm.plans\">\n" +
    "            <h4 class=\"plan__title\">{{plan.name}}</h4>\n" +
    "            <h5 class=\"plan__price\">\n" +
    "                RD$\n" +
    "                <strong>{{plan.price | currency:'':2}}</strong>/mes\n" +
    "            </h5>\n" +
    "\n" +
    "            <div class=\"plan__icon plan__icon--{{$index}}\">\n" +
    "                <md-icon md-svg-src=\"assets/store/small_{{$index}}.svg\"></md-icon>\n" +
    "            </div>\n" +
    "            <div class=\"plan__content\">\n" +
    "                <p>\n" +
    "                    <strong>{{plan.characteristics.post}}</strong> Productos</p>\n" +
    "                <p>\n" +
    "                    <strong>{{plan.characteristics.images}}</strong> Fotos por producto</p>\n" +
    "                <strong>30</strong> Días por producto</p>\n" +
    "                <p ng-if=\"plan.characteristics.store\">\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-check\" class=\"md-success\"></md-icon>\n" +
    "                    Permite tienda\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    <p ng-if=\"!plan.characteristics.store\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-close\" class=\"md-warn\"></md-icon>\n" +
    "                        No Permite tienda\n" +
    "                    </p>\n" +
    "                    <p ng-if=\"plan.characteristics.refresh\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                        Reinicio de productos\n" +
    "                    </p>\n" +
    "                    <p ng-if=\"!plan.characteristics.refresh\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-close\" class=\"md-warn\"></md-icon>\n" +
    "                        Sin reinicio de productos\n" +
    "                    </p>\n" +
    "            </div>\n" +
    "            <div class=\"plan__action\">\n" +
    "                <md-button class=\"md-raised\" ng-click=\"vm.buy(plan)\" ng-class=\"{'md-primary': $index!==1, 'md-accent': $index===1}\">\n" +
    "                    Comprar ahora!\n" +
    "                </md-button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<!-- <div class=\"plans\" layout=\"row\" layout-wrap flex=\"100\" layout-align=\"center\">\n" +
    "    <div class=\"plans__description\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"center\" layout-padding>\n" +
    "        <h3 flex=\"100\" class=\"md-display-1\">Planes adaptados para individuos y negocios</h3>\n" +
    "        <p hide-xs hide-sm flex=\"80\" class=\"md-body\">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute\n" +
    "            irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n" +
    "    </div>\n" +
    "    <section layout=\"row\" layout-align=\"center start\" layout-wrap>\n" +
    "        <md-card class=\"plan__detail\" ng-class=\"{'plan__detail--recomended':plan.recommended}\" flex-sm=\"80\" flex-xs=\"80\" ng-repeat=\"plan in model.plans\">\n" +
    "            <md-card-title>\n" +
    "                <md-card-title-text>\n" +
    "                    <span class=\"md-subhead md-primary\">{{plan.name}}</span>\n" +
    "                    <span class=\"md-display-1\">{{plan.price | currency: 'RD$':2}}\n" +
    "                    </span>\n" +
    "                    <small class=\"md-caption\">mensual</small>\n" +
    "                </md-card-title-text>\n" +
    "            </md-card-title>\n" +
    "            <md-card-content>\n" +
    "                <p>\n" +
    "                    Hasta {{plan.characteristics.post}} anuncios\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{plan.characteristics.images}} fotos por anuncio\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{plan.characteristics.days}} días para vender\n" +
    "                </p>\n" +
    "                <p ng-class=\"{'plan__detail--strike':!plan.characteristics.store}\">\n" +
    "                    Tu tienda\n" +
    "                </p>\n" +
    "                <p ng-class=\"{'plan__detail--strike':!plan.characteristics.html}\">\n" +
    "                    HTML\n" +
    "                </p>\n" +
    "\n" +
    "            </md-card-content>\n" +
    "            <md-card-action layout-align=\"center\" layout=\"row\">\n" +
    "                <md-button ng-if=\"plan.price > 0\" class=\"md-raised md-primary\">Comprar</md-button>\n" +
    "            </md-card-action>\n" +
    "        </md-card>\n" +
    "    </section>\n" +
    "</div> -->");
}]);

angular.module("main/post/create/add.picture.panel.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/create/add.picture.panel.tpl.html",
    "<div class=\"post-create__add-picture\" layout=\"column\">\n" +
    "  <md-toolbar>\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button go-back class=\"toolbar__back-button\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <h3>Fotografia de tu producto</h3>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content flex layout-padding layout=\"column\" layout-align=\"end center\">\n" +
    "    <p>Los productos con imágenes se venden más rápido</p>\n" +
    "    <div class=\"post-create__buttons\">\n" +
    "      <md-button ngf-select ngf-multiple=\"true\" ngf-change=\"vm.choosePicture(vm.files)\" ng-model=\"vm.files\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\" class=\"md-raised md-accent md-large\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n" +
    "        Agregar Foto\n" +
    "      </md-button>\n" +
    "      <md-button class=\"md-large post-create__skip-picture\" ng-click=\"vm.choosePicture()\" >\n" +
    "        Continuar sin fotos\n" +
    "        <span class=\"small_text\">(no recomendado)</span>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/create/ask.authenticate.dialog/ask.for.authentication.dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/create/ask.authenticate.dialog/ask.for.authentication.dialog.tpl.html",
    "<md-dialog class=\"ask-for-authentication-dialog\">\n" +
    "    <md-dialog-content class=\"md-dialog-content\">\n" +
    "        <h2 class=\"md-title\">¿Tienes Cuenta en eMarket?\n" +
    "        </h2>\n" +
    "        <div class=\"md-dialog-content-body\">\n" +
    "            <p>Para poder publicar tu producto debes decirnos quien eres</p>\n" +
    "        </div>\n" +
    "    </md-dialog-content>\n" +
    "    <md-dialog-actions>\n" +
    "        <md-button ng-click=\"vm.close()\">Cancelar</md-button>\n" +
    "        <span flex></span>\n" +
    "        <md-button class=\"md-primary\" ui-sref=\"signup\">Quiero registrarme</md-button>\n" +
    "        <md-button class=\"md-primary\" ui-sref=\"auth\">Si tengo cuenta</md-button>\n" +
    "    </md-dialog-actions>\n" +
    "</md-dialog>");
}]);

angular.module("main/post/create/create-desktop.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/create/create-desktop.tpl.html",
    "<div class=\"post__create\" layout=\"row\" flex layout-align=\"center\" layout-wrap>\n" +
    "  <form class=\"post__create-form\" name=\"createPostForm\" novalidate ng-submit=\"model.showErrors=true; model.showCustomError=true; model.create(createPostForm)\"\n" +
    "    focus-input-invalid flex-gt-sm=\"60\" flex=\"100\" layout=\"row\" layout-wrap>\n" +
    "    <h3 class=\"em-title\" flex=\"100\">Publicación de Producto</h3>\n" +
    "    <div class=\"box-item\" flex=\"100\">\n" +
    "      <div class=\"numeric-title\">\n" +
    "        <div class=\"numeric-title__number\">\n" +
    "          <p class=\"number\">1</p>\n" +
    "        </div>\n" +
    "        <div class=\"numeric-title__text\">\n" +
    "          <h4>Selección de imagen</h4>\n" +
    "          <p>Click sobre la foto que deseas como imagen principal</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"post__create__images post__create__images--desktop\" layout=\"row\" flex=\"100\">\n" +
    "\n" +
    "        <div class=\"images__add\" ngf-select ngf-multiple=\"true\" ngf-change=\"model.saveFiles(model.files)\" ng-model=\"model.files\"\n" +
    "          ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n" +
    "          <p>Foto</p>\n" +
    "        </div>\n" +
    "        <div class=\"images__container\" ng-class=\"{'image__pending':image.pending, 'images__container--main': image.isMain}\" ng-repeat=\"image in model.post.images\">\n" +
    "          <div ng-if=\"!image.loading && !image.pending\">\n" +
    "            <md-button class=\"md-icon-button md-raised md-small image__delete-btn\" ng-click=\"model.deleteFile(image, $index)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "            </md-button>\n" +
    "            <img em-src-image=\"image\" square hide-xs hide-sm alt=\"\">\n" +
    "            <img em-src-image=\"image\" thumbnail hide-gt-sm alt=\"\">\n" +
    "            <md-button hide-xs hide-sm ng-click=\"model.setMainImage($index)\" ng-show=\"!image.isMain\" class=\"image__main-btn md-small md-raised\">Marcar Principal</md-button>\n" +
    "            <p hide-xs hide-sm ng-show=\"image.isMain\" class=\"main__image__text\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>Es Principal</p>\n" +
    "          </div>\n" +
    "          <div class=\"image__progress\" ng-if=\"image.loading\">\n" +
    "            <md-progress-circular md-diameter=\"{{model.progressDiameter}}\" md-mode=\"{{image.progress >= 95 ? 'indeterminate' :'determinate'}}\"\n" +
    "              value=\"{{image.progress}}\"></md-progress-circular>\n" +
    "            <p hide-xs hide-sm class=\"md-subhead\">Cargando Imagen...</p>\n" +
    "          </div>\n" +
    "          <div ng-if=\"image.pending\" class=\"image__pending__container\">\n" +
    "            <md-button class=\"md-icon-button md-raised md-small image__delete-btn\" ng-click=\"model.deleteFile(image, $index)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "            </md-button>\n" +
    "            <img em-src-image=\"model.getFileByIndex($index)\" thumbnail />\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <p hide-gt-sm class=\"post__create__images__hint\">Presiona sobre la foto que deseas como imagen principal</p>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"box-item box-item__left\" flex=\"50\" layout=\"column\">\n" +
    "      <div class=\"numeric-title\">\n" +
    "        <div class=\"numeric-title__number\">\n" +
    "          <p class=\"number\">2</p>\n" +
    "        </div>\n" +
    "        <div class=\"numeric-title__text\">\n" +
    "          <h4>Detalles del producto</h4>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"input-wrappers\" layout=\"row\" layout-wrap>\n" +
    "        <md-input-container flex=\"100\" class=\"clasic-input title \" ng-class=\"{suggested__input: model.suggestion.term}\" flex=\"100\">\n" +
    "          <label class=\"md-subhead\">Título del anuncio</label>\n" +
    "          <input ng-model=\"model.post.title\" required name=\"title\" ng-blur=\"model.suggestion.check()\" />\n" +
    "          <div ng-messages=\"createPostForm.title.$error\">\n" +
    "            <div ng-message=\"required\">No olvides el titulo de tu anuncio</div>\n" +
    "          </div>\n" +
    "          <div class=\"md-erros-spacer\" ng-hide=\"createPostForm.title.$touched && createPostForm.title.$invalid\" ng-show=\"!model.suggestion.term\">\n" +
    "            <div class=\"md-char-counter\">Usa palabras que describan brevemente y de manera simple tu artículo o servicio para que sea fácil de encontrar</div>\n" +
    "          </div>\n" +
    "          <div flex=\"100\" class=\"hint hint--suggestion\" ng-click=\"model.suggestion.accept()\" ng-hide=\"createPostForm.title.$invalid || !model.suggestion.term\">¿Quisiste decir:\n" +
    "            <span>{{model.suggestion.term}}</span> ?</div>\n" +
    "        </md-input-container>\n" +
    "\n" +
    "        <md-input-container flex=\"100\" class=\"clasic-input fake-input category__chooser\" flex=\"100\">\n" +
    "          <label class=\"md-subhead\">Categoria</label>\n" +
    "          <input ng-focus=\"model.showCategoryDialog()\" type=\"text\" ng-model=\"model.post.categorySlug\" class=\"dummy-input\">\n" +
    "          <md-button ng-click=\"model.showCategoryDialog()\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n" +
    "          </md-button>\n" +
    "          <p ng-show=\"!model.post.category && model.showErrors\" class=\"hint hint--error\">No olvides completar la categoria</p>\n" +
    "        </md-input-container>\n" +
    "        <div class=\"post__create__price\" layout=\"row\" flex=\"100\">\n" +
    "          <md-input-container class=\"clasic-input\">\n" +
    "            <label class=\"md-subhead\">Moneda</label>\n" +
    "            <md-select name=\"currency\" required ng-model=\"model.post.currency\">\n" +
    "              <md-option ng-selected=\"$first\" ng-repeat=\"currency in model.currencies\" ng-value=\"currency._id\">{{currency.symbol}}</md-option>\n" +
    "            </md-select>\n" +
    "            <div ng-messages=\"createPostForm.currency.$error\">\n" +
    "              <div ng-message=\"required\">Debes de escoger la moneda</div>\n" +
    "            </div>\n" +
    "          </md-input-container>\n" +
    "          <md-input-container class=\"clasic-input\" flex>\n" +
    "            <label class=\"md-subhead\">Precio</label>\n" +
    "            <input type=\"number\" ng-model=\"model.post.prices.list\" name=\"price\" required>\n" +
    "            <div ng-messages=\"createPostForm.price.$error\">\n" +
    "              <div ng-message=\"required\">\n" +
    "                {{media.gtsm ? 'El precio es importante para el producto, no olvides agregarlo' : 'No olvides el precio'}}</div>\n" +
    "            </div>\n" +
    "            <div class=\"md-erros-spacer\" ng-hide=\"createPostForm.price.$touched && createPostForm.price.$invalid\">\n" +
    "              <div class=\"md-char-counter\">Coloca un precio que sea realista pero que también sea atractivo.</div>\n" +
    "            </div>\n" +
    "          </md-input-container>\n" +
    "          <!-- <md-checkbox flex flex-xs=\"100\" flex-sm=\"100\" class=\"post__create__negotiable_price\" ng-model=\"model.post.isNegotiable\">El precio es negociable</md-checkbox> -->\n" +
    "        </div>\n" +
    "        <md-input-container ng-if=\"!model.user || !model.user.plan.product.characteristics.html\" flex=\"100\" class=\"clasic-input\"\n" +
    "          flex=\"100\">\n" +
    "          <label class=\"md-subhead\">Contenido</label>\n" +
    "          <textarea name=\"content\" rows=\"10\" required ng-model=\"model.post.content\"></textarea>\n" +
    "          <div ng-messages=\"createPostForm.content.$error\">\n" +
    "            <div ng-message=\"required\">Debes de agregar algún contenido en el producto</div>\n" +
    "          </div>\n" +
    "          <div class=\"md-erros-spacer\" ng-hide=\"createPostForm.content.$touched && createPostForm.content.$invalid\">\n" +
    "            <div class=\"md-char-counter\">Agrega la mayor cantidad de detalles de tu producto o servicio y que cada detalle sea preciso y veráz. Esto aumentará\n" +
    "              las posibilidades de venta.</div>\n" +
    "          </div>\n" +
    "        </md-input-container>\n" +
    "\n" +
    "        <div ng-if=\"model.user.plan.product.characteristics.html\" flex=\"100\" class=\"clasic-input\" flex=\"100\">\n" +
    "          <label class=\"md-subhead\">Contenido</label>\n" +
    "          <textarea html-editor=\"model.post.content\" name=\"content\" rows=\"5\" required></textarea>\n" +
    "          <div ng-messages=\"createPostForm.content.$error\">\n" +
    "            <div ng-message=\"required\">Debes de agregar algún contenido en el producto</div>\n" +
    "          </div>\n" +
    "          <div class=\"md-erros-spacer\" ng-hide=\"createPostForm.content.$touched && createPostForm.content.$invalid\">\n" +
    "            <div class=\"md-char-counter\">Agrega la mayor cantidad de detalles de tu producto o servicio y que cada detalle sea preciso y veráz. Esto aumentará\n" +
    "              las posibilidades de venta.</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"box-item box-item__right\" flex=\"50\" layout=\"column\">\n" +
    "      <div class=\"numeric-title\">\n" +
    "        <div class=\"numeric-title__number\">\n" +
    "          <p class=\"number\">3</p>\n" +
    "        </div>\n" +
    "        <div class=\"numeric-title__text\">\n" +
    "          <h4>Condiciones & ubicación</h4>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"input-wrappers\">\n" +
    "        <md-input-container flex=\"100\" class=\"clasic-input place\">\n" +
    "          <label class=\"md-subhead\">Lugar en que te encuentras</label>\n" +
    "          <md-select required name=\"province\" ng-model=\"model.post.province\">\n" +
    "            <md-option ng-repeat=\"province in model.provinces\" ng-value=\"province._id\">{{province.name}}</md-option>\n" +
    "          </md-select>\n" +
    "          <div ng-messages=\"createPostForm.province.$error\">\n" +
    "            <div ng-message=\"required\">No olvides la provincia</div>\n" +
    "          </div>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container flex=\"100\">\n" +
    "          <p class=\"em-label\" flex=\"100\">Condición</p>\n" +
    "          <em-radio-button small flex=\"100\" elements=\"model.conditions\" translate=\"true\" model=\"model.post.condition\"></em-radio-button>\n" +
    "          <div flex=\"100\" class=\"hint hint--error\" ng-show=\"!model.post.condition && model.showErrors\">Debes de escojer el estado del producto</div>\n" +
    "        </md-input-container>\n" +
    "        <custom-field-container edit=\"true\" flex=\"100\" ng-model=\"model.post.custom\" fields=\"model.customFields\" ng-if=\"model.customFields\"></custom-field-container>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"post__create__publish-btn__container\" flex=\"100\">\n" +
    "      <md-button type=\"submit\" class=\"md-raised md-accent post__create__publish-btn md-big\">\n" +
    "\n" +
    "        <span ng-if=\"!model.post._id\">Publicar Producto</span>\n" +
    "        <span ng-if=\"model.post._id\">Guardar Cambios</span>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("main/post/create/create-mobile.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/create/create-mobile.tpl.html",
    "<div class=\"post__create\" layout=\"row\" flex layout-align=\"center\">\n" +
    "  <md-toolbar hide-gt-sm class=\"md-toolbar--simple\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h3 flex>Creación de Producto</h3>\n" +
    "      <md-button class=\"md-icon-button\" ui-sref=\"main.home\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <form class=\"post__create-form\" name=\"createPostForm\" novalidate ng-submit=\"model.showErrors=true; model.showCustomError=true; model.create(createPostForm)\" focus-input-invalid flex-gt-sm=\"60\" flex=\"100\" layout=\"row\" layout-wrap>\n" +
    "    <h3 flex=\"100\" class=\"em-title\" hide-xs hide-sm>Publicación de Producto</h3>\n" +
    "    <div class=\"input-containers\" flex=\"100\" layout=\"row\" layout-wrap>\n" +
    "      <md-input-container flex=\"100\" class=\"clasic-input title \" ng-class=\"{suggested__input: model.suggestion.term}\" flex=\"100\">\n" +
    "        <label class=\"md-subhead\">Título del anuncio</label>\n" +
    "        <input ng-model=\"model.post.title\" required name=\"title\" ng-blur=\"model.suggestion.check()\"/>\n" +
    "        <div ng-messages=\"createPostForm.title.$error\">\n" +
    "          <div ng-message=\"required\">No olvides el titulo de tu anuncio</div>\n" +
    "        </div>\n" +
    "        <div hide-sm hide-xs ng-hide=\"createPostForm.title.$touched && createPostForm.title.$invalid\" ng-show=\"!model.suggestion.term\" class=\"hint\">Usa palabras que describan brevemente y de manera simple tu artículo o servicio para que sea fácil de encontrar</div>\n" +
    "\n" +
    "        <div flex=\"100\" class=\"hint hint--suggestion\" ng-click=\"model.suggestion.accept()\" ng-hide=\"createPostForm.title.$invalid || !model.suggestion.term\">¿Quisiste decir: <span>{{model.suggestion.term}}</span> ?</div>\n" +
    "      </md-input-container>\n" +
    "      <md-input-container flex=\"100\" class=\"clasic-input fake-input category__chooser\" flex=\"100\">\n" +
    "        <label class=\"md-subhead\">Categoria</label>\n" +
    "        <input ng-focus=\"model.showCategoryDialog()\" type=\"text\" ng-model=\"model.post.categorySlug\" class=\"dummy-input\">\n" +
    "        <md-button ng-click=\"model.showCategoryDialog()\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <p ng-show=\"!model.post.category && model.showErrors\" class=\"hint hint--error\">No olvides completar la categoria</p>\n" +
    "      </md-input-container>\n" +
    "      <md-input-container ng-if=\"!model.user || model.user.plan.product.price === 0\"  flex=\"100\" class=\"clasic-input\" flex=\"100\">\n" +
    "        <label class=\"md-subhead\">Contenido</label>\n" +
    "        <textarea name=\"content\" rows=\"5\" required ng-model=\"model.post.content\"></textarea>\n" +
    "        <div ng-messages=\"createPostForm.content.$error\">\n" +
    "          <div ng-message=\"required\">Debes de agregar algún contenido en el anuncio</div>\n" +
    "        </div>\n" +
    "        <div hide-sm hide-xs ng-hide=\"createPostForm.content.$touched && createPostForm.content.$invalid\" class=\"hint\">Agrega la mayor cantidad de detalles de tu producto o servicio y que cada detalle sea preciso y veráz. Esto aumentará las posibilidades de venta.</div>\n" +
    "      </md-input-container>\n" +
    "      <div flex=\"100\" class=\"clasic-input\" ng-if=\"model.user.plan.product.price > 0\">\n" +
    "        <label class=\"md-subhead\">Contenido</label>\n" +
    "        <textarea html-editor=\"model.post.content\" name=\"content\" rows=\"5\" required ng-model=\"model.post.content\"></textarea>\n" +
    "        <div ng-messages=\"createPostForm.content.$error\">\n" +
    "          <div ng-message=\"required\">Debes de agregar algún contenido en el anuncio</div>\n" +
    "        </div>\n" +
    "        <div hide-sm hide-xs ng-hide=\"createPostForm.content.$touched && createPostForm.content.$invalid\" class=\"hint\">Agrega la mayor cantidad de detalles de tu producto o servicio y que cada detalle sea preciso y veráz. Esto aumentará las posibilidades de venta.</div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"post__create__price\" layout=\"row\" flex=\"100\">\n" +
    "        <md-input-container class=\"clasic-input\">\n" +
    "          <label class=\"md-subhead\">Moneda</label>\n" +
    "          <md-select name=\"currency\" required ng-model=\"model.post.currency\">\n" +
    "            <md-option ng-selected=\"$first\" ng-repeat=\"currency in model.currencies\" ng-value=\"currency._id\">{{currency.symbol}}</md-option>\n" +
    "          </md-select>\n" +
    "          <div ng-messages=\"createPostForm.currency.$error\">\n" +
    "            <div ng-message=\"required\">Debes de escoger la moneda</div>\n" +
    "          </div>\n" +
    "        </md-input-container>\n" +
    "        <md-input-container class=\"clasic-input\" flex>\n" +
    "          <label class=\"md-subhead\">Precio</label>\n" +
    "          <input type=\"number\" ng-model=\"model.post.prices.list\" name=\"price\" required>\n" +
    "          <div ng-messages=\"createPostForm.price.$error\">\n" +
    "            <div ng-message=\"required\">\n" +
    "              {{media.gtsm ? 'El precio es importante para el producto, no olvides agregarlo' : 'No olvides el precio'}}</div>\n" +
    "          </div>\n" +
    "          <div hide-sm hide-xs ng-hide=\"createPostForm.content.$touched && createPostForm.content.$invalid\" class=\"hint\">Coloca un precio que sea realista pero que también sea atractivo.</div>\n" +
    "        </md-input-container>\n" +
    "        <md-checkbox flex flex-xs=\"100\" flex-sm=\"100\" class=\"post__create__negotiable_price\" ng-model=\"model.post.isNegotiable\">El precio es negociable</md-checkbox>\n" +
    "      </div>\n" +
    "      <md-input-container flex=\"100\" class=\"clasic-input place\">\n" +
    "        <label class=\"md-subhead\">Lugar en que te encuentras</label>\n" +
    "        <md-select required name=\"province\" ng-model=\"model.post.province\">\n" +
    "          <md-option ng-repeat=\"province in model.provinces\" ng-value=\"province._id\">{{province.name}}</md-option>\n" +
    "        </md-select>\n" +
    "        <div ng-messages=\"createPostForm.province.$error\">\n" +
    "          <div ng-message=\"required\">No olvides la provincia</div>\n" +
    "        </div>\n" +
    "      </md-input-container>\n" +
    "      <md-input-container flex=\"100\">\n" +
    "        <p class=\"em-label\" flex=\"100\">Condición</p>\n" +
    "        <em-radio-button small flex=\"100\" elements=\"model.conditions\" translate=\"true\" model=\"model.post.condition\"></em-radio-button>\n" +
    "        <div flex=\"100\" class=\"hint hint--error\" ng-show=\"!model.post.condition && model.showErrors\">Debes de escojer el estado del producto</div>\n" +
    "      </md-input-container>\n" +
    "    </div>\n" +
    "    <div class=\"post__create__images\" layout=\"row\" flex=\"100\">\n" +
    "      <div class=\"images__add\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-image\"></md-icon>\n" +
    "        <md-button ngf-select ngf-multiple=\"true\" ngf-change=\"model.saveFiles(model.files)\" ng-model=\"model.files\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\" class=\"md-raised md-primary\">Agregar imagen</md-button>\n" +
    "      </div>\n" +
    "      <div hide-gt-sm class=\"images__add images__add--mobile\" ngf-select ngf-multiple=\"true\" ngf-change=\"model.saveFiles(model.files)\" ng-model=\"model.files\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n" +
    "        <p>Foto</p>\n" +
    "      </div>\n" +
    "      <div class=\"images__container\" ng-class=\"{'image__pending':image.pending, 'images__container--main': image.isMain}\" ng-repeat=\"image in model.post.images\">\n" +
    "        <div ng-if=\"!image.loading && !image.pending\">\n" +
    "          <md-button class=\"md-icon-button md-raised md-small image__delete-btn\" ng-click=\"model.deleteFile(image, $index)\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "          </md-button>\n" +
    "          <img em-src-image=\"image\" square hide-xs hide-sm alt=\"\">\n" +
    "          <img em-src-image=\"image\" thumbnail hide-gt-sm alt=\"\">\n" +
    "          <md-button hide-xs hide-sm ng-click=\"model.setMainImage($index)\" ng-show=\"!image.isMain\" class=\"image__main-btn md-small md-raised\">Marcar Principal</md-button>\n" +
    "          <p hide-xs hide-sm ng-show=\"image.isMain\" class=\"main__image__text\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>Es Principal</p>\n" +
    "        </div>\n" +
    "        <div class=\"image__progress\" ng-if=\"image.loading\">\n" +
    "          <md-progress-circular md-diameter=\"{{model.progressDiameter}}\" md-mode=\"{{image.progress >= 95 ? 'indeterminate' :'determinate'}}\" value=\"{{image.progress}}\"></md-progress-circular>\n" +
    "          <p hide-xs hide-sm class=\"md-subhead\">Cargando Imagen...</p>\n" +
    "        </div>\n" +
    "        <div ng-if=\"image.pending\" class=\"image__pending__container\">\n" +
    "          <md-button class=\"md-icon-button md-raised md-small image__delete-btn\" ng-click=\"model.deleteFile(image, $index)\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "          </md-button>\n" +
    "          <img em-src-image=\"model.getFileByIndex($index)\" thumbnail />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <p hide-gt-sm class=\"post__create__images__hint\">Presiona sobre la foto que deseas como imagen principal</p>\n" +
    "\n" +
    "    </div>\n" +
    "    <div class=\"post__create__publish-btn__container\">\n" +
    "      <md-button type=\"submit\" class=\"md-raised md-accent post__create__publish-btn\">Publicar producto\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "  <div flex=\"20\" class=\"tips\" hide-sm hide-xs>\n" +
    "    <h4 class=\"em-subtitle\">Politicas de seguridad</h4>\n" +
    "    <p>\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>No esta permitido la publicación de más de un producto con el mismo titulo y contenido por una misma persona.</p>\n" +
    "    <p>\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>No se permite la colocación de productos en categorías que no correspondan al contenido del mismo.</p>\n" +
    "    <p>\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>No se permiten productos de promoción de websites.</p>\n" +
    "    <p>\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>El título del producto debe describir UN SOLO tipo de articulo o servicio.</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/create/success.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/create/success.tpl.html",
    "<div layout=\"row\" layout-align=\"center\" hide-sm hide-xs>\n" +
    "    <md-card flex=\"100\" flex-gt-sm=\"80\">\n" +
    "        <md-card-content>\n" +
    "            <h3 class=\"md-display-2\">Producto Guardado</h3>\n" +
    "            <p>Su producto ha sido publicado satisfactoriamente</p>\n" +
    "            <small class=\"md-subhead\">¿Que puedo hacer ahora?</small>\n" +
    "            <div class=\"\" layout=\"row\">\n" +
    "                <md-button flex class=\"md-raised md-primary\" ui-sref=\"main.home\">Ir a la Portada</md-button>\n" +
    "                <md-button flex class=\"md-raised md-primary\" ui-sref=\"main.profile.products\">Ir a Mis Productos</md-button>\n" +
    "                <md-button flex class=\"md-raised md-primary\" ui-sref=\"main.post.detail({title:model.id})\">Ver Productos</md-button>\n" +
    "                <md-button flex class=\"md-raised md-primary\">Editar Productos</md-button>\n" +
    "                <md-button flex class=\"md-raised md-primary\" ui-sref=\"main.post.create\">Publicar Otro</md-button>\n" +
    "            </div>\n" +
    "        </md-card-content>\n" +
    "    </md-card>\n" +
    "</div>\n" +
    "<div hide-gt-sm class=\"post__create__success\" layout=\"column\">\n" +
    "  <div class=\"post__create__success-image\"></div>\n" +
    "  <div class=\"post__create__success-text\" flex>\n" +
    "    <img src=\"../assets/circle-check.png\" alt=\"\">\n" +
    "    <p>Tu producto ha sido publicado exitosamente!</p>\n" +
    "  </div>\n" +
    "  <md-button ui-sref=\"main.home\" ui-sref-opt=\"{location:'replace'}\" class=\"md-accent md-raised md-large\">Continuar</md-button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/detail.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail.tpl.html",
    "<div class=\"product-detail\" layout-padding layout=\"row\" flex=\"100\" layout-wrap layout-align=\"start start\">\n" +
    "	<div class=\"images\" flex=\"40\">\n" +
    "		<img style=\"width:100%; max-height:400px\" src=\"http://placehold.it/420x444\" alt=\"\">\n" +
    "	</div>\n" +
    "	<div class=\"details\" flex=\"40\">\n" +
    "		<h2>El titulo del anuncio pero con solo 100 caracteres de acuerdo a los estandares de calidad de la empr</h2>\n" +
    "	</div>\n" +
    "	<div class=\"seller-profile\" flex=\"20\"></div>\n" +
    "</div>");
}]);

angular.module("main/post/detail/detail.panel.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/detail.panel.tpl.html",
    "<div class=\"post-detail__panel\">\n" +
    "  <md-toolbar>\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button class=\"return-btn\" go-back>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <img class=\"logo\" src=\"assets/logo-slogan-white.png\">\n" +
    "      <span flex></span>\n" +
    "      <md-button class=\"md-icon-button\" ng-disabled=\"model.disablePrev\" ng-click=\"model.prev()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <md-button class=\"md-icon-button\" ng-disabled=\"model.disableNext\" ng-click=\"model.next()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content ng-include=\"'main/post/detail/detail.tpl.html'\">\n" +
    "\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/detail/detail.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/detail.tpl.html",
    "<div ng-if=\"model.showNavBar\" class=\"navigation\" ng-controller=\"NavigationController as model\" ng-include=\"model.navigationTemplate\">\n" +
    "\n" +
    "</div>\n" +
    "<div class=\"post-detail\" layout=\"row\" layout-wrap>\n" +
    "    <div class=\"post-detail__container gray-container\" layout=\"row\" layout-align=\"center start\" flex=\"100\">\n" +
    "        <div flex-md=\"95\" flex-gt-md=\"80\" flex=\"95\">\n" +
    "            <div class=\"post-detail__breadcrumb\">\n" +
    "                <md-button href go-back class=\"breadcrumb__return\">\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>Regresar</md-button>\n" +
    "                <p>Estan en:\n" +
    "                    <a ui-sref=\"main.post.search({categoria:category.slug})\" ng-repeat-start=\"category in model.post.categoryTree\">{{category.name}}</a>\n" +
    "                    <span ng-repeat-end> / </span>\n" +
    "                    <span>{{model.post.title}}</span>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "            <div class=\"post-detail__header\" layout=\"row\">\n" +
    "                <div class=\"post-detail__pictures\" slider=\"model.post\" ng-if=\"model.post.images && model.post.images.length > 0\" large-slider=\"!model.isMobile ? model.post.images : null\">\n" +
    "                    <div class=\"pictures__main\">\n" +
    "                        <div class=\"z-slide-item\" ng-repeat=\"image in model.post.images\">\n" +
    "                            <img class=\"z-slide-open-large\" em-src-image=\"image\" square alt=\"\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-show=\"model.post.images.length > 1\" class=\"pictures__thumbnails z-slide-thumbnails\" layout=\"row\">\n" +
    "                        <img data-image-id=\"{{$index}}\" ng-repeat=\"image in model.post.images\" em-src-image=\"image\" thumbnail alt=\"\" />\n" +
    "                    </div>\n" +
    "                    <div class=\"z-slide-arrows\" ng-show=\"model.post.images.length > 1\">\n" +
    "                        <md-button class=\"md-icon-button\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "                        </md-button>\n" +
    "                        <md-button class=\"md-icon-button\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "                        </md-button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"post-detail__pictures\" ng-show=\"!model.post.images || model.post.images.length === 0\">\n" +
    "                    <div class=\"pictures__main\">\n" +
    "                        <div class=\"z-slide-item\">\n" +
    "                            <img src=\"assets/noimagefound.jpg\" alt=\"\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"post-detail__info\" flex flex-xs=\"100\" flex-sm=\"100\" layout=\"column\">\n" +
    "                    <p class=\"post-detail__publish-at\" hide-xs hide-sm>\n" +
    "                        Publicado\n" +
    "                        <span>\n" +
    "                            <span duration=\"model.post.resetAt\">{{model.post.resetAt}}</span>\n" +
    "                            <md-tooltip md-delay=\"500\">{{model.post.resetAt | date:'medium'}}</md-tooltip>\n" +
    "                        </span>\n" +
    "                        <md-button class=\"md-warn md-small\" ng-click=\"model.reportPost()\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon>\n" +
    "                            Denunciar producto</md-button>\n" +
    "\n" +
    "                    </p>\n" +
    "                    <p class=\"post-detail__title\">{{model.post.title}}</p>\n" +
    "                    <p class=\"post-detail__condition\" hide-sm hide-xs>\n" +
    "                        <strong>Condición:</strong> {{model.post.condition | translate}}\n" +
    "                        <span flex hide-gt-sm></span>\n" +
    "                        <span hide-gt-sm>\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "                            <span duration=\"model.post.resetAt\"></span>\n" +
    "                            <md-tooltip md-delay=\"500\">{{model.post.resetAt | date:'medium'}}</md-tooltip>\n" +
    "                        </span>\n" +
    "                    </p>\n" +
    "                    <p class=\"post-detail__condition\" hide-gt-sm>\n" +
    "                        <span class=\"post-condition {{model.post.condition}}\">{{model.post.condition | translate}}</span>\n" +
    "                        <span class=\"separator\">|</span>\n" +
    "                        <span>{{model.post.province.name}}</span>\n" +
    "                        <span flex hide-gt-sm></span>\n" +
    "                        <span class=\"duration\" hide-gt-sm>\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "                            <span duration=\"model.post.resetAt\"></span>\n" +
    "                            <md-tooltip md-delay=\"500\">{{model.post.resetAt | date:'medium'}}</md-tooltip>\n" +
    "                        </span>\n" +
    "                    </p>\n" +
    "                    <p class=\"post-detail__condition\" hide-sm hide-xs>\n" +
    "                        <strong>Lugar:</strong> {{model.post.province.name}}\n" +
    "                    </p>\n" +
    "                    <div class=\"post-detail__price-block\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "                        <p class=\"price\">{{model.post.prices.list | currency:model.post.currency.symbol:2}}</p>\n" +
    "                        <div class=\"post-detail__share\" layout=\"row\">\n" +
    "                            <div hide-xs hide-sm class=\"post-detail__share--favorite\" ng-class=\"{'in-favorite': model.favoritePost}\">\n" +
    "                                <md-button ng-click=\"model.handleFavoritePost()\" class=\"md-icon-button favorite-btn\" ng-class=\"{'md-favorite': model.favoritePost}\">\n" +
    "                                    <md-icon md-font-icon=\"zmdi zmdi-star-outline\" ng-if=\"!model.favoritePost\"></md-icon>\n" +
    "                                    <md-icon md-font-icon=\"zmdi zmdi-star\" ng-if=\"model.favoritePost\"></md-icon>\n" +
    "                                    <md-tooltip md-delay=\"500\">\n" +
    "                                        <span ng-if=\"!model.favoritePost\">\n" +
    "                                            Agregar a Favoritos\n" +
    "                                        </span>\n" +
    "                                        <span ng-if=\"model.favoritePost\">\n" +
    "                                            Eliminar de favoritos\n" +
    "                                        </span>\n" +
    "                                    </md-tooltip>\n" +
    "                                </md-button>\n" +
    "                                <p>Favorito</p>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"vertical-divider\"></div>\n" +
    "                            <div class=\"post-detail__share--buttons\" hide-xs hide-sm>\n" +
    "                                <p>Compartir</p>\n" +
    "                                <md-button ng-click=\"model.fbShare()\" class=\"md-icon-button md-primary md-facebook\">\n" +
    "                                    <md-icon md-font-icon=\"zmdi zmdi-facebook-box\"></md-icon>\n" +
    "                                    <md-tooltip md-delay=\"500\">\n" +
    "                                        Compartir en Facebook\n" +
    "                                    </md-tooltip>\n" +
    "                                </md-button>\n" +
    "                                <md-button ng-click=\"model.twShare()\" class=\"md-icon-button md-primary md-twitter\">\n" +
    "                                    <md-icon md-font-icon=\"zmdi zmdi-twitter-box\"></md-icon>\n" +
    "                                    <md-tooltip md-delay=\"500\">\n" +
    "                                        Compartir en Twitter\n" +
    "                                    </md-tooltip>\n" +
    "                                </md-button>\n" +
    "\n" +
    "                                <!-- <md-button hide-xs hide-sm ng-click=\"model.gpShare()\" class=\"md-icon-button md-primary\">\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-google-plus-box\"></md-icon>\n" +
    "                            </md-button> -->\n" +
    "                                <a socialshare socialshare-provider=\"whatsapp\" socialshare-url=\"{{model.socialshareUrl}}\" socialshare-text=\"{{model.post.title + ' '}}\"\n" +
    "                                    ng-click=\"model.whatsappShare()\" class=\"md-icon-button md-primary md-button md-whatsapp\">\n" +
    "                                    <md-icon md-font-icon=\"zmdi zmdi-whatsapp\"></md-icon>\n" +
    "                                    <md-tooltip md-delay=\"500\">\n" +
    "                                        Compartir en Whatsapp\n" +
    "                                    </md-tooltip>\n" +
    "                                </a>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"post-detail__actions\" layout=\"row\" layout-align=\"space-between start\">\n" +
    "                        <div flex=\"100\" hide-gt-sm class=\"contact-button-wrapper\">\n" +
    "                            <md-button ng-disabled=\"model.isMy\" ng-click=\"model.showSellerContact($ev)\" class=\"md-accent md-raised contact-seller\">Contactar Vendedor</md-button>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <md-button hide-gt-sm class=\"md-primary no-hover favorite-btn\" ng-disabled=\"model.isMy\" ng-click=\"model.handleFavoritePost()\"\n" +
    "                            ng-class=\"{'md-favorite': model.favoritePost}\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-star-outline\" ng-hide=\"model.favoritePost\"></md-icon>\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-star\" ng-show=\"model.favoritePost\"></md-icon>\n" +
    "                            <span ng-hide=\"model.favoritePost\">Agregar favoritos</span>\n" +
    "                            <span ng-show=\"model.favoritePost\">Este producto esta en tus favoritos</span>\n" +
    "                            <md-tooltip ng-if=\"model.favoritePost\" md-delay=\"500\">\n" +
    "                                Click para remover de tus favoritos\n" +
    "                            </md-tooltip>\n" +
    "                        </md-button>\n" +
    "\n" +
    "                        <md-button class=\"md-primary favorite-btn\" hide-gt-sm ng-click=\"model.showShareSheet()\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-share\"></md-icon>\n" +
    "                            Compartir Producto\n" +
    "                        </md-button>\n" +
    "\n" +
    "                    </div>\n" +
    "                    <div class=\"post-detail__tips\" ng-hide=\"model.post.custom\">\n" +
    "                        <h4>Tips que debes tener en cuenta:</h4>\n" +
    "                        <ul>\n" +
    "                            <li>Solicita documento de identificación al vendedor.</li>\n" +
    "                            <li>Realiza en el cuentro en un lugar público.</li>\n" +
    "                            <li>Verifica que el equipo que compras funciona correctamente.</li>\n" +
    "                            <li>Manten el número de contacto del vendedor.</li>\n" +
    "                            <li>Nunca hagas un depósito sin tener tu equipo en mano.</li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                    <div class=\"post-detail__fields\" ng-show=\"model.post.custom\" layout=\"row\" layout-wrap>\n" +
    "\n" +
    "                        <div class=\"item\" layout=\"row\" ng-repeat=\"field in model.fields\" flex-xs=\"100\" flex-sm=\"100\">\n" +
    "                            <strong>{{field.name}}:</strong>\n" +
    "                            <span ng-show=\"field.showAs !== 'map'\">{{field.value}}</span>\n" +
    "                            <a href flex ng-show=\"field.showAs === 'map'\">Ver Mapa</a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div hide-xs hide-sm class=\"post-detail__seller\" flex=\"100\" ng-include=\"'main/post/detail/seller-info.tpl.html'\" flex-gt-sm=\"25\">\n" +
    "\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"post-detail__container post-detail__other-details\" layout=\"row\" layout-align=\"center start\" flex=\"100\">\n" +
    "        <div class=\"post-detail__content\" layout=\"column\" flex-md=\"95\" flex-gt-md=\"80\" flex=\"95\">\n" +
    "            <h3>Detalles del producto</h3>\n" +
    "            <div class=\"post-detail__content-container\" flex=\"100\" layout=\"row\">\n" +
    "\n" +
    "                <div class=\"post-detail__content-body\" layout=\"column\" flex>\n" +
    "                    <div class=\"post-detail__content-text\" ng-show=\"model.post.owner.plan.product.price === 0 && !model.post.isPremium\">\n" +
    "                        {{model.post.content}}\n" +
    "                    </div>\n" +
    "                    <div class=\"post-detail__content-text\" ng-show=\"model.post.owner.plan.product.price > 0 || model.post.isPremium\">\n" +
    "                        <preview content=\"model.post.content\"></preview>\n" +
    "                    </div>\n" +
    "                    <div hide-gt-sm class=\"post-detail__seller\" ng-include=\"'main/post/detail/seller-info.tpl.html'\">\n" +
    "\n" +
    "                    </div>\n" +
    "                    <md-divider hide-gt-sm></md-divider>\n" +
    "                    <div class=\"post-detail__more-products\" layout=\"column\">\n" +
    "                        <h3 class=\"headline\">Mas productos de este usuario</h3>\n" +
    "                        <div class=\"post-detail__more-products-wrapper\" layout=\"row\">\n" +
    "                            <em-product class=\"em-product-small__fixed\" ui-sref=\"main.post.detail({title:post._id})\" ng-repeat=\"post in model.relatedProducts\"\n" +
    "                                product=\"post\"></em-product>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"post-detail__content_banner\">\n" +
    "                    <em-banner size=\"160x600\" slot=\"'7514977611'\"></em-banner>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-if=\"model.showNavBar\" ng-include=\"'main/footer.tpl.html'\"></div>");
}]);

angular.module("main/post/detail/seller-contact-dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/seller-contact-dialog.tpl.html",
    "<md-dialog aria-label=\"Contacto del vendedor\" flex=\"30\">\n" +
    "    <md-toolbar>\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <h3>Contacto de {{model.seller.displayName}}</h3>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-dialog-content>\n" +
    "        <md-list flex>\n" +
    "            <md-list-item ng-click=\"null\" ng-repeat=\"contact in model.seller.phones\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-phone\" aria-label=\"Número Telefonico\"></md-icon>\n" +
    "                <p>{{contact.number | bcTelephone:'format'}}</p>\n" +
    "            </md-list-item>\n" +
    "        </md-list>\n" +
    "    </md-dialog-content>\n" +
    "    <md-dialog-actions>\n" +
    "        <md-button ng-click=\"model.showChatDialog()\" class=\"md-raised md-primary\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-email\" aria-label=\"Enviar Mensaje\"></md-icon>\n" +
    "            Enviar Mensaje</md-button>\n" +
    "        <span flex></span>\n" +
    "        <md-button ng-click=\"model.close()\">Cerrar</md-button>\n" +
    "    </md-dialog-actions>\n" +
    "</md-dialog>");
}]);

angular.module("main/post/detail/seller-contact.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/seller-contact.tpl.html",
    "<md-bottom-sheet class=\"seller-contact-sheet\">\n" +
    "  <md-subheader ng-cloak>Contactar a {{model.seller.displayName}}</md-subheader>\n" +
    "  <div class=\"warnings-container\" layout=\"row\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"md-warn\"></md-icon>\n" +
    "    <p>\n" +
    "      Nunca hagas depósitos por adelantado, haz tus transacciones en persona\n" +
    "    </p>\n" +
    "  </div>\n" +
    "  <md-list ng-cloak flex=\"100\">\n" +
    "    <md-list-item ng-click=\"model.hideSheet()\" ng-href=\"tel:{{contact.number}}\" ng-repeat=\"contact in model.seller.phones\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n" +
    "      <p>{{contact.number | bcTelephone:'format'}}</p>\n" +
    "    </md-list-item>\n" +
    "    <md-list-item ng-click=\"model.showChatDialog()\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n" +
    "      <p>Enviar Mensaje</p>\n" +
    "    </md-list-item>\n" +
    "  </md-list>\n" +
    "</md-bottom-sheet>");
}]);

angular.module("main/post/detail/seller-info.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/seller-info.tpl.html",
    "<md-card>\n" +
    "    <md-toolbar class=\"md-small\">\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <h3>\n" +
    "                <span>Información del </span>Vendedor</h3>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-card-content flex class=\"seller__profile\" layout-wrap layout=\"column\">\n" +
    "        <div class=\"seller__profile__detail\" layout=\"row\">\n" +
    "            <img em-src-image=\"model.post.owner.picture\" thumbnail class=\"md-avatar\" alt=\"\">\n" +
    "            <div class=\"seller__profile__detail-text\">\n" +
    "                <h3>{{model.post.owner.displayName}}</h3>\n" +
    "                <p>\n" +
    "                    <small>@{{model.post.owner.username}}</small>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"seller__profile-actions\" flex layout=\"column\" flex=\"100\">\n" +
    "            <md-button title=\"¿Quieres contactarte a ti mismo :)?\" ng-disabled=\"model.isMy\" ng-click=\"model.showSellerContact()\" class=\"md-accent md-raised\">\n" +
    "                Contactar Vendedor\n" +
    "                <md-tooltip md-delay=\"500\" ng-if=\"model.isMy\">\n" +
    "                    ¿Quieres contactarte a ti mismo :)?\n" +
    "                </md-tooltip>\n" +
    "            </md-button>\n" +
    "            <md-button ng-disabled=\"model.isMy\" class=\"link__button seller__profile__favorite\" ng-click=\"model.handleFavoriteSeller()\"\n" +
    "                ng-class=\"{'md-favorite': model.favoriteSeller, 'md-raised': model.favoriteSeller}\">\n" +
    "                <!-- <md-icon ng-if=\"!model.favoriteSeller\" md-font-icon=\"zmdi zmdi-favorite-outline\"></md-icon> -->\n" +
    "                <!-- <md-icon ng-if=\"model.favoriteSeller\" md-font-icon=\"zmdi zmdi-favorite\"></md-icon> -->\n" +
    "                <span ng-hide=\"model.favoriteSeller\">Seguir Vendedor</span>\n" +
    "                <span ng-show=\"model.favoriteSeller\">Ya estas siguiendolo</span>\n" +
    "                <md-tooltip ng-if=\"model.favoriteSeller\" md-delay=\"500\">\n" +
    "                    Click para dejar de seguir\n" +
    "                </md-tooltip>\n" +
    "            </md-button>\n" +
    "            <md-button ng-if=\"!model.post.owner.plan.product.characteristics.store\" class=\"link__button link__button\" ui-sref=\"main.post.search({usuario:model.post.owner.username})\">\n" +
    "                <!-- <md-icon md-font-icon=\"zmdi zmdi-file-text\"></md-icon> -->\n" +
    "                Otros Productos del Vendedor\n" +
    "            </md-button>\n" +
    "            <md-button ng-if=\"model.post.owner.plan.product.characteristics.store\" class=\"link__button link__button\" ui-sref=\"store.home({name:model.post.owner.username})\">\n" +
    "\n" +
    "                Visita mi Tienda\n" +
    "            </md-button>\n" +
    "            <!-- <md-divider></md-divider> -->\n" +
    "            <!-- <md-button ng-disabled=\"model.isMy\" class=\"link__button align__button\" ng-click=\"model.reportPost()\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon>\n" +
    "                Denunciar Producto\n" +
    "            </md-button> -->\n" +
    "\n" +
    "        </div>\n" +
    "    </md-card-content>\n" +
    "</md-card>");
}]);

angular.module("main/post/detail/share.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/detail/share.tpl.html",
    "<div class=\"post-detail__share\" layout=\"row\" layout-align=\"center center\" layout-wrap flex>\n" +
    "	<p hide-gt-sm class=\"md-subhead\" flex=\"100\">Compartir</p>\n" +
    "	<md-button ng-click=\"model.fbShare()\" aria-label=\"compartir en facebook\" class=\"md-raised post-detail__share--facebook\">\n" +
    "		<md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon>\n" +
    "	</md-button>\n" +
    "	<md-button ng-click=\"model.twShare()\" aria-label=\"compartir en twitter\" class=\"md-raised post-detail__share--twitter\">\n" +
    "		<md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon>\n" +
    "	</md-button>\n" +
    "	<md-button ng-click=\"model.gpShare()\" aria-label=\"compartir en google plus\" class=\"md-raised post-detail__share--google\">\n" +
    "		<md-icon md-font-icon=\"zmdi zmdi-google-plus\"></md-icon>\n" +
    "	</md-button>\n" +
    "	<md-button ng-click=\"model.emailShare()\" aria-label=\"compartir en email\" class=\"md-raised post-detail__share--email\">\n" +
    "		<md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n" +
    "	</md-button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/em-product-list/em-product-list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/em-product-list/em-product-list.tpl.html",
    "<md-list class=\"em-product-list\">\n" +
    "	<md-list-item ui-sref=\"main.post.detail({title:product._id})\" class=\"md-2-line\" ng-repeat-start=\"product in products\">\n" +
    "		<img em-src-image=\"product.images[0].path\" small alt=\"\" class=\"md-avatar\">\n" +
    "		<div class=\"md-list-item-text\">\n" +
    "			<h3>{{product.title}}</h3>\n" +
    "			<p class=\"em-product-list__price\">{{product.prices.list | currency:'RD$':2}}</p>\n" +
    "		</div>\n" +
    "	</md-list-item>\n" +
    "	<md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "</md-list>\n" +
    "");
}]);

angular.module("main/post/em-product/large.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/em-product/large.tpl.html",
    "<md-card class=\"em-product em-product-large\" ng-class=\"{'em-product-sponsor':sponsor}\">\n" +
    "	<a ui-sref=\"{{headerUri}}\" ng-if=\"headerText\" class=\"em-product__header-text\">\n" +
    "		<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>{{headerText}}\n" +
    "		<md-tooltip md-delay=\"'500'\" ng-if=\"headerTitle\">{{headerTitle}}</md-tooltip>\n" +
    "	</a>\n" +
    "	<p class=\"sponsor-text\" ng-if=\"sponsor\">Producto destacado</p>\n" +
    "	<img ng-if=\"mProduct.images\" em-src-image=\"mProduct.images[0]\" small alt=\"\">\n" +
    "\n" +
    "	<md-card-content layout-align=\"center end\" layout=\"row\" layout-wrap>\n" +
    "		<!-- <p>{{mProduct.title}}</p> -->\n" +
    "		<p flex=\"100\">{{mProduct.title}}</p>\n" +
    "\n" +
    "		<div flex=\"100\" layout=\"flex\" layout-align=\"end end\">\n" +
    "			<!-- TODO: removed '||' after load real product  -->\n" +
    "			<p flex=\"100\" class=\"price\">\n" +
    "				<strong>{{mProduct.price || mProduct.prices.list | currency:'RD$':2}}</strong>\n" +
    "			</p>\n" +
    "		</div>\n" +
    "	</md-card-content>\n" +
    "</md-card>");
}]);

angular.module("main/post/em-product/small.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/em-product/small.tpl.html",
    "<md-card class=\"em-product em-product-small\" md-ink-ripple=\"#333\" layout-align=\"space-between\">\n" +
    "	<div class=\"image-container\">\n" +
    "		<img ng-if=\"mProduct.img\" ng-src=\"{{mProduct.img}}\" alt=\"\">\n" +
    "		<img ng-if=\"mProduct.images\" em-src-image=\"mProduct.images[0]\" small alt=\"\">\n" +
    "	</div>\n" +
    "	<md-card-content>\n" +
    "		<p>{{mProduct.title | characters:41:true}}</p>\n" +
    "		<p class=\"price\" ng-if=\"mProduct.prices.list\">\n" +
    "			<strong>{{mProduct.prices.list | currency:'RD$':2}}</strong>\n" +
    "		</p>\n" +
    "	</md-card-content>\n" +
    "	<md-tooltip md-delay=\"500\" ng-if=\"mProduct.title.length > 41\">\n" +
    "		{{mProduct.title}}\n" +
    "	</md-tooltip>\n" +
    "</md-card>");
}]);

angular.module("main/post/offer/offer-list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/offer/offer-list.tpl.html",
    "<md-dialog aria-label=\"Ofertas\" flex-gt-sm=\"30\" class=\"offers\">\n" +
    "    <md-toolbar>\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <h3>Ofertas</h3>\n" +
    "            <span flex></span>\n" +
    "            <md-button ng-click=\"model.close()\" class=\"md-icon-button\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "            </md-button>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-dialog-content>\n" +
    "        <md-list ng-show=\"model.offers && model.offers.length > 0\">\n" +
    "            <md-list-item ng-click=\"null\" ng-repeat-start=\"offer in model.offers\" class=\"md-2-line\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-check\" ng-show=\"offer.status === 'accepted'\"></md-icon>\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-time\" ng-show=\"offer.status === 'pending'\"></md-icon>\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-close\" ng-show=\"offer.status === 'rejected' || offer.status ==='cancelled'\"></md-icon>\n" +
    "                <div class=\"md-list-item-text\">\n" +
    "                    <h3>{{offer.amount | currency:'RD$':2}}</h3>\n" +
    "                    <p>\n" +
    "                        {{offer.status}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "                <md-button ng-if=\"model.user === user._id\" class=\"md-secondary\">Cancelar</md-button>\n" +
    "            </md-list-item>\n" +
    "            <md-divider md-inset ng-repeat-end></md-divider>\n" +
    "        </md-list>\n" +
    "        <h3 ng-hide=\"model.offers && model.offers.length > 0\">Aún no se a ofertado nada, sé el primero en hacerlo</h3>\n" +
    "    </md-dialog-content>\n" +
    "    <md-dialog-actions>\n" +
    "        <form ng-submit=\"model.makeOffer()\" flex layout=\"row\">\n" +
    "            <md-input-container flex layout=\"row\">\n" +
    "                <label>Agregue su oferta</label>\n" +
    "                <input required type=\"number\" md-autofocus ng-model=\"model.amount\">\n" +
    "            </md-input-container>\n" +
    "            <md-button type=\"submit\">Ofertar</md-button>\n" +
    "        </form>\n" +
    "    </md-dialog-actions>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/post/offer/offer-manage.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/offer/offer-manage.tpl.html",
    "<md-dialog class=\"offers\" aria-label=\"Ofertas\">\n" +
    "    <md-toolbar class=\"md-transparent\">\n" +
    "      <div class=\"md-toolbar-tools\">\n" +
    "        <md-button ng-click=\"model.close()\" class=\"md-icon-button\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <h3>Ofertas del producto {{model.post.title}}</h3>\n" +
    "      </div>\n" +
    "    </md-toolbar>\n" +
    "    <md-dialog-content>\n" +
    "        <md-list>\n" +
    "          <md-list-item ng-click=\"null\" class=\"md-2-line _md-button-wrap _md md-clickable offer__{{offer.status}}\" ng-repeat=\"offer in model.post.offers | orderBy:'status' track by $index\">\n" +
    "            <md-icon ng-if=\"offer.status==='cancelled'\" md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon>\n" +
    "            <md-icon ng-if=\"offer.status==='pending'\" md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "            <md-icon ng-if=\"offer.status==='accepted'\" md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            <md-icon ng-if=\"offer.status==='rejected'\" md-font-icon=\"zmdi zmdi-close-circle\"></md-icon>\n" +
    "            <div class=\"md-list-item-text\">\n" +
    "              <h3>{{offer.amount |currency:'RD$':'2'}}</h3>\n" +
    "              <p>por {{offer.user.displayName}}</p>\n" +
    "            </div>\n" +
    "            <md-button  class=\"md-icon-button button-check\" ng-click=\"model.accept(offer)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </md-button>\n" +
    "            <md-button class=\"md-icon-button button-cancel\" ng-click=\"model.reject(offer)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-close-circle\"></md-icon>\n" +
    "            </md-button>\n" +
    "          </md-list-item>\n" +
    "        </md-list>\n" +
    "    </md-dialog-content>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/post/premium-product-list/premium.product.list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/premium-product-list/premium.product.list.tpl.html",
    "<div class=\"category-premium__container\" layout=\"row\" layout-align=\"space-between\">\n" +
    "    <a class=\"category-premium\" small ng-click=\"vm.onOpen($event, premium.post._id, $index)\" ui-sref=\"main.post.search.detail-desktop({title:premium.post._id, post:premium.product})\"\n" +
    "        em-product=\"premium.post\" ng-repeat=\"premium in premiumPosts | limitTo:4\"></a>\n" +
    "</div>");
}]);

angular.module("main/post/report/report.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/report/report.tpl.html",
    "<div class=\"report-post__panel--container\" >\n" +
    "\n" +
    "  <md-toolbar class=\"md-primary\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h3 flex>Reportar Producto</h3>\n" +
    "\n" +
    "      <md-button ng-disabled=\"model.isLoading\" class=\"md-icon-button\" ng-click=\"model.close()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <form layout=\"column\" ng-submit=\"reportForm.$valid && model.sendReport()\" name=\"reportForm\" novalidate>\n" +
    "\n" +
    "    <md-input-container class=\"clasic-input\">\n" +
    "      <label>Nombre</label>\n" +
    "      <input required ng-disabled=\"model.isLoading\" type=\"text\" ng-model=\"model.report.name\" name=\"fullname\">\n" +
    "      <div ng-messages=\"reportForm.fullname.$error\">\n" +
    "        <div ng-message=\"required\">Por favor escribe tu nombre</div>\n" +
    "      </div>\n" +
    "    </md-input-container>\n" +
    "    <md-input-container class=\"clasic-input\">\n" +
    "      <label>Razón</label>\n" +
    "      <md-select required ng-disabled=\"model.isLoading\" ng-model=\"model.report.reason\" name=\"reason\">\n" +
    "        <md-option value=\"inapropiado\">Inapropiado</md-option>\n" +
    "        <md-option value=\"repetido\">Repetido</md-option>\n" +
    "        <md-option value=\"fraude\">Fraude</md-option>\n" +
    "        <md-option value=\"invalid\">No cumple con las condiciones</md-option>\n" +
    "        <md-option value=\"other\">Otras</md-option>\n" +
    "      </md-select>\n" +
    "      <div ng-messages=\"reportForm.reason.$error\">\n" +
    "        <div ng-message=\"required\">Escoja la razón del reporte</div>\n" +
    "      </div>\n" +
    "    </md-input-container>\n" +
    "    <md-input-container class=\"clasic-input\">\n" +
    "      <label>Comentario</label>\n" +
    "      <textarea ng-disabled=\"model.isLoading\" rows=\"4\" ng-model=\"model.report.details\"></textarea>\n" +
    "    </md-input-container>\n" +
    "    <span flex></span>\n" +
    "    <div class=\"form__actions\">\n" +
    "      <md-button ng-disabled=\"model.isLoading\" class=\"md-big\" ng-click=\"model.close()\">Cancelar</md-button>\n" +
    "      <em-button is-loading=\"model.isLoading\" loading-text=\"'Enviando'\" type=\"submit\" class=\"md-big md-warn md-raised\">\n" +
    "        Reportar\n" +
    "      </em-button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/search/filter_old.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/filter_old.tpl.html",
    "<md-content flex class=\"md-transparent post-search__filter\" layout-wrap ng-cloak>\n" +
    "    <h4 hide-xs hide-sm>Filtrar Resultados</h4>\n" +
    "    <section layout=\"row\" layout-wrap>\n" +
    "        <div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "            <h5>Provincia</h5>\n" +
    "            <md-progress-circular ng-show=\"model.isLoading\" md-diameter=\"10\"></md-progress-circular>\n" +
    "        </div>\n" +
    "        <md-checkbox ng-change=\"model.filterProvince(province, $index)\" ng-repeat=\"province in model.provinces | limitTo:model.limit.province\" flex=\"100\" ng-model=\"model.filteringProvince[province._id]\" aria-label=\"{{province.name}}\">\n" +
    "            {{province.name}} ({{province.total |currency:'':0}})\n" +
    "        </md-checkbox>\n" +
    "        <small ng-show=\"model.provinces.length > 3\">\n" +
    "			<a href ng-click=\"model.toggleLimit('province')\">\n" +
    "				<span ng-show=\"model.limit.category\">Más</span><span ng-hide=\"model.limit.category\">Menos</span> provincias\n" +
    "				<md-icon ng-show=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-down\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "				<md-icon ng-hide=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-up\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "			</a>\n" +
    "		</small>\n" +
    "    </section>\n" +
    "\n" +
    "    <section layout=\"row\" layout-wrap>\n" +
    "			<div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "					<h5>Categorías</h5>\n" +
    "					<md-progress-circular ng-show=\"model.isLoading\" md-diameter=\"10\"></md-progress-circular>\n" +
    "			</div>\n" +
    "        <md-chips ng-show=\"model.parentCategory\">\n" +
    "            <md-chip>\n" +
    "                <md-button ng-click=\"model.filterCategory({})\" class=\"md-icon-button md-chip-remove\">\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                </md-button>{{model.parentCategory.name}}\n" +
    "                <md-tooltip md-delay=\"500\">{{model.parentCategory.name}}</md-tooltip>\n" +
    "            </md-chip>\n" +
    "        </md-chips>\n" +
    "        <md-checkbox ng-class=\"{'extra-padding': model.parentCategory}\" ng-change=\"model.filterCategory(filter.category, $index)\" ng-repeat=\"filter in model.products.$metadata.filter.categories | limitTo: model.limit.category\" flex=\"100\" ng-model=\"model.filteringCategory[filter.category._id]\"\n" +
    "            aria-label=\"filtrar por {{filter.category.name}}\">\n" +
    "            {{filter.category.name}} ({{filter.total |currency:'':0}})\n" +
    "            </md-checkbox>\n" +
    "            <small ng-show=\"model.products.$metadata.filter.categories.length > 5\">\n" +
    "			<a href ng-click=\"model.toggleLimit('category')\">\n" +
    "				<span ng-show=\"model.limit.category\">Más</span><span ng-hide=\"model.limit.category\">Menos</span> categorías\n" +
    "				<md-icon ng-show=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-down\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "				<md-icon ng-hide=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-up\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "			</a>\n" +
    "		</small>\n" +
    "    </section>\n" +
    "\n" +
    "    <section layout=\"row\" layout-wrap class=\"post-search__filter__price\">\n" +
    "        <h5 flex=\"100\">Precio</h5>\n" +
    "        <small>De</small>\n" +
    "        <md-input-container flex>\n" +
    "            <input type=\"number\" ng-model=\"model.fromPrice\">\n" +
    "        </md-input-container>\n" +
    "        <small>A</small>\n" +
    "        <md-input-container flex>\n" +
    "            <input type=\"number\" ng-model=\"model.toPrice\">\n" +
    "        </md-input-container>\n" +
    "        <md-button ng-click=\"model.filterPrice(model.fromPrice, model.toPrice)\" class=\"md-small md-raised\">\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <md-button flex=\"100\" ng-click=\"model.clearPrice()\">Limpiar Precio</md-button>\n" +
    "    </section>\n" +
    "\n" +
    "    <section layout=\"row\" layout-wrap>\n" +
    "        <h5 flex=\"100\">Condición</h5>\n" +
    "        <md-checkbox ng-repeat=\"state in model.products.$metadata.filter.conditions |orderBy:'-total'\" flex=\"100\" ng-model=\"model.filteringCondition[state.condition]\" ng-change=\"model.filterCondition(state.condition, $index)\" aria-label=\"condición\">\n" +
    "            {{state.condition | translate}} ({{state.total |currency:'':0}})\n" +
    "        </md-checkbox>\n" +
    "    </section>\n" +
    "    <section layout=\"row\" layout-wrap>\n" +
    "        <h5 flex=\"100\">Moneda</h5>\n" +
    "        <md-checkbox ng-change=\"model.filterCurrency(currency, $index)\" ng-repeat=\"currency in model.currencies\" flex=\"100\" ng-model=\"model.filteringCurrency[currency.symbol]\" aria-label=\"{{currency.name}}\">\n" +
    "            {{currency.symbol}} ({{currency.count |currency:'':0}})\n" +
    "        </md-checkbox>\n" +
    "    </section>\n" +
    "</md-content>\n" +
    "");
}]);

angular.module("main/post/search/filter/custom-filter.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/filter/custom-filter.tpl.html",
    "<div ng-controller=\"CustomFilterController as vm\">\n" +
    "\n" +
    "  <div class=\"custom-filter\" ng-show=\"vm.filters\">\n" +
    "    <h4 class=\"custom-filter__text\">Filtrar Por:</h4>\n" +
    "\n" +
    "    <div class=\"custom-filter__list\">\n" +
    "      <custom-field-container flex=\"100\" hidden-tabs=\"vm.hideTabs\" ng-model=\"vm.filter\" fields=\"vm.filters\"></custom-field-container>\n" +
    "      <div class=\"custom-filter__actions\" ng-hide=\"vm.hideTabs\" hide-xs hide-sm>\n" +
    "        <md-button ng-click=\"vm.clearFilters()\" class=\"md-medium md-default\">Limpiar Filtro</md-button>\n" +
    "        <md-button ng-click=\"vm.applyFilter()\" class=\"md-medium md-accent md-raised\">Aplicar Filtro</md-button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"custom-filter-list\">\n" +
    "    <md-chips ng-model=\"vm.filterList\" md-on-remove=\"vm.removeFilter($chip.slug)\">\n" +
    "      <md-chip-template>\n" +
    "        <span>\n" +
    "          <strong>{{$chip.name}}:</strong>\n" +
    "          <em>{{$chip.value}}</em>\n" +
    "        </span>\n" +
    "      </md-chip-template>\n" +
    "      <md-button md-chip-remove class=\"md-icon-button md-small vegetablechip\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close-circle\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </md-chips>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("main/post/search/filter/filter.container.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/filter/filter.container.tpl.html",
    "<div class=\"search-filter\" flex>\n" +
    "    <md-card>\n" +
    "        <md-toolbar class=\"md-small\">\n" +
    "            <div class=\"md-toolbar-tools\">\n" +
    "                <h3>Filtrar Resultados</h3>\n" +
    "            </div>\n" +
    "        </md-toolbar>\n" +
    "        <md-card-content ng-include=\"'main/post/search/filter/filter.tpl.html'\">\n" +
    "\n" +
    "        </md-card-content>\n" +
    "    </md-card>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/search/filter/filter.panel.container.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/filter/filter.panel.container.tpl.html",
    "<div layout=\"column\" flex class=\"search__filter\">\n" +
    "  <md-toolbar>\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h3 flex>Filtrar Resultados</h3>\n" +
    "      <md-button class=\"md-icon-button\" ng-click=\"model.close()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content flex>\n" +
    "    <div ng-include=\"'main/post/search/filter/filter.tpl.html'\">\n" +
    "\n" +
    "    </div>\n" +
    "    <div class=\"search__filter__buttons\">\n" +
    "      <md-button ng-click=\"model.clearAndClose()\" class=\"md-raised search__filter__apply-btn\">Limpiar Filtros</md-button>\n" +
    "      <md-button ng-click=\"model.close()\" class=\"md-raised md-accent search__filter__apply-btn\">Aplicar Filtros</md-button>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/search/filter/filter.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/filter/filter.tpl.html",
    "<div class=\"search-filter__content\">\n" +
    "  <h3>Precios:</h3>\n" +
    "  <div class=\"search-filter__price\">\n" +
    "    <form ng-submit=\"model.filterPrice(model.fromPrice, model.toPrice)\">\n" +
    "      <small>de</small>\n" +
    "      <md-input-container flex>\n" +
    "        <input aria-label=\"precio desde\" type=\"number\" min=\"0\" max=\"{{model.toPrice}}\" step=\"100\" ng-model=\"model.fromPrice\">\n" +
    "      </md-input-container>\n" +
    "      <small>a</small>\n" +
    "      <md-input-container flex>\n" +
    "        <input aria-label=\"precio hasta\" type=\"number\" step=\"100\" min=\"{{model.fromPrice || 0}}\" ng-model=\"model.toPrice\">\n" +
    "      </md-input-container>\n" +
    "      <md-button ng-hide=\"model.fromPanel\" type=\"submit\" class=\"md-small md-primary  md-raised\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <div flex=\"100\" class=\"md-button-wrapper\">\n" +
    "        <md-button ng-hide=\"!model.fromPrice && !model.toPrice\" ng-click=\"model.clearPrice()\">Limpiar Precio</md-button>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"search-filter__content search-filter__content--condition\">\n" +
    "  <h3>Condición:</h3>\n" +
    "  <md-checkbox ng-if=\"filter.condition !== 'na'\" ng-repeat=\"filter in model.metadata.filter.conditions |orderBy:'-total'\" flex-gt-sm=\"100\"\n" +
    "    flex=\"50\" ng-model=\"model.filteringCondition[filter.condition]\" ng-change=\"model.filterCondition(filter.condition, $index)\"\n" +
    "    aria-label=\"condición\" class=\"md-checkbox__boxed\">\n" +
    "    {{filter.condition | translate}} ({{filter.total |currency:'':0}})\n" +
    "  </md-checkbox>\n" +
    "  <small ng-show=\"!model.metadata.filter.conditions || model.metadata.filter.conditions.length === 0\">Sin filtro</small>\n" +
    "</div>\n" +
    "<div class=\"search-filter__content\" hide-xs hide-sm>\n" +
    "  <h3>Moneda:</h3>\n" +
    "  <md-checkbox ng-change=\"model.filterCurrency(filter.currency, $index)\" ng-repeat=\"filter in model.metadata.filter.currencies\"\n" +
    "    flex=\"100\" ng-model=\"model.filteringCurrency[filter.currency.symbol]\" aria-label=\"{{filter.currency.name}}\" class=\"md-checkbox__boxed\">\n" +
    "    {{filter.currency.symbol}} ({{filter.total |currency:'':0}})\n" +
    "  </md-checkbox>\n" +
    "  <small ng-show=\"!model.metadata.filter.currencies || model.metadata.filter.currencies.length === 0\">Sin filtro</small>\n" +
    "</div>\n" +
    "<div class=\"search-filter__content search-filter__content--category\" ng-class=\"{'with-parent-category':model.categoryTree && model.categoryTree.length > 1 }\">\n" +
    "  <h3>Categorías:</h3>\n" +
    "  <md-button ng-if=\"model.categoryTree && model.categoryTree.length > 1\" ng-click=\"model.jumpToCategory(model.categoryTree[0], 0)\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "    {{model.categoryTree[0].name}}\n" +
    "  </md-button>\n" +
    "  <md-button ng-if=\"model.categoryTree && model.categoryTree.length === 1\" ng-click=\"model.jumpToCategory({})\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "    Todas las categorías\n" +
    "  </md-button>\n" +
    "  <md-checkbox class=\"md-checkbox__boxed\" ng-class=\"{'extra-padding': model.parentCategory}\" ng-change=\"model.filterCategory(filter.category, $index)\"\n" +
    "    ng-repeat=\"filter in model.metadata.filter.categories | limitTo: model.limit.category\" flex=\"100\" ng-model=\"model.filteringCategory[filter.category._id]\"\n" +
    "    aria-label=\"filtrar por {{filter.category.name}}\"> {{filter.category.name}}({{filter.total |currency:'':0}})</md-checkbox>\n" +
    "  <a href ng-click=\"model.toggleLimit('category')\" class=\"search-filter__more\" ng-show=\"model.metadata.filter.categories && model.metadata.filter.categories.length > 0\">\n" +
    "    <span ng-show=\"model.limit.category\">Más</span>\n" +
    "    <span ng-hide=\"model.limit.category\">Menos</span> categorías\n" +
    "    <md-icon ng-show=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-down\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "    <md-icon ng-hide=\"model.limit.category\" md-font-icon=\"zmdi zmdi-caret-up\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "  </a>\n" +
    "  <small ng-show=\"!model.metadata.filter.categories || model.metadata.filter.categories.length === 0\">Sin filtro</small>\n" +
    "  <div class=\"loading\" ng-class=\"{active: model.isLoading}\">\n" +
    "    <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"search-filter__content\">\n" +
    "  <h3>Provincias:</h3>\n" +
    "  <md-checkbox ng-change=\"model.filterProvince(filter.province, false)\" ng-repeat=\"filter in model.metadata.filter.provinces | limitTo:model.limit.province\"\n" +
    "    flex=\"100\" ng-model=\"model.filteringProvince[filter.province.slug]\" aria-label=\"{{filter.province.name}}\" class=\"md-checkbox__boxed\">\n" +
    "    {{filter.province.name}} ({{filter.total |currency:'':0}})\n" +
    "  </md-checkbox>\n" +
    "  <a href ng-click=\"model.toggleLimit('province')\" class=\"search-filter__more\" ng-show=\"model.metadata.filter.provinces && model.metadata.filter.provinces.length > 0\">\n" +
    "\n" +
    "    <span ng-show=\"model.limit.province\">Más</span>\n" +
    "    <span ng-hide=\"model.limit.province\">Menos</span> provincias\n" +
    "    <md-icon ng-show=\"model.limit.province\" md-font-icon=\"zmdi zmdi-caret-down\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "    <md-icon ng-hide=\"model.limit.province\" md-font-icon=\"zmdi zmdi-caret-up\" aria-label=\"Ver categorias\"></md-icon>\n" +
    "  </a>\n" +
    "  <small ng-show=\"!model.metadata.filter.provinces || model.metadata.filter.provinces.length === 0\">Sin filtro</small>\n" +
    "</div>");
}]);

angular.module("main/post/search/search-list-old.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/search-list-old.tpl.html",
    "<div class=\"search-list__mobile\" layout=\"column\" ng-if=\"model.isMobile\">\n" +
    "    <md-subheader class=\"mobile-subheader\">{{model.products.$metadata.total}} resultados de la busqueda <span ng-show=\"model.term\">\"{{model.term}}\"</span>\n" +
    "        <span flex></span>\n" +
    "        <md-button ng-click=\"model.showFilter()\">Filtrar</md-button>\n" +
    "    </md-subheader>\n" +
    "    <md-virtual-repeat-container flex=\"100\" md-auto-shrink>\n" +
    "        <md-list class=\"em-product-list\">\n" +
    "            <div md-virtual-repeat=\"post in model.infiniteScroll\" md-on-demand=\"model.onDemand\" ng-init=\"sectionIndex = $index\">\n" +
    "                <md-list-item ui-sref=\"main.post.search.detail({title:post._id})\" class=\"md-2-line\">\n" +
    "                    <img em-src-image=\"post.images[0].path\" small alt=\"\" class=\"md-avatar\">\n" +
    "                    <div class=\"md-list-item-text\">\n" +
    "                        <h3>{{post.title}}</h3>\n" +
    "                        <p class=\"em-post-list__price\">{{post.prices.list | currency:post.currency.symbol:2}}</p>\n" +
    "                    </div>\n" +
    "                </md-list-item>\n" +
    "            </div>\n" +
    "            <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "        </md-list>\n" +
    "    </md-virtual-repeat-container>\n" +
    "</div>\n" +
    "<div flex ng-if=\"!model.isMobile\" class=\"search-list__desktop\" layout=\"column\">\n" +
    "    <div class=\"breadcrum\" layout=\"row\">\n" +
    "        <p class=\"md-subhead category-tree\">\n" +
    "            {{model.products.$metadata.total |currency:'':0}} resultados <span ng-show=\"model.term\">para:</span>\n" +
    "            <a href ng-click=\"model.jumpToCategory(category, $index)\" ng-repeat-start=\"category in model.categoryTree\">\n" +
    "              {{category.name}}\n" +
    "            </a>\n" +
    "            <span ng-repeat-end ng-show=\"!$last\"> : </span>\n" +
    "            <span ng-show=\"model.categoryTree.length > 0\"> : </span>\n" +
    "            <span class=\"term\" ng-show=\"model.term\"> \"{{model.term}}\"</span>\n" +
    "            <span ng-show=\"model.province\"> en </span>\n" +
    "            <span ng-show=\"model.province\" class=\"term\">\n" +
    "              {{model.province.name}}\n" +
    "    					<md-button class=\"md-icon-button\"  ng-click=\"model.removeProvinceFilter(model.province)\">\n" +
    "    						<md-icon md-font-icon=\"zmdi zmdi-close-circle\"></md-icon>\n" +
    "    					</md-button>\n" +
    "				    </span>\n" +
    "            <span class=\"md-subhead\" ng-show=\"model.user\">de</span>\n" +
    "        </p>\n" +
    "        <md-chips ng-show=\"model.user\">\n" +
    "            <md-chip>\n" +
    "                <md-chip-template>\n" +
    "                    <div class=\"md-content-avatar\">\n" +
    "                        <img thumbnail em-src-image=\"model.user.picture.path\" alt=\"\">\n" +
    "                    </div>\n" +
    "                    <div class=\"md-content-name\">\n" +
    "                        {{model.user.displayName}}\n" +
    "                    </div>\n" +
    "                    <md-button ng-click=\"model.clearUser()\"class=\"md-icon-button md-small\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-close-circle\"></md-icon>\n" +
    "                    </md-button>\n" +
    "                </md-chip-template>\n" +
    "\n" +
    "            </md-chip>\n" +
    "        </md-chips>\n" +
    "    </div>\n" +
    "    <!-- <p class=\"md-subhead\" ng-show=\"model.categoryTree.length === 0\">{{model.products.$metadata.total}} resultados de la busqueda <span ng-show=\"model.term\" class=\"term\">\"{{model.term}}\"</span></p> -->\n" +
    "    <!-- <md-subheader class=\"md-no-sticky\">{{model.products.$metadata.total}} resultados de la busqueda <span ng-show=\"model.term\">\"{{model.term}}\"</span></md-subheader> -->\n" +
    "    <md-card flex layout=\"column\">\n" +
    "        <md-virtual-repeat-container flex>\n" +
    "            <md-list flex>\n" +
    "                <div md-item-size=\"117\" md-virtual-repeat=\"post in model.infiniteScroll\" md-on-demand=\"model.onDemand\" ng-init=\"sectionIndex = $index\">\n" +
    "                    <md-list-item ng-click=\"model.setVirtualIndex($index)\" ng-show=\"post._id\" ui-sref=\"main.post.search.detail({title:post._id})\" class=\"md-3-line\" ng-click=\"null\">\n" +
    "                        <img em-src-image=\"post.images[0].path\" small alt=\"\" class=\"md-avatar\">\n" +
    "                        <div class=\"md-list-item-text\">\n" +
    "                            <p class=\"post-search__title\">{{post.title}}</p>\n" +
    "                            <h4 class=\"post-search__price\">{{post.prices.list | currency:post.currency.symbol:2}}</h4>\n" +
    "                            <a href=\"\">{{post.categorySlug}}</a>\n" +
    "                        </div>\n" +
    "                        <div class=\"md-secondary\">\n" +
    "                            <p duration=\"post.createdAt\">{{post.createdAt}}</p>\n" +
    "                            <p class=\"md-subhead capitalize\">\n" +
    "                                <md-icon class=\"md-small\" md-font-icon=\"zmdi zmdi-account\"></md-icon>\n" +
    "                                {{post.owner.displayName}}\n" +
    "                            </p>\n" +
    "                        </div>\n" +
    "                    </md-list-item>\n" +
    "                    <!-- <md-list-item ng-hide=\"post._id\" class=\"no-more-result-message\">\n" +
    "						<div class=\"md-list-item-text\" flex>\n" +
    "							<h3>No existen más anuncios</h3>\n" +
    "						</div>\n" +
    "					</md-list-item> -->\n" +
    "                    <md-divider ng-show=\"post._id\"></md-divider>\n" +
    "                    <md-list-item ng-if=\"sectionIndex/3 === 0 && model.premiums.length > 0\" class=\"premium-post\" layout-wrap>\n" +
    "                        <p flex=\"100\" class=\"md-subhead\">Anuncios Destacados {{sectionIndex/3}}\n" +
    "                            <md-button class=\"md-icon-button\">\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-info\" aria-label=\"Anuncios premium información\"></md-icon>\n" +
    "                                <md-tooltip>Que es esto?</md-tooltip>\n" +
    "                            </md-button>\n" +
    "                        </p>\n" +
    "                        <div layout=\"row\" flex layout-align=\"space-around center\">\n" +
    "                            <div ui-sref=\"main.post.detail({title:product.post._id})\" ng-repeat=\"product in model.premiums\" em-product=\"product.post\"></div>\n" +
    "                        </div>\n" +
    "                    </md-list-item>\n" +
    "                    <md-divider ng-if=\"sectionIndex/3 ===0 && model.premiums.length > 0\"></md-divider>\n" +
    "\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- <md-divider ng-if=\"$index /3  === 1\"></md-divider> -->\n" +
    "            </md-list>\n" +
    "        </md-virtual-repeat-container>\n" +
    "\n" +
    "        <div ng-show=\"model.isLoading\" layout=\"row\" class=\"loading-indicator\" layout-align=\"center center\">\n" +
    "            <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n" +
    "            <p>\n" +
    "                Cargando productos ...\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </md-card>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/post/search/search-list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/search-list.tpl.html",
    "<div class=\"search-result\">\n" +
    "  <h3 ng-show=\"model.products && model.products.length > 0\" hide-xs hide-sm class=\"user\" ng-if=\"model.user\">Productos de:\n" +
    "    <div class=\"user-chip\">\n" +
    "      <div class=\"user-chip__content\">\n" +
    "        <img class=\"user-chip__image\" thumbnail em-src-image=\"model.user.picture\" alt=\"\">\n" +
    "        <h4>{{model.user.displayName}}</h4>\n" +
    "      </div>\n" +
    "      <md-button class=\"md-icon-button \" ng-click=\"model.clearUser()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </h3>\n" +
    "  <h3 ng-show=\"model.isLoading\" hide-xs hide-sm class=\"md-subhead search-result__detail-text\"></h3>\n" +
    "  <h3 ng-show=\"model.products && model.products.length > 0\" hide-xs hide-sm class=\"md-subhead search-result__detail-text\">\n" +
    "    Más de\n" +
    "    <strong>{{model.metadata.total | currency:'':0}}</strong> resultados\n" +
    "    <span class=\"category-tree\" ng-show=\"model.categoryTree && model.categoryTree.length > 0\">para:\n" +
    "      <a href ng-click=\"model.jumpToCategory(category, $index)\" ng-repeat-start=\"category in model.categoryTree\">{{category.name}}</a>\n" +
    "\n" +
    "      <span ng-repeat-end ng-if=\"!$last\"> &#62; </span>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-show=\"model.term\" class=\"term-container\">de la búsqueda\n" +
    "      <span class=\"term\">\"{{model.term}}\"\n" +
    "        <a href class=\"close-btn\" ng-click=\"model.clearTerm()\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "        </a>\n" +
    "      </span>\n" +
    "    </span>\n" +
    "    <span class=\"term-container\" ng-show=\"model.isPremium\"> en\n" +
    "      <span class=\"term\">Producto Destacados\n" +
    "        <a href class=\"close-btn\" ng-click=\"model.clearPremium()\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "        </a>\n" +
    "      </span>\n" +
    "    </span>\n" +
    "    <span class=\"province\" ng-show=\"model.province\">\n" +
    "      en:\n" +
    "      <a href=\"\">{{model.province.name}}</a>\n" +
    "      <a href class=\"close-btn\" ng-click=\"model.removeProvinceFilter(model.province)\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </a>\n" +
    "    </span>\n" +
    "    <span class=\"sort-by\">\n" +
    "      <md-input-container>\n" +
    "        <label for=\"\">Ordenar por</label>\n" +
    "        <md-select ng-model=\"model.sortBy\" ng-change=\"model.changeOrder()\">\n" +
    "          <md-option value=\"\">Relevancia</md-option>\n" +
    "          <md-option value=\"precio\">Precio mas bajo arriba</md-option>\n" +
    "          <md-option value=\"-precio\">Precio mas alto arriba</md-option>\n" +
    "          <md-option value=\"-fecha\">Fecha mas reciente primero</md-option>\n" +
    "          <md-option value=\"fecha\">Fecha mas viejo primero</md-option>\n" +
    "        </md-select>\n" +
    "      </md-input-container>\n" +
    "    </span>\n" +
    "  </h3>\n" +
    "  <div hide-xs hide-sm class=\"search__suggestions\" ng-click=\"model.acceptSuggesiton()\" ng-show=\"model.metadata.suggestion\">\n" +
    "    <p class=\"search-result__detail-text\">Talvez quisiste decir:\n" +
    "      <span>{{model.metadata.suggestion}}</span>\n" +
    "    </p>\n" +
    "  </div>\n" +
    "\n" +
    "  <md-subheader hide-gt-sm ng-if=\"model.province\" class=\"province-subheader\">\n" +
    "    <div layout=\"row\">\n" +
    "      <span flex>Resultados de {{model.province.name}}</span>\n" +
    "      <md-button class=\"md-primary md-small\" ng-click=\"model.showFilter()\">Cambiar</md-button>\n" +
    "    </div>\n" +
    "\n" +
    "  </md-subheader>\n" +
    "  <div ng-if=\"model.metadata.filter.custom && model.metadata.filter.custom.length > 0\" ng-include=\"'main/post/search/filter/custom-filter.tpl.html'\"></div>\n" +
    "  <div class=\"search-result__list\" ng-show=\"model.products && model.products.length > 0\">\n" +
    "\n" +
    "    <md-subheader class=\"ng-hide result-text result-text__exact\" ng-repeat-start=\"product in model.products track by product._id\"\n" +
    "      ng-show=\"$index===0 && product.perfectmatch\">Resultados exactos de la busqueda </md-subheader>\n" +
    "    <md-subheader class=\"ng-hide result-text result-text__inexact\" ng-show=\"$index===0 && !product.perfectmatch || (!product.perfectmatch && model.products[$index-1].perfectmatch)\">\n" +
    "      <span ng-if=\"$index===0 && model.metadata.skip == 0\">No hubo resultados exactos para esta busqueda, te presentamos otros resultados que te puede interesar</span>\n" +
    "      <span ng-if=\"$index!==0 || (model.metadata.skip != 0 && $index===0)\">Otros resultados relacionados con la busqueda</span>\n" +
    "    </md-subheader>\n" +
    "    <a class=\"search-result__post\" ng-animate=\"{enter:'post-enter'}\" ng-click=\"model.showPost($event, product._id, $index)\" ui-sref=\"main.post.search.detail-desktop({title:product._id, post:product})\">\n" +
    "      <div class=\"post__image\">\n" +
    "        <img hide-xs hide-sm em-src-image=\"product.images[0]\" square alt=\"\">\n" +
    "        <img hide-gt-sm em-src-image=\"product.images[0]\" thumbnail alt=\"\">\n" +
    "      </div>\n" +
    "      <div class=\"post__body\" flex>\n" +
    "        <div>\n" +
    "          <!-- <p class=\"post__body__category\" hide-xs hide-sm>{{product.categorySlug}}</p> -->\n" +
    "          <h3 class=\"post__body__title\">{{product.title}}</h3>\n" +
    "          <h3 class=\"post__body__price\">{{product.prices.list | currency:product.currency.symbol:2}}</h3>\n" +
    "        </div>\n" +
    "        <div class=\"post__detail\">\n" +
    "          <div class=\"post__detail__block post__detail__mobile__block\" hide-gt-sm>\n" +
    "            <p>\n" +
    "              <span class=\"{{product.condition}}\">{{product.condition | translate}}</span> | {{product.province.name}}\n" +
    "            </p>\n" +
    "            <p>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "              <span duration=\"product.resetAt\">{{product.resetAt}}</span>\n" +
    "            </p>\n" +
    "          </div>\n" +
    "          <div class=\"post__detail__block\" hide-xs hide-sm>\n" +
    "\n" +
    "            <p>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-triangle-up\"></md-icon>\n" +
    "              <strong>Condición: </strong>\n" +
    "              <span class=\"{{product.condition}}\">{{product.condition | translate}}</span>\n" +
    "            </p>\n" +
    "            <p>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "              <strong>Ubicación: </strong> {{product.province.name}}\n" +
    "            </p>\n" +
    "            <p ng-if=\"product.owner.plan.product.characteristics.store\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-store\"></md-icon>\n" +
    "              <span> Tienda</span>\n" +
    "            </p>\n" +
    "            <div class=\"custom-filter-list\">\n" +
    "              <div ng-repeat=\"(key, filter) in product.custom\">\n" +
    "                <md-icon ng-if=\"filter.icon.svg\" md-svg-src=\"{{'assets/'+filter.icon.svg}}\"></md-icon>\n" +
    "                <md-icon ng-if=\"filter.icon.font\" md-font-icon=\"{{filter.icon.font}}\"></md-icon>\n" +
    "                <span>{{filter.value}}</span>\n" +
    "                <md-tooltip>{{key}}</md-tooltip>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"post__detail__block\" hide-xs hide-sm>\n" +
    "            <p>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "              <span duration=\"product.resetAt\">{{product.resetAt}}</span>\n" +
    "            </p>\n" +
    "            <p>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n" +
    "              {{product.owner.displayName}}\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </a>\n" +
    "\n" +
    "    <md-divider ng-if=\"model.canShowBanner($index)\"></md-divider>\n" +
    "\n" +
    "    <em-banner slot=\"9270912410\" hide-gt-sm ng-if=\"model.canShowBanner($index)\" size=\"320x50\"></em-banner>\n" +
    "    <!-- <div class=\"category-premium__container\" layout=\"row\" ng-if=\"model.canShowBanner($index)\" layout-align=\"space-between\">\n" +
    "      <a class=\"category-premium\" small ng-click=\"model.showPost($event, premium.post._id, $index)\" ui-sref=\"main.post.search.detail-desktop({title:premium.post._id, post:premium.product})\"\n" +
    "        em-product=\"premium.post\" ng-repeat=\"premium in model.premiumPost | limitTo:4\"></a>\n" +
    "    </div> -->\n" +
    "\n" +
    "    <em-premium-product-list premium-post=\"model.premiumPost\" on-open=\"model.showPost($event)\" ng-if=\"model.canShowBanner($index) && !model.isAds\"\n" +
    "    />\n" +
    "\n" +
    "    <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "  </div>\n" +
    "  <div ng-show=\"(!model.products || model.products.length === 0) && !model.isLoading\">\n" +
    "    <p>No se encontraron resultados en la búsqueda de:\n" +
    "      <strong>{{model.term}}</strong>\n" +
    "    </p>\n" +
    "    <h4>Ayuda para mejorar su búsqueda</h4>\n" +
    "    <ul>\n" +
    "      <li>Pruebe un término alterno.</li>\n" +
    "      <li>Pruebe una palabra clave o combinación de palabras clave diferentes.</li>\n" +
    "      <li>Amplíe su busqueda usando menos palabras clave.</li>\n" +
    "      <li>Revise su ortografía.</li>\n" +
    "      <li>Explore nuestras\n" +
    "        <a href ui-sref=\"main.category\">categorías.</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"model.province\">Intente buscar en\n" +
    "        <a href ui-sref=\"main.post.search({q:model.term, provincia: null})\">todo el país.</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"mobile-pagination\" ng-show=\"model.products && model.products.length > 0\" hide-gt-sm>\n" +
    "    <md-button ng-click=\"model.changePage(model.page - 1)\" class=\"md-raised md-primary\" ng-disabled=\"model.page === 1\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      Anterior\n" +
    "    </md-button>\n" +
    "    <p>{{model.page}}/{{model.totalPage}}</p>\n" +
    "    <md-button ng-click=\"model.changePage(model.page + 1)\" class=\"md-raised md-primary\" ng-disabled=\"model.totalPage === model.page\">\n" +
    "      Siguiente\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "    </md-button>\n" +
    "  </div>\n" +
    "  <md-card ng-if=\"!model.isMobile\" class=\"pagination__container\" ng-show=\"model.products && model.products.length > 0\" paging\n" +
    "    page=\"model.page\" page-size=\"25\" show-prev-next=\"true\" total=\"model.metadata.total\" paging-action=\"model.changePage(page, pageSize, total)\">\n" +
    "  </md-card>\n" +
    "  <div layout=\"column\" ng-show=\"model.isLoading\" layout-align=\"center center\" class=\"search-loading\">\n" +
    "    <md-progress-circular md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular>\n" +
    "    <p class=\"md-subhead\">Cargando productos...</p>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("main/post/search/search.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/search/search.tpl.html",
    "<div class=\"search\" flex layout=\"row\" layout-align=\"center\" layout-wrap>\n" +
    "  <div hide-gt-sm class=\"search__suggestions\" flex=\"100\" ng-click=\"model.acceptSuggesiton()\" ng-show=\"model.metadata.suggestion\">\n" +
    "    <p>Talvez quisiste decir:\n" +
    "      <span>{{model.metadata.suggestion}}</span>\n" +
    "    </p>\n" +
    "  </div>\n" +
    "  <div class=\"responsive-container\" layout=\"row\">\n" +
    "    <div flex=\"20\" hide-sm hide-xs class=\"search__filter\" ng-include=\"'main/post/search/filter/filter.container.tpl.html'\">\n" +
    "\n" +
    "    </div>\n" +
    "    <div flex class=\"search__list\" ng-include=\"'main/post/search/search-list.tpl.html'\">\n" +
    "\n" +
    "    </div>\n" +
    "    <em-banner size=\"160x600\" slot=\"'7514977611'\" hide-xs hide-sm></em-banner>\n" +
    "    <md-button hide-xs hide-sm ng-click=\"model.scrollToTop()\" class=\"md-fab md-primary md-raised md-fab-bottom-right\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-chevron-up\"></md-icon>\n" +
    "      <md-tooltip md-delay=\"500\" md-direction=\"top\">Volver al Principio</md-tooltip>\n" +
    "    </md-button>\n" +
    "  </div>\n" +
    "  <div class=\"search__post-detail-container\" ng-show=\"model.search.showPost\">\n" +
    "    <ui-view name=\"detail\" class=\"search__post-detail\"></ui-view>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("main/post/share-sheet/share.sheet.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/post/share-sheet/share.sheet.tpl.html",
    "<md-bottom-sheet class=\"md-grid share-sheet\" layout=\"column\">\n" +
    "    <div layout=\"row\" layout-align=\"center center\" ng-cloak>\n" +
    "        <h4>\n" +
    "            Compartir\n" +
    "            <span>{{vm.post.title}}</span>\n" +
    "        </h4>\n" +
    "    </div>\n" +
    "    <div ng-cloak>\n" +
    "        <md-list flex layout=\"row\" layout-align=\"center center\">\n" +
    "            <md-list-item>\n" +
    "                <div>\n" +
    "                    <md-button class=\"md-grid-item-content md-facebook\" ng-click=\"vm.shareFacebook()\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-facebook-box\"></md-icon>\n" +
    "                        <div class=\"md-grid-text\">Facebook</div>\n" +
    "                    </md-button>\n" +
    "                </div>\n" +
    "            </md-list-item>\n" +
    "            <md-list-item>\n" +
    "                <div>\n" +
    "                    <md-button class=\"md-grid-item-content md-twitter\" ng-click=\"vm.shareTwitter()\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-twitter-box\"></md-icon>\n" +
    "                        <div class=\"md-grid-text\">Twitter</div>\n" +
    "                    </md-button>\n" +
    "                </div>\n" +
    "            </md-list-item>\n" +
    "            <md-list-item>\n" +
    "                <div>\n" +
    "                    <a socialshare socialshare-provider=\"whatsapp\" socialshare-url=\"{{vm.socialshareUrl}}\" socialshare-text=\"{{vm.post.title\n" +
    "                    + ' '}}\" class=\"md-button md-grid-item-content md-whatsapp\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-whatsapp\"></md-icon>\n" +
    "                        <div class=\"md-grid-text\">Whatsapp</div>\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </md-list-item>\n" +
    "        </md-list>\n" +
    "    </div>\n" +
    "</md-bottom-sheet>");
}]);

angular.module("main/profile/buy/buy.dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/buy/buy.dialog.tpl.html",
    "<md-dialog class=\"buy-dialog\">\n" +
    "    <form name=\"buyDialogForm\" ng-submit=\"buyDialogForm.$valid && vm.onSubmit()\">\n" +
    "        <md-dialog-content class=\"md-dialog-content\" layout=\"column\">\n" +
    "            <h3 class=\"md-title\">Comprar Plan</h3>\n" +
    "            <md-input-container>\n" +
    "                <label for=\"\">Plan</label>\n" +
    "                <md-select ng-change=\"vm.calculateDailyPlan(vm.shop.plan)\" ng-model=\"vm.shop.plan\" required name=\"plan\">\n" +
    "                    <md-option ng-repeat=\"plan in vm.plans\" ng-value=\"plan\">{{plan.name}}</md-option>\n" +
    "                </md-select>\n" +
    "                <div ng-messages=\"buyDialogForm.plan.$error\">\n" +
    "                    <div ng-message=\"required\">Debe de escojer un plan</div>\n" +
    "                </div>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container>\n" +
    "                <label for=\"\">Días</label>\n" +
    "                <input type=\"number\" pattern=\"[0-9]+\" ng-change=\"vm.calculateDailyPlan(vm.shop.plan)\" required ng-model=\"vm.shop.days\" min=\"1\"\n" +
    "                    step=\"1\" name=\"days\">\n" +
    "                <div ng-messages=\"buyDialogForm.days.$error\">\n" +
    "                    <div ng-message=\"required\">No olvides la cantidad de días</div>\n" +
    "                    <div ng-message=\"min\">Debe al menos tener (1) día</div>\n" +
    "                    <div ng-message=\"pattern\">Solo números enteros</div>\n" +
    "                </div>\n" +
    "                <p ng-if=\"buyDialogForm.days.$valid && vm.invalid   \" class=\"hint hint--direct hint--error\">No tienes suficiente balance</p>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container>\n" +
    "                <label for=\"\">¿A cual usuario aplicar?</label>\n" +
    "                <input type=\"text\" ng-model=\"vm.shop.applyTo\" ng-change=\"vm.searchUser(vm.shop.applyTo)\" ng-model-options=\"{debounce: 500}\">\n" +
    "                <p ng-show=\"vm.shop.applyTo && vm.userFound\" class=\"hint hint--direct\">Aplicar a: {{vm.userFound.displayName}}</p>\n" +
    "                <p ng-hide=\"vm.shop.applyTo\" class=\"hint hint--direct\">puedes dejarlo en blanco si es a tí mismo</p>\n" +
    "                <p ng-show=\"vm.shop.applyTo && !vm.userFound\" class=\"hint hint--direct\">Este usuario no existe</p>\n" +
    "            </md-input-container>\n" +
    "            <div class=\"summary\">\n" +
    "\n" +
    "                <p>Balance Actual:\n" +
    "                    <span>{{vm.user.balance | currency:'$':2}}</span>\n" +
    "                </p>\n" +
    "                <p>Costo:\n" +
    "                    <span>{{vm.cost | currency:'$':2}}</span>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </md-dialog-content>\n" +
    "        <md-dialog-actions>\n" +
    "            <md-button ng-click=\"vm.close()\">Cancelar</md-button>\n" +
    "            <md-button ng-disabled=\"vm.invalid\" class=\"md-raised md-primary\" type=\"submit\">Comprar</md-button>\n" +
    "        </md-dialog-actions>\n" +
    "    </form>\n" +
    "</md-dialog>");
}]);

angular.module("main/profile/card/profile-card.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/card/profile-card.tpl.html",
    "<md-dialog class=\"profile-card\">\n" +
    "    <md-dialog-content>\n" +
    "        <h3>Perfil de {{model.profile.displayName}}</h3>\n" +
    "\n" +
    "        <md-list>\n" +
    "            <md-list-item>\n" +
    "                <p>\n" +
    "                    <strong>Miembro desde:</strong>\n" +
    "                    {{model.profile.createdAt | date:'longDate'}}</p>\n" +
    "            </md-list-item>\n" +
    "            <md-divider></md-divider>\n" +
    "            <md-list-item>\n" +
    "                <p>\n" +
    "                    <strong>Plan:</strong>\n" +
    "                    <a href=\"#\">Gratis</a>\n" +
    "                </p>\n" +
    "            </md-list-item>\n" +
    "            <md-divider></md-divider>\n" +
    "            <md-list-item>\n" +
    "                <p>\n" +
    "                    <strong>Productos Eliminados:</strong>\n" +
    "                    25</p>\n" +
    "            </md-list-item>\n" +
    "        </md-list>\n" +
    "    </md-dialog-content>\n" +
    "\n" +
    "    <md-dialog-actions layout=\"row\" layout-align=\"space-between\">\n" +
    "        <md-button ng-click=\"model.close()\">Cerrar</md-button>\n" +
    "        <md-button ng-click=\"model.close()\" ui-sref=\"main.post.search({username:model.profile.username})\" class=\"md-raised md-primary\">Ver Productos</md-button>\n" +
    "    </md-dialog-actions>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/profile/change-password-dialog/change.password.dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/change-password-dialog/change.password.dialog.tpl.html",
    "<md-dialog class=\"change-password-dialog\">\n" +
    "    <md-toolbar class=\"md-small md-transparent\">\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <h3 flex>Cambio de Contraseña</h3>\n" +
    "            <md-button ng-click=\"vm.close()\" class=\"md-icon-button\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "            </md-button>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <form name=\"changePasswordForm\" ng-submit=\"changePasswordForm.$valid && vm.changePassword()\" novalidate>\n" +
    "        <md-dialog-content class=\"md-dialog-content\">\n" +
    "            <div class=\"input-containers-wrapper\" layout=\"row\" layout-wrap>\n" +
    "                <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "                    <label for=\"\">Contraseña Actual</label>\n" +
    "                    <input name=\"password\" required type=\"password\" ng-model=\"vm.current\">\n" +
    "                    <div ng-messages=\"changePasswordForm.password.$error\">\n" +
    "                        <div ng-message=\"required\">Debes escribir tu contraseña actual</div>\n" +
    "                    </div>\n" +
    "                </md-input-container>\n" +
    "                <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "                    <label for=\"\">Contraseña Nueva</label>\n" +
    "                    <input type=\"password\" required name=\"newPass\" ng-model=\"vm.password\">\n" +
    "                    <div ng-messages=\"changePasswordForm.newPass.$error\">\n" +
    "                        <div ng-message=\"required\">Debes escribir tu nueva contraseña</div>\n" +
    "                    </div>\n" +
    "                </md-input-container>\n" +
    "                <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "                    <label for=\"\">Confirmar Contraseña Nueva</label>\n" +
    "                    <input compare-to=\"vm.password\" name=\"confirm\" type=\"password\" ng-model=\"vm.confirmPassword\">\n" +
    "                    <div ng-messages=\"changePasswordForm.confirm.$error\">\n" +
    "                        <div ng-message=\"required\">Debes escribir tu nueva contraseña</div>\n" +
    "                        <div ng-message=\"compareTo\">Contraseñas no coinciden</div>\n" +
    "                    </div>\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "        </md-dialog-content>\n" +
    "        <md-dialog-actions>\n" +
    "            <md-button ng-click=\"vm.close()\">Cancelar</md-button>\n" +
    "            <md-button type=\"submit\" class=\"md-primary\">Cambiar</md-button>\n" +
    "        </md-dialog-actions>\n" +
    "    </form>\n" +
    "</md-dialog>");
}]);

angular.module("main/profile/chat/chat-detail.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/chat/chat-detail.tpl.html",
    "<md-content layout=\"column\" layout-wrap flex>\n" +
    "  <md-toolbar class=\"md-border\" ng-if=\"model.isDialog || model.isMobile\" ng-class=\"{'md-primary mobile-chat': model.isMobile}\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button class=\"md-icon-button\" ng-click=\"model.closeDialog()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <img em-src-image=\"model.chat.participants[0].picture\" thumbnail class=\"md-avatar\" alt=\"Carlos perez\" />\n" +
    "      <div class=\"md-toolbar-text\" layout=\"column\">\n" +
    "        <h3>{{model.chat.participants[0].displayName}}</h3>\n" +
    "        <!-- <a ng-show=\"model.chat.post\" ui-sref=\"main.post.detail({title:model.chat.post._id})\">{{model.chat.post.title}}</a> -->\n" +
    "      </div>\n" +
    "      <!--\n" +
    "      <span flex></span>\n" +
    "      <md-menu md-position-mode=\"target-right target\">\n" +
    "        <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <md-menu-content width=\"4\">\n" +
    "          <md-menu-item>\n" +
    "            <md-button>\n" +
    "              Info. del Usuario\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "          <md-menu-item>\n" +
    "            <md-button ui-sref=\"main.post.detail({title:model.chat.post._id})\">\n" +
    "              Ver Producto\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "          <md-divider></md-divider>\n" +
    "          <md-menu-item>\n" +
    "            <md-button>Bloquear\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "        </md-menu-content>\n" +
    "      </md-menu> -->\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content flex class=\"md-content__message-wrapper\">\n" +
    "    <md-subheader ng-if=\"model.chat.post\">\n" +
    "      <div layout=\"row\">\n" +
    "        <img em-src-image=\"model.chat.post.images[0]\" thumbnail />\n" +
    "        <div layout=\"column\" flex>\n" +
    "          <h4>{{model.chat.post.title}}</h4>\n" +
    "          <p>{{model.chat.post.prices.list | currency:model.chat.post.currency.symbol:2}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </md-subheader>\n" +
    "    <div class=\"chat__detail-message-wrapper\" flex layout=\"row\" layout-wrap ng-class=\"{'no-post':!model.chat.post}\">\n" +
    "      <div class=\"chat__detail-message__loading\" ng-if=\"model.isLoading\">\n" +
    "        <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n" +
    "        <p class=\"text-center md-subhead\">Cargando mensajes...</p>\n" +
    "      </div>\n" +
    "      <div ng-repeat=\"message in model.chat.messages | orderBy: 'createdAt'\" class=\"chat__detail-message\" ng-class=\"{'chat__detail-message--me':model.isMe(message.from)}\" flex=\"100\" layout=\"column\" layout-align=\"end end\" ng-show=\"!model.isLoading\" ng-if=\"message.type !== 'post'\">\n" +
    "        <div layout=\"row\">\n" +
    "          <!-- <img thumbnail em-src-image=\"model.getProfilePicture(message.from)\" alt=\"\" class=\"img--avatar\"> -->\n" +
    "          <p>\n" +
    "            {{message.body}}\n" +
    "            <span ng-if=\"!message.pending\">\n" +
    "              <small duration=\"message.createdAt\">{{message.createdAt}}</small>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </span>\n" +
    "            <span ng-if=\"message.pending\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "            </span>\n" +
    "          </p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "  <section class=\"chat__detail-message-filter\" layout=\"row\">\n" +
    "    <md-autocomplete md-autofocus ng-keypress=\"model.detectKey($event)\" md-search-text=\"model.message\" flex placeholder=\"Enviar mensaje\" md-items=\"i in []\"></md-autocomplete>\n" +
    "    <md-button class=\"md-icon-button\" ng-click=\"model.send()\">\n" +
    "      <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n" +
    "    </md-button>\n" +
    "  </section>\n" +
    "</md-content>\n" +
    "");
}]);

angular.module("main/profile/chat/chat.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/chat/chat.tpl.html",
    "<section flex class=\"chat\" layout=\"column\">\n" +
    "    <div layout=\"row\" flex ng-show=\"model.chats && model.chats.length > 0\">\n" +
    "        <div ng-show=\"model.showList\" flex flex-gt-sm=\"35\" layout=\"row\" class=\"chat__list\" layout-wrap>\n" +
    "            <section hide-xs hide-sm flex=\"100\" class=\"chat__list-filter\" layout=\"row\" layout-align=\"center center\">\n" +
    "                <md-input-container md-no-float class=\"clasic-input\">\n" +
    "                  <input type=\"text\" placeholder=\"Buscar chat\" ng-model=\"model.chatFilterText\">\n" +
    "                  <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "                </md-input-container>\n" +
    "            </section>\n" +
    "            <md-toolbar class=\"md-transparent md-border\">\n" +
    "              <div class=\"md-toolbar-tools\">\n" +
    "                <h3 flex class=\"md-title\">Conversaciones</h3>\n" +
    "                <em-search-button ng-model=\"model.chatFilterText\"></em-search-button>\n" +
    "              </div>\n" +
    "            </md-toolbar>\n" +
    "            <md-list flex>\n" +
    "                <md-list-item class=\"md-2-line\" ui-sref-opts=\"model.transitionOption\" ui-sref=\"main.profile.chat.detail({id:chat._id, chat:chat})\" ng-repeat-start=\"chat in model.chats | filter:model.chatFilterText\" ng-class=\"{selected: chat._id === model.currenChat._id}\">\n" +
    "                    <img em-src-image=\"chat.participants[0].picture\" thumbnail class=\"md-avatar\" alt=\"{{chat.participants[0].displayName}}\"/>\n" +
    "                    <div class=\"md-list-item-text\">\n" +
    "                        <h3>{{chat.participants[0].displayName}}</h3>\n" +
    "                        <p ng-if=\"chat.lastMessage\">\n" +
    "                            {{chat.lastMessage.body}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                    <p ng-show=\"chat.unread[model.user._id] && chat.unread[model.user._id] > 0\" class=\"md-secondary\">{{chat.unread[model.user._id]}}</p>\n" +
    "                </md-list-item>\n" +
    "                <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "            </md-list>\n" +
    "        </div>\n" +
    "        <div ng-show=\"model.showDetail\" flex class=\"chat__detail\" layout=\"row\">\n" +
    "            <ui-view name=\"chat\" layout=\"row\" flex>\n" +
    "              <div flex class=\"missing-chat-message\">\n" +
    "                  <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "                    <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "                      <md-icon md-svg-src=\"assets/inbox-full.svg\"></md-icon>\n" +
    "                      <h4>Tienes mensajes nuevos!</h4>\n" +
    "                      <p class=\"md-subhead\">\n" +
    "                        Para ver los mensajes que te han escrito, has clic en cualquiera de los chats\n" +
    "                      </p>\n" +
    "                    </div>\n" +
    "                  </md-content>\n" +
    "              </div>\n" +
    "            </ui-view>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div flex class=\"missing-chat-message\" ng-if=\"model.chats.length === 0\">\n" +
    "        <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "          <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "            <md-icon md-svg-src=\"assets/inbox.svg\"></md-icon>\n" +
    "            <h4>Tu bandeja de mensajes esta vacia</h4>\n" +
    "            <p class=\"md-subhead\">\n" +
    "              No te desanimes... tan pronto recibas un mensaje te notificaremos\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </md-content>\n" +
    "    </div>\n" +
    "</section>\n" +
    "");
}]);

angular.module("main/profile/chat/dialog/chat-dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/chat/dialog/chat-dialog.tpl.html",
    "<md-dialog class=\"chat chat-dialog\" layout=\"column\" >\n" +
    "    <div flex layout=\"column\" class=\"chat__detail\" ng-include=\"'main/profile/chat/chat-detail.tpl.html'\">\n" +
    "\n" +
    "    </div>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/profile/detail/detail.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/detail/detail.tpl.html",
    "<h3>Perfil</h3>\n" +
    "");
}]);

angular.module("main/profile/edit-dialog/edit-dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit-dialog/edit-dialog.tpl.html",
    "<md-dialog flex-gt-sm=\"70\" flex=\"95\" class=\"edit-profile-dialog\">\n" +
    "    <form layout=\"column\" layout-wrap-gt-sm ng-submit=\"model.save()\" flex>\n" +
    "      <md-toolbar class=\"md-white md-border\" hide-gt-sm>\n" +
    "          <div class=\"md-toolbar-tools\">\n" +
    "              <md-button class=\"md-icon-button\" ng-click=\"model.cancel()\">\n" +
    "                  <md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>\n" +
    "              </md-button>\n" +
    "              <span flex></span>\n" +
    "              <md-button ngf-select ngf-drop ngf-fix-orientation=\"true\" ng-model=\"model.file\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\">Cambiar Imagen</md-button>\n" +
    "              <em-button hide-gt-sm type=\"submit\" class=\" md-icon-button md-accent\" loading=\"model.isLoading\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-save\"></md-icon>\n" +
    "                <md-tooltip>Guardar Cambios</md-tooltip>\n" +
    "              </em-button>\n" +
    "          </div>\n" +
    "      </md-toolbar>\n" +
    "        <div layout=\"row\" class=\"profile-edition-container\" layout-wrap flex>\n" +
    "\n" +
    "\n" +
    "        <div class=\"image-container\" flex=\"30\" flex-sm=\"100\" flex-xs=\"100\">\n" +
    "            <md-toolbar class=\"md-white md-border\" hide-sm hide-xs>\n" +
    "                <div class=\"md-toolbar-tools\">\n" +
    "                    <md-button class=\"md-icon-button\" ng-click=\"model.cancel()\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>\n" +
    "                    </md-button>\n" +
    "                    <span flex></span>\n" +
    "                    <md-button ngf-select ngf-drop ngf-fix-orientation=\"true\" ng-model=\"model.file\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\">Cambiar Imagen</md-button>\n" +
    "                    <em-button hide-gt-sm type=\"submit\" class=\" md-icon-button md-accent\" loading=\"model.isLoading\">\n" +
    "                      <md-icon md-font-icon=\"zmdi zmdi-save\"></md-icon>\n" +
    "                      <md-tooltip>Guardar Cambios</md-tooltip>\n" +
    "                    </em-button>\n" +
    "                </div>\n" +
    "            </md-toolbar>\n" +
    "            <img md-whiteframe=\"1\" class=\"img--rounded img--center profile__picture\" square em-src-image=\"model.user.picture.path\"/>\n" +
    "\n" +
    "            <h3 class=\"md-headline text-center\">{{model.user.displayName}}</h3>\n" +
    "        </div>\n" +
    "        <div class=\"form-modification\" flex flex-xs=\"100\" flex-sm=\"100\">\n" +
    "          <md-toolbar class=\"md-transparent\">\n" +
    "            <div class=\"md-toolbar-tools\">\n" +
    "              <h3 flex class=\"md-title\" ng-if=\"!model.user.plan.product.characteristics.store\">Modificar Perfil</h3>\n" +
    "              <md-tabs md-stretch-tabs=\"auto\" md-selected=\"currentTab\" flex ng-show=\"model.user.plan.product.characteristics.store\">\n" +
    "                <md-tab>\n" +
    "                  <md-tab-label>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> Perfil\n" +
    "                  </md-tab-label>\n" +
    "                </md-tab>\n" +
    "                <md-tab>\n" +
    "                  <md-tab-label>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-store\"></md-icon> Mi Tienda\n" +
    "                  </md-tab-label>\n" +
    "                </md-tab>\n" +
    "              </md-tabs>\n" +
    "\n" +
    "              <em-button hide-sm hide-xs type=\"submit\" class=\"md-raised md-primary\" loading=\"model.isLoading\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-save\"></md-icon> Guardar Cambios</em-button>\n" +
    "            </div>\n" +
    "          </md-toolbar>\n" +
    "            <md-card>\n" +
    "\n" +
    "                <md-tabs flex=\"100\" md-dynamic-height md-selected=\"currentTab\" class=\"noTabPanel\">\n" +
    "                  <md-tab label=\"Perfil\">\n" +
    "                    <md-card-content layout=\"row\" layout-padding layout-wrap>\n" +
    "                        <md-input-container flex=\"50\">\n" +
    "                            <label>Nombre</label>\n" +
    "                            <input type=\"text\" ng-model=\"model.user.displayName\">\n" +
    "                        </md-input-container>\n" +
    "                        <md-input-container flex=\"50\">\n" +
    "                            <label>Provincia</label>\n" +
    "                            <md-select ng-model=\"model.user.address.city\">\n" +
    "                                <md-option ng-value=\"city._id\" ng-repeat=\"city in model.provinces\">{{city.name}}</md-option>\n" +
    "                            </md-select>\n" +
    "                        </md-input-container>\n" +
    "                        <md-input-container flex=\"50\">\n" +
    "                            <label>Usuario</label>\n" +
    "                            <input type=\"text\" ng-model=\"model.user.username\" disabled=\"\">\n" +
    "                        </md-input-container>\n" +
    "                        <md-input-container flex=\"50\">\n" +
    "                            <label>Address</label>\n" +
    "                            <input type=\"text\" ng-model=\"model.user.address.address\">\n" +
    "                        </md-input-container>\n" +
    "                        <p flex=\"100\" class=\"md-subhead\">Cuentas de Correo</p>\n" +
    "                        <div class=\"contact-container\" ng-repeat=\"email in model.user.emails\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"end start\">\n" +
    "                            <md-button ng-click=\"model.removeEmail($index)\" class=\"md-icon-button\" ng-if=!$first>\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                            </md-button>\n" +
    "                            <md-input-container flex=\"70\">\n" +
    "                                <label>Cuenta</label>\n" +
    "                                <input type=\"email\" ng-model=\"email.email\">\n" +
    "                                <!-- <p ng-show=\"$last\" class=\"hint hint--inverse hint--direct\">\n" +
    "                                    <a ng-click=\"model.addEmptyEmail()\" href>Agregar otro correo eléctronico</a>\n" +
    "                                </p> -->\n" +
    "                            </md-input-container>\n" +
    "                            <md-button ng-if=\"email.status !== 'validated'\" class=\"md-button--fixed-height md-button--form\">Validar</md-button>\n" +
    "                            <p class=\"contact-validated md-subhead\" ng-if=\"email.status === 'validated'\">\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                                Validado\n" +
    "                                <md-tooltip md-delay=\"500\">Este correo ya ha sido validado</md-tooltip>\n" +
    "                            </p>\n" +
    "                        </div>\n" +
    "                        <p flex=\"100\" class=\"md-subhead\">Números de Telefono</p>\n" +
    "                        <div class=\"contact-container\" ng-repeat=\"phone in model.user.phones\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"end start\">\n" +
    "                            <md-button ng-click=\"model.removePhone($index)\" class=\"md-icon-button\" ng-if=!$first>\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                            </md-button>\n" +
    "\n" +
    "                            <md-input-container flex>\n" +
    "                                <label>Tipo</label>\n" +
    "                                <md-select ng-model=\"phone.type\">\n" +
    "\n" +
    "                                    <md-option value=\"mobile\">Celular</md-option>\n" +
    "                                    <md-option value=\"home\">Casa</md-option>\n" +
    "                                    <md-option value=\"work\">Trabajo</md-option>\n" +
    "                                </md-select>\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"40\">\n" +
    "                                <label>Número</label>\n" +
    "                                <input type=\"tel\" ng-model=\"phone.number\">\n" +
    "                                <p ng-show=\"$last\" class=\"hint hint--inverse hint--direct\">\n" +
    "                                    <a ng-click=\"model.addEmptyPhone()\" href>Agregar otro número telefonico</a>\n" +
    "                                </p>\n" +
    "                            </md-input-container>\n" +
    "                            <md-button ng-click=\"model.validate(phone)\" ng-if=\"phone.status !== 'validated'\" class=\"md-button--fixed-height md-button--form\">Validar</md-button>\n" +
    "                            <p class=\"contact-validated md-subhead\" ng-if=\"phone.status === 'validated'\">\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "                                Validado\n" +
    "                                <md-tooltip md-delay=\"500\">Este número ya ha sido validado</md-tooltip>\n" +
    "                            </p>\n" +
    "                        </div>\n" +
    "                    </md-card-content>\n" +
    "                  </md-tab>\n" +
    "                  <md-tab label=\"Tienda\">\n" +
    "                      <md-card-content>\n" +
    "                        <md-content layout=\"row\" layout-wrap flex=\"100\" flex>\n" +
    "                          <md-subheader flex=\"100\">Información Básica</md-subheader>\n" +
    "                          <md-input-container flex=\"100\">\n" +
    "                              <label>Descripción de la tienda</label>\n" +
    "                              <textarea ng-model=\"model.user.store.description\"></textarea>\n" +
    "                              <span class=\"hint\">Es una pequeña descripcion, se breve</span>\n" +
    "                          </md-input-container>\n" +
    "                            <md-input-container flex=\"100\">\n" +
    "                                <label>Politica de compra</label>\n" +
    "                                <textarea ng-model=\"model.user.store.policy\"></textarea>\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"100\">\n" +
    "                                <label>Sobre Nosotros</label>\n" +
    "                                <textarea ng-model=\"model.user.store.about\"></textarea>\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"100\">\n" +
    "                                <label>Categorias de la tienda</label>\n" +
    "                                <md-select multiple ng-model=\"model.user.store.categories\" ng-model-options=\"{trackBy: '$value._id'}\">\n" +
    "                                  <md-option ng-repeat=\"category in model.categories\" ng-value=\"category\">{{category.name}}</md-option>\n" +
    "                                </md-select>\n" +
    "                            </md-input-container>\n" +
    "\n" +
    "\n" +
    "\n" +
    "                            <md-subheader flex=\"100\">Publicidad Principal</md-subheader>\n" +
    "                            <md-input-container flex=\"60\">\n" +
    "                                <label>Título</label>\n" +
    "                                <input type=\"text\" ng-model=\"model.user.store.cover.title\" />\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"40\">\n" +
    "                                <label>Subtitulo</label>\n" +
    "                                <input type=\"text\" ng-model=\"model.user.store.cover.subtitle\" />\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"80\">\n" +
    "                                <label>Descripción</label>\n" +
    "                                <input type=\"text\" ng-model=\"model.user.store.cover.description\" />\n" +
    "                            </md-input-container>\n" +
    "                            <md-button class=\"md-raised store-cover__image-upload\" flex ngf-select ngf-change=\"model.uploadStoreCoverPicture(model.storeCoverPicture)\" ng-model=\"model.storeCoverPicture\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\">Agregar Imagen</md-button>\n" +
    "                            <md-input-container flex=\"60\">\n" +
    "                                <label>Categoria</label>\n" +
    "                                <md-select ng-model=\"model.user.store.cover.category\" ng-model-options=\"{trackBy: '$value._id'}\">\n" +
    "                                  <md-option ng-repeat=\"category in model.categories\" ng-value=\"category\">{{category.name}}</md-option>\n" +
    "                                </md-select>\n" +
    "                            </md-input-container>\n" +
    "                            <md-input-container flex=\"40\">\n" +
    "                                <label>Titulo Boton</label>\n" +
    "                                <input type=\"text\" ng-model=\"model.user.store.cover.buttonTitle\" />\n" +
    "                            </md-input-container>\n" +
    "                        </md-content>\n" +
    "                      </md-card-content>\n" +
    "                  </md-tab>\n" +
    "                </md-tabs>\n" +
    "            </md-card>\n" +
    "        </div>\n" +
    "          </div>\n" +
    "    </form>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/profile/edit-dialog/phone-validation-dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit-dialog/phone-validation-dialog.tpl.html",
    "<md-dialog>\n" +
    "    <form name=\"validationform\" novalidate>\n" +
    "        <md-dialog-content class=\"md-dialog-content\">\n" +
    "            <h2 class=\"md-title\">Codigo de validación</h2>\n" +
    "            <div class=\"md-dialog-content-body\">\n" +
    "                <p>Llegará una llamada al número proporcionado, por favor inserte el codigo que escuche en la llamada</p>\n" +
    "            </div>\n" +
    "            <md-input-container class=\"md-prompt-input-container\">\n" +
    "                <label>Codigo de validación</label>\n" +
    "                <input required type=\"text\" ng-model=\"model.code\" name=\"code\">\n" +
    "                <div ng-messages=\"validationform.code.$error\">\n" +
    "                    <div ng-message=\"required\">No olvides escribir el codigo de validación</div>\n" +
    "                </div>\n" +
    "            </md-input-container>\n" +
    "        </md-dialog-content>\n" +
    "        <md-dialog-actions>\n" +
    "            <md-button>Cerrar</md-button>\n" +
    "            <span flex></span>\n" +
    "            <md-button>Reenviar Codigo</md-button>\n" +
    "            <md-button type=\"submit\" class=\"md-primary\">Validar</md-button>\n" +
    "        </md-dialog-actions>\n" +
    "    </form>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/profile/edit/main.advertising.panel.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit/main.advertising.panel.tpl.html",
    "<div layout=\"column\">\n" +
    "  <md-toolbar class=\"md-toolbar--simple\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h3 flex>Publicidad Principal</h3>\n" +
    "      <md-button class=\"md-icon-button\" ng-click=\"vm.dismiss()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content layout-padding>\n" +
    "    <div ng-include=\"'main/profile/edit/main.advertising.tpl.html'\" layout=\"row\" layout-wrap></div>\n" +
    "    <div layout=\"row\">\n" +
    "      <md-button ng-click=\"vm.close()\" class=\"md-raised md-primary md-large\">Guardar Publicidad</md-button>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/profile/edit/main.advertising.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit/main.advertising.tpl.html",
    "<div class=\"cover-picture\" flex-gt-sm=\"30\" flex=\"100\">\n" +
    "  <md-icon md-font-icon=\"zmdi zmdi-image\" ng-if=\"!vm.user.store.cover.image\"></md-icon>\n" +
    "  <img em-src-image=\"vm.user.store.cover.image\"  thumbnail ng-if=\"vm.user.store.cover.image\" alt=\"\">\n" +
    "  <md-button ngf-select ngf-change=\"vm.uploadStoreCoverPicture(vm.storeCoverPicture)\" ng-model=\"vm.storeCoverPicture\" ngf-accept=\"'image/*'\" ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\">Cambiar Imagen</md-button>\n" +
    "</div>\n" +
    "<div class=\"cover-form\"flex=\"100\"  layout=\"row\" flex-gt-sm=\"70\" layout-wrap >\n" +
    "  <md-input-container class=\"clasic-input\" flex-gt-sm=\"50\" flex=\"100\">\n" +
    "    <label>Título</label>\n" +
    "    <input type=\"text\" ng-model=\"vm.user.store.cover.title\">\n" +
    "  </md-input-container>\n" +
    "  <md-input-container class=\"clasic-input\" flex-gt-sm=\"50\" flex=\"100\">\n" +
    "    <label>Subtitulo</label>\n" +
    "    <input type=\"text\" ng-model=\"vm.user.store.cover.subtitle\">\n" +
    "  </md-input-container>\n" +
    "  <md-input-container class=\"clasic-input\" flex-gt-sm=\"50\" flex=\"100\">\n" +
    "    <label>Categoría</label>\n" +
    "    <md-select ng-model=\"vm.user.store.cover.category\" ng-model-options=\"{trackBy: '$value._id'}\">\n" +
    "      <md-option ng-repeat=\"category in vm.categories\" ng-value=\"category\">{{category.name}}</md-option>\n" +
    "    </md-select>\n" +
    "  </md-input-container>\n" +
    "  <md-input-container class=\"clasic-input\" flex-gt-sm=\"50\" flex=\"100\">\n" +
    "    <label>Texto del Botón</label>\n" +
    "    <input type=\"text\" ng-model=\"vm.user.store.cover.buttonTitle\">\n" +
    "  </md-input-container>\n" +
    "  <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "    <label>Descripción</label>\n" +
    "    <textarea rows=\"3\" ng-model=\"vm.user.store.cover.description\"></textarea>\n" +
    "  </md-input-container>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/profile/edit/profile-edit.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit/profile-edit.tpl.html",
    "<div class=\"profile-edition\" flex>\n" +
    "  <form ng-submit=\"vm.save()\" name=\"profileEditForm\">\n" +
    "    <md-toolbar class=\"md-white md-small md-border\">\n" +
    "      <div class=\"md-toolbar-tools\">\n" +
    "        <md-tabs flex md-selected=\"vm.currentItem\" md-stretch-tabs=\"always\">\n" +
    "          <md-tab label=\"Mi Perfil\"></md-tab>\n" +
    "          <md-tab label=\"Mi Tienda\"></md-tab>\n" +
    "        </md-tabs>\n" +
    "        <em-button hide-xs hide-sm class=\"md-raised md-primary\" loading-text=\"'Guardando...'\" is-loading=\"vm.loading\" type=\"submit\">Guardar</em-button>\n" +
    "      </div>\n" +
    "    </md-toolbar>\n" +
    "    <div layout-padding>\n" +
    "      <md-tabs class=\"no-tab-panel\" md-selected=\"vm.currentItem\" md-dynamic-height>\n" +
    "        <md-tab label=\"Mi Perfil\">\n" +
    "          <md-content class=\"md-transparent\" layout-wrap layout=\"row\">\n" +
    "            <md-input-container flex=\"100\" flex-gt-sm=\"50\" class=\"clasic-input\" class=\"clasic-input\">\n" +
    "              <label>Nombre</label>\n" +
    "              <input ng-model=\"vm.user.displayName\" />\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex=\"100\" flex-gt-sm=\"50\" class=\"clasic-input\">\n" +
    "              <label>Provincia</label>\n" +
    "              <md-select ng-model=\"vm.user.address.province\">\n" +
    "                <md-option ng-repeat=\"province in vm.provinces\" ng-value=\"province._id\">{{province.name}}</md-option>\n" +
    "              </md-select>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex=\"100\" flex-gt-sm=\"33\" class=\"clasic-input\">\n" +
    "              <label>Usuario</label>\n" +
    "              <input disabled ng-model=\"vm.user.username\" />\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex=\"100\" flex-gt-sm=\"33\" class=\"clasic-input\">\n" +
    "              <label>Contraseña</label>\n" +
    "              <input disabled ng-model=\"vm.password\" value=\"*********\" type=\"password\" />\n" +
    "              <md-button class=\"md-small\" ng-click=\"vm.showChangePasswordDialog()\">Cambiar</md-button>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex=\"100\" flex-gt-sm=\"33\" class=\"clasic-input\">\n" +
    "              <label>Direccion</label>\n" +
    "              <input type=\"text\" ng-model=\"vm.user.address.street\" />\n" +
    "            </md-input-container>\n" +
    "            <p class=\"md-subhead\">Datos de Contacto</p>\n" +
    "            <md-input-container flex=\"100\" class=\"clasic-input\">\n" +
    "              <label>Correo Eléctronico</label>\n" +
    "              <input type=\"email\" ng-model=\"vm.user.emails[0].email\" />\n" +
    "            </md-input-container>\n" +
    "            <p flex=\"100\" class=\"md-subhead\">Agregar número de teléfono</p>\n" +
    "            <md-input-container flex=\"30\" class=\"clasic-input\">\n" +
    "              <label>Tipo</label>\n" +
    "              <md-select ng-model=\"vm.phone.type\" ng-change=\"vm.showPhoneTypeError=false\">\n" +
    "                <md-option class=\"capitalize-text\" ng-repeat=\"phoneType in vm.phoneTypes\" value=\"{{phoneType}}\">{{phoneType | translate}}</md-option>\n" +
    "              </md-select>\n" +
    "              <div ng-if=\"vm.showPhoneTypeError\" class=\"md-input-messages-animation md-auto-hide ng-active\" aria-live=\"assertive\">\n" +
    "                <div class=\"md-input-message-animation ng-scope\" style=\"opacity: 1; margin-top: 0px;\">Debe de elegir el tipo de teléfono</div>\n" +
    "              </div>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex class=\"clasic-input\">\n" +
    "              <label>Número</label>\n" +
    "              <input type=\"tel\" name=\"phoneNumber\" ng-model=\"vm.phone.number\" pattern=\"8[024]9\\d{7}\" ng-keyup=\"$event.keyCode === 13 && vm.addPhone()\"\n" +
    "              />\n" +
    "              <div ng-messages=\"profileEditForm.phoneNumber.$error\">\n" +
    "                <div ng-message=\"pattern\">Número invalido, recuerda no agregar guiones(-) ni otros carácteres ej.8095452222</div>\n" +
    "              </div>\n" +
    "            </md-input-container>\n" +
    "            <md-button ng-click=\"vm.addPhone()\" class=\"md-raised md-primary md-button--fixed-height\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>Agregar\n" +
    "            </md-button>\n" +
    "            <div class=\"phones\" flex=\"100\">\n" +
    "              <div class=\"phone-container\" flex=\"100\" flex-gt-sm=\"50\" ng-repeat=\"phone in vm.user.phones\">\n" +
    "                <div class=\"phone\" ng-class=\"{'phone__status-pending': phone.status === 'unvalidated', 'phone__status-active': phone.status === 'validated'}\">\n" +
    "                  <div class=\"phone__header\">\n" +
    "                    <md-menu>\n" +
    "                      <md-button ng-click=\"$mdMenu.open($event)\" class=\"dropdown-button\">\n" +
    "                        {{phone.type | translate}}\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n" +
    "                      </md-button>\n" +
    "                      <md-menu-content>\n" +
    "                        <md-menu-item ng-click=\"phone.type = phoneType\" ng-repeat=\"phoneType in vm.phoneTypes\">\n" +
    "                          <md-button class=\"capitalize-text\">{{phoneType | translate}}</md-button>\n" +
    "                        </md-menu-item>\n" +
    "                      </md-menu-content>\n" +
    "                    </md-menu>\n" +
    "                    <md-button ng-click=\"vm.removePhone($index)\" class=\"md-icon-button md-warn\">\n" +
    "                      <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "                    </md-button>\n" +
    "                  </div>\n" +
    "                  <div class=\"phone__content\">\n" +
    "                    <div class=\"phone__content__icon\">\n" +
    "                      <md-icon ng-if=\"phone.type === vm.phone.types.WORK  || phone.type === vm.phoneTypes.HOME\" md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n" +
    "                      <md-icon ng-if=\"phone.type === vm.phoneTypes.MOBILE\" md-font-icon=\"zmdi zmdi-smartphone-android\"></md-icon>\n" +
    "                    </div>\n" +
    "                    <div class=\"phone__content__detail\" flex>\n" +
    "                      <div class=\"phone__content__number\">\n" +
    "                        <h4>{{phone.number}}</h4>\n" +
    "                      </div>\n" +
    "                      <div class=\"phone__content__status\">\n" +
    "                        <p class=\"md-subhead\" ng-if=\"phone.status === vm.phoneStatus.VALIDATED\">\n" +
    "                          <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>Validado</p>\n" +
    "                        <p class=\"md-subhead\" ng-if=\"phone.status === vm.phoneStatus.UNVALIDATED\">Pendiente</p>\n" +
    "                        <md-button ng-click=\"vm.validatePhone(phone)\" ng-if=\"phone.status === 'unvalidated'\" class=\"md-small\">Validar ahora</md-button>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </md-content>\n" +
    "        </md-tab>\n" +
    "        <md-tab label=\"Mi Tienda\">\n" +
    "          <md-content class=\"md-transparent profile__store\" layout-wrap layout=\"row\">\n" +
    "            <p class=\"md-subhead\">Información Básica</p>\n" +
    "            <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "              <label>Categorías de la tienda</label>\n" +
    "              <md-select multiple ng-model=\"vm.user.store.categories\">\n" +
    "                <md-option ng-repeat=\"category in vm.categories\" ng-value=\"category._id\">{{category.name}}</md-option>\n" +
    "              </md-select>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "              <label>Descripción de la tienda</label>\n" +
    "              <textarea rows=\"3\" ng-model=\"vm.user.store.description\"></textarea>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container class=\"clasic-input\" flex=\"100\" flex-gt-sm=\"50\">\n" +
    "              <label>Sobre Nosotros</label>\n" +
    "              <textarea ng-model=\"vm.user.store.about\" rows=\"3\"></textarea>\n" +
    "            </md-input-container>\n" +
    "            <md-input-container class=\"clasic-input\" flex=\"100\" flex-gt-sm=\"50\">\n" +
    "              <label>Politica de Compra</label>\n" +
    "              <textarea rows=\"3\" ng-model=\"vm.user.store.policy\"></textarea>\n" +
    "            </md-input-container>\n" +
    "            <p class=\"md-subhead\" flex=\"100\">Publicidad principal</p>\n" +
    "            <div layout=\"row\" flex=\"100\" layout-wrap>\n" +
    "              <md-button hide-gt-sm class=\"md-large md-raised\" ng-click=\"vm.showMainAdvertising()\">Modificar Publicidad Principal</md-button>\n" +
    "              <div hide-xs hide-sm layout=\"row\" flex=\"100\" layout-wrap ng-include=\"'main/profile/edit/main.advertising.tpl.html'\"></div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <p class=\"md-subhead\" flex=\"100\">Redes Sociales</p>\n" +
    "            <div layout=\"row\" flex=\"100\">\n" +
    "              <md-input-container class=\"clasic-input\" flex=\"100\" flex-gt-sm=\"33\">\n" +
    "                <label>Facebook</label>\n" +
    "                <input rows=\"3\" ng-model=\"vm.user.store.socialNetworks.facebook\"></input>\n" +
    "              </md-input-container>\n" +
    "              <md-input-container class=\"clasic-input\" flex=\"100\" flex-gt-sm=\"33\">\n" +
    "                <label>Twitter</label>\n" +
    "                <input rows=\"3\" ng-model=\"vm.user.store.socialNetworks.twitter\"></input>\n" +
    "              </md-input-container>\n" +
    "              <md-input-container class=\"clasic-input\" flex=\"100\" flex-gt-sm=\"33\">\n" +
    "                <label>Instagram</label>\n" +
    "                <input rows=\"3\" ng-model=\"vm.user.store.socialNetworks.instagram\"></input>\n" +
    "              </md-input-container>\n" +
    "            </div>\n" +
    "          </md-content>\n" +
    "        </md-tab>\n" +
    "      </md-tabs>\n" +
    "      <div layout=\"row\">\n" +
    "        <em-button hide-gt-sm class=\"md-raised md-primary md-large\" loading-text=\"'Guardando...'\" is-loading=\"vm.loading\" type=\"submit\">Guardar Cambios</em-button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("main/profile/edit/profile.edit.image.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit/profile.edit.image.tpl.html",
    "<section class=\"profile\" flex layout=\"row\" layout-align=\"center\">\n" +
    "  <div class=\"profile-container\" layout=\"row\" flex=\"80\">\n" +
    "    <div class=\"profile__user\" flex=\"30\" layout=\"column\">\n" +
    "      <md-card class=\"profile__basic-info\">\n" +
    "        <md-card-content>\n" +
    "          <img em-src-image=\"model.user.picture\" square class=\"img--rounded\" />\n" +
    "          <h3 class=\"md-headline\">{{model.user.displayName}}</h3>\n" +
    "          <p class=\"md-subhead\">({{model.user.username}})</p>\n" +
    "          <md-button ui-sref=\"main.profile.edit\" class=\"md-primary md-raised\">\n" +
    "            Editar Perfil\n" +
    "          </md-button>\n" +
    "        </md-card-content>\n" +
    "      </md-card>\n" +
    "    </div>\n" +
    "    <md-card class=\"profile__navigation\" flex layout=\"column\">\n" +
    "        <div hide-sm hide-xs  ng-hide=\"model.hideNavBar\">\n" +
    "          <md-nav-bar md-selected-nav-item=\"model.currentNavItem\" nav-bar-aria-label=\"navigation links\">\n" +
    "            <md-nav-item md-nav-sref=\"main.profile.products\" name=\"main.profile.products\">Productos</md-nav-item>\n" +
    "            <md-nav-item md-nav-sref=\"main.profile.chat\" name=\"main.profile.chat\">Mensajes</md-nav-item>\n" +
    "            <md-nav-item md-nav-sref=\"main.profile.favorite.post\" name=\"main.profile.favorite.post\">Productos Favoritos</md-nav-item>\n" +
    "            <md-nav-item md-nav-sref=\"main.profile.favorite.seller\" name=\"main.profile.favorite.seller\">Tiendas Favoritos</md-nav-item>\n" +
    "\n" +
    "          </md-nav-bar>\n" +
    "          <md-divider></md-divider>\n" +
    "        </div>\n" +
    "        <ui-view name=\"profile\" class=\"profile-ui-view\" layout=\"row\" layout-align=\"start start\" flex></ui-view>\n" +
    "    </md-card>\n" +
    "  </div>\n" +
    "</section>\n" +
    "");
}]);

angular.module("main/profile/edit/profile.edit.phone.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/edit/profile.edit.phone.tpl.html",
    "<div class=\"profile__edit__phone\" layout=\"column\" flex>\n" +
    "  <md-toolbar class=\"md-toolbar__simple\" hide-gt-sm>\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button ng-show=\"vm.selectedIndex=== 1\" class=\"toolbar__back-button\" ng-click=\"vm.selectedIndex = 0\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <h3 flex>Número Teléfonico</h3>\n" +
    "      <md-button class=\"md-icon-button\" ui-sref=\"main.post.create\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n" +
    "      </md-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-tabs class=\"no-tab-panel\" flex md-selected=\"vm.selectedIndex\">\n" +
    "    <md-tab label=\"Insertar numero\">\n" +
    "      <md-content class=\"md-transparent\">\n" +
    "        <div class=\"text-container\" flex>\n" +
    "          <md-icon class=\"profile__edit__phone__art\" md-svg-src=\"assets/phone-validation.svg\"></md-icon>\n" +
    "          <p class=\"text-center\">\n" +
    "            <!-- Tu seguridad es importante para nosotros valida tu número de teléfono ahora -->\n" +
    "            Agrega un número de teléfono para que tus compradores se comuniquen contigo\n" +
    "          </p>\n" +
    "        </div>\n" +
    "        <form ng-submit=\"phoneValidationForm.$valid && vm.addPhone()\" novalidate name=\"phoneValidationForm\" class=\"phone-container\">\n" +
    "          <p class=\"maintext\">Número de teléfono</p>\n" +
    "          <div class=\"phone\" layout=\"row\">\n" +
    "            <md-input-container class=\"clasic-input\" md-no-float>\n" +
    "\n" +
    "              <md-select ng-model=\"vm.phone.type\" required name=\"phoneType\" placeholder=\"Tipo\">\n" +
    "                <md-option ng-value=\"phoneType\" ng-repeat=\"phoneType in vm.phoneTypes\">{{phoneType | translate}}</md-option>\n" +
    "              </md-select>\n" +
    "\n" +
    "            </md-input-container>\n" +
    "            <md-input-container flex class=\"clasic-input\" md-no-float>\n" +
    "\n" +
    "              <input ng-model=\"vm.phone.number\" required type=\"tel\" pattern=\"8[024]9\\d{7}\" name=\"phone\" placeholder=\"Número\" />\n" +
    "              <div ng-messages=\"phoneValidationForm.phone.$error\">\n" +
    "                <div ng-message=\"required\">Escribe un número teléfonico valido</div>\n" +
    "                <div ng-message=\"pattern\">Agregue un número sin guión \"-\" ni \"1\" ej: 8095554444</div>\n" +
    "              </div>\n" +
    "            </md-input-container>\n" +
    "          </div>\n" +
    "          <p hide class=\"subtext\" ng-show=\"phoneValidationForm.$valid\">Nuestro sistema te llamará en breve...</p>\n" +
    "          <em-button type=\"submit\" class=\"md-raised md-primary md-large\" is-loading=\"vm.loading.saving\" loading-text=\"'Llamando...'\">\n" +
    "            Guardar Número\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "          </em-button>\n" +
    "        </form>\n" +
    "      </md-content>\n" +
    "    </md-tab>\n" +
    "    <md-tab label=\"no insertar\">\n" +
    "      <form class=\"full\" ng-submit=\"phoneCodeValidation.$valid && vm.makePhoneValidation()\" name=\"phoneCodeValidation\" novalidate>\n" +
    "        <md-content class=\"md-transparent\">\n" +
    "          <div class=\"profil__edit__phone__code\" layout=\"column\" layout-align=\"start center\">\n" +
    "            <div class=\"text-container\" flex>\n" +
    "              <md-icon class=\"profile__edit__phone__art\" md-svg-src=\"assets/phone-validation-ring.svg\"></md-icon>\n" +
    "              <div class=\"input-wrapper\" layout=\"row\">\n" +
    "                <md-input-container flex ng-hide=\"vm.loading.validating\" md-no-float class=\"clasic-input\">\n" +
    "                  <input type=\"number\" required ng-model=\"vm.validationCode\" name=\"code\" maxlength=\"4\" placeholder=\"Inserte su Código\">\n" +
    "                  <div class=\"hint hint--error\" ng-if=\"vm.error\">{{vm.error}}</div>\n" +
    "                  <div ng-messages=\"phoneCodeValidation.code.$error\">\n" +
    "                    <div ng-message=\"required\">Digite los 4 numero que le proporcionaron en la llamada</div>\n" +
    "                  </div>\n" +
    "\n" +
    "                </md-input-container>\n" +
    "              </div>\n" +
    "              <md-button class=\"link__button md-primary\" ng-show=\"vm.showCallAgain\">Llamar nuevamente</md-button>\n" +
    "              <p class=\"text-center\">Por favor introduzca los número que le fueron suministrados en la llamada.</p>\n" +
    "            </div>\n" +
    "            <div class=\"phone-container\">\n" +
    "              <em-button type=\"submit\" class=\"md-raised md-accent md-large\" is-loading=\"vm.loading.validating\" loading-text=\"'Validando...'\">\n" +
    "                Confirmar Código\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "              </em-button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </md-content>\n" +
    "      </form>\n" +
    "    </md-tab>\n" +
    "  </md-tabs>\n" +
    "  <!-- <md-content layout-padding class=\"md-transparent\">\n" +
    "    <md-icon md-svg-src=\"assets/phone-validation.svg\"></md-icon>\n" +
    "    <p class=\"text-center\">Algun texto explicativo, como solo un ultimo paso, valida tu celular para recibir llamadas de tu producto</p>\n" +
    "    <div class=\"phone\" layout=\"row\">\n" +
    "      <md-input-container class=\"clasic-input\">\n" +
    "        <label>Tipo</label>\n" +
    "        <md-select ng-model=\"vm.phone.type\">\n" +
    "          <md-option ng-value=\"phoneType\" ng-repeat=\"phoneType in vm.phoneTypes\">{{phoneType | translate}}</md-option>\n" +
    "        </md-select>\n" +
    "      </md-input-container>\n" +
    "      <md-input-container flex class=\"clasic-input\">\n" +
    "        <label>Número</label>\n" +
    "        <input ng-model=\"vm.phone.number\" type=\"tel\" />\n" +
    "      </md-input-container>\n" +
    "    </div>\n" +
    "    <div class=\"button-wrapper\" layout=\"row\" layout-align=\"center start\">\n" +
    "      <em-button class=\"md-raised md-accent md-big\" ng-click=\"vm.addPhone()\" is-loading=\"vm.loading.saving\" loading-text=\"'Llamando...'\">Validar Número</em-button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"profil__edit__phone__code\" layout=\"column\" layout-align=\"start center\">\n" +
    "      <h3 class=\"text-center\">Inserte los digitos</h3>\n" +
    "      <div class=\"input-wrapper\" layout=\"row\">\n" +
    "        <md-input-container ng-hide=\"vm.loading.validating\" md-no-float class=\"clasic-input\">\n" +
    "          <input type=\"number\" ng-model=\"vm.validationCode\" maxlength=\"4\" placeholder=\"XXXX\">\n" +
    "        </md-input-container>\n" +
    "        <md-progress-circular ng-show=\"vm.loading.validating\" md-diameter=\"30\"></md-progress-circular>\n" +
    "\n" +
    "      </div>\n" +
    "      <p class=\"text-center\">Le estaremos llamando para que inserte estos digitos</p>\n" +
    "    </div>\n" +
    "  </md-content> -->\n" +
    "</div>");
}]);

angular.module("main/profile/favorites/favorite.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/favorites/favorite.tpl.html",
    "<div class=\"favorites\" flex layout=\"column\" layout-align=\"center start\">\n" +
    "    <md-progress-circular ng-show=\"model.isLoading\"></md-progress-circular>\n" +
    "    <div flex layout=\"row\" class=\"favorites__container\" ng-hide=\"model.isLoading\">\n" +
    "        <ui-view flex name=\"favorite\" layout=\"r\"></ui-view>\n" +
    "    </div>\n" +
    "\n" +
    "    <div flex-gt-sm=\"60\" flex=\"100\" ng-if=\"!model.isLoading && model.products.length === 0 && model.sellers.length === 0\">\n" +
    "        <md-card class=\"empty-space\">\n" +
    "            <md-card-content layout=\"row\" layout-align=\"center\" layout-wrap>\n" +
    "                <h3 flex=\"100\" class=\"text-center md-display-1\">No tienes nada en tus favoritos</h3>\n" +
    "                <p flex=\"100\" class=\"md-subhead text-center\">Agrega un vendedor o un producto a tus favoritos para verlo aquí</p>\n" +
    "            </md-card-content>\n" +
    "        </md-card>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/profile/favorites/list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/favorites/list.tpl.html",
    "<div class=\"favorite__mobile\" layout=\"row\" hide-gt-sm flex ng-hide=\"model.isLoading\">\n" +
    "  <md-tabs flex class=\"md-primary\" md-stretch-tabs=\"always\">\n" +
    "    <md-tab label=\"Productos\" md-on-select=\"model.changeType('post')\">\n" +
    "      <md-content class=\"favorite-container\">\n" +
    "        <div>\n" +
    "          <md-toolbar class=\"md-transparent\">\n" +
    "            <div class=\"md-toolbar-tools\">\n" +
    "              <h2 class=\"md-title\" ng-hide=\"model.favorites.length === 0\">Productos Favoritos</h2>\n" +
    "              <span flex></span>\n" +
    "              <em-search-button ng-hide=\"model.favorites.length === 0\" ng-model=\"model.postFilter\"></em-search-button>\n" +
    "            </div>\n" +
    "          </md-toolbar>\n" +
    "          <md-list flex ng-show=\"model.favorites.length > 0\">\n" +
    "            <md-list-item class=\"md-2-line md-no-proxy mobile-product-list\" ng-repeat=\"favorite in model.favorites | filter:model.postFilter\"\n" +
    "              ui-sref=\"main.post.detail({title:favorite.postId._id})\">\n" +
    "              <img thumbnail em-src-image=\"favorite.post.image\" alt=\"\" class=\"md-avatar\">\n" +
    "              <div class=\"md-list-item-text\">\n" +
    "                <h3>{{favorite.post.title}}</h3>\n" +
    "                <p class=\"price\">{{favorite.post.price | currency:'RD$':2}}</p>\n" +
    "              </div>\n" +
    "\n" +
    "            </md-list-item>\n" +
    "          </md-list>\n" +
    "          <div flex class=\"empty-state\" ng-show=\"model.favorites.length === 0\" layout=\"column\">\n" +
    "            <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "              <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "                <md-icon md-svg-src=\"assets/no-favorite.svg\"></md-icon>\n" +
    "                <h4>Aún no tienes productos favoritos</h4>\n" +
    "                <p class=\"md-subhead\">\n" +
    "                  Solo debes ir a cualquier producto y presionar agregar favoritos\n" +
    "                </p>\n" +
    "              </div>\n" +
    "            </md-content>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </md-content>\n" +
    "    </md-tab>\n" +
    "    <md-tab label=\"Tiendas\" md-on-select=\"model.changeType('seller')\">\n" +
    "      <md-content class=\"favorite-container\">\n" +
    "        <div>\n" +
    "          <md-toolbar class=\"md-transparent\">\n" +
    "            <div class=\"md-toolbar-tools\">\n" +
    "              <h2 class=\"md-title\" ng-hide=\"model.favorites.length === 0\">Tiendas Favoritas</h2>\n" +
    "              <span flex></span>\n" +
    "              <em-search-button ng-hide=\"model.favorites.length === 0\" ng-model=\"model.postFilter\"></em-search-button>\n" +
    "            </div>\n" +
    "          </md-toolbar>\n" +
    "          <md-list flex ng-show=\"model.favorites.length > 0\">\n" +
    "            <md-list-item class=\"md-2-line md-no-proxy mobile-product-list\" ng-repeat=\"favorite in model.favorites | filter:model.postFilter\"\n" +
    "              ui-sref=\"store.home({name:favorite.seller.username})\">\n" +
    "              <img thumbnail em-src-image=\"favorite.seller.picture\" alt=\"\" class=\"md-avatar\">\n" +
    "              <div class=\"md-list-item-text\">\n" +
    "                <h3>{{favorite.seller.displayName}}</h3>\n" +
    "                <p>{{favorite.seller.username}}</p>\n" +
    "              </div>\n" +
    "              <!-- <md-button class=\"md-secondary md-icon-button md-warn\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n" +
    "              </md-button> -->\n" +
    "            </md-list-item>\n" +
    "          </md-list>\n" +
    "          <div flex class=\"empty-state\" ng-show=\"model.favorites.length === 0\" layout=\"column\">\n" +
    "            <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "              <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "                <md-icon md-svg-src=\"assets/store/small_2.svg\"></md-icon>\n" +
    "                <h4>Aún no sigues ninguna tienda</h4>\n" +
    "                <p class=\"md-subhead\">\n" +
    "                  Entra a un producto y sigue a tu tienda favorita\n" +
    "                </p>\n" +
    "              </div>\n" +
    "            </md-content>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </md-content>\n" +
    "    </md-tab>\n" +
    "  </md-tabs>\n" +
    "</div>");
}]);

angular.module("main/profile/favorites/post.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/favorites/post.tpl.html",
    "<div flex class=\"favorite-seller\">\n" +
    "  <md-toolbar class=\"md-transparent\" ng-hide=\"model.favorites.length === 0\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h2 class=\"md-title\">Listado de Productos</h2>\n" +
    "      <span flex></span>\n" +
    "      <em-search-button ng-model=\"model.postFilter\"></em-search-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-list ng-hide=\"model.favorites.length === 0\">\n" +
    "    <md-list-item class=\"md-3-line md-long-text\" ui-sref=\"main.post.detail({title:favorite.postId._id})\" ng-repeat-start=\"favorite in model.favorites | filter:model.postFilter\">\n" +
    "      <img class=\"md-avatar\" square em-src-image=\"favorite.post.image\">\n" +
    "      <div class=\"md-list-item-text \">\n" +
    "        <h3 class=\"md-headline\">{{favorite.post.title}}</h3>\n" +
    "        <p class=\"price\">{{favorite.post.price | currency:'RD$':2}}</p>\n" +
    "        <p>\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "          <strong>Ubicación: </strong> Santo Domingo\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n" +
    "          <strong>Guardado: </strong>\n" +
    "          <span duration=\"favorite.createdAt\">{{favorite.createdAt}}</span>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "\n" +
    "    </md-list-item>\n" +
    "    <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "  </md-list>\n" +
    "  <div flex class=\"empty-state\" ng-show=\"model.favorites.length === 0\" layout=\"column\">\n" +
    "    <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "      <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "        <md-icon md-svg-src=\"assets/no-favorite.svg\"></md-icon>\n" +
    "        <h4>Aún no tienes productos favoritos</h4>\n" +
    "        <p class=\"md-subhead\">\n" +
    "          Solo debes ir a cualquier producto y presionar agregar favoritos\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </md-content>\n" +
    "  </div>\n" +
    "  <p class=\"text-center\" ng-show=\"model.products.length === 0\">No tienes ningún producto en tus favoritos</p>\n" +
    "</div>");
}]);

angular.module("main/profile/favorites/seller.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/favorites/seller.tpl.html",
    "<div flex>\n" +
    "  <md-toolbar class=\"md-transparent\" ng-hide=\"model.favorites.length === 0\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h2 class=\"md-title\">Tiendas Favoritas</h2>\n" +
    "      <span flex></span>\n" +
    "      <em-search-button ng-model=\"model.sellerFilter\"></em-search-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-list ng-show=\"model.favorites.length > 0\">\n" +
    "    <md-list-item class=\"md-3-line md-long-text\" ui-sref=\"store.home({name:favorite.seller.username})\" ng-repeat-start=\"favorite in model.favorites | filter:model.sellerFilter\">\n" +
    "      <img class=\"md-avatar\" square em-src-image=\"favorite.seller.picture\">\n" +
    "      <div class=\"md-list-item-text\">\n" +
    "        <h3>{{favorite.seller.displayName.toLowerCase()}}</h3>\n" +
    "        <p>\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "          <strong>Ubicación: </strong> Santo Domingo\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n" +
    "          <strong>Guardado: </strong>\n" +
    "          <span duration=\"favorite.createdAt\">{{favorite.createdAt}}</span>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      <md-button ui-sref=\"store.home({name:seller.seller.username})\" class=\"md-secondary\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-store\"></md-icon>\n" +
    "        Visitar Tienda\n" +
    "      </md-button>\n" +
    "    </md-list-item>\n" +
    "    <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "  </md-list>\n" +
    "  <div flex class=\"empty-state\" ng-show=\"model.favorites.length === 0\" layout=\"column\">\n" +
    "    <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "      <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "        <md-icon md-svg-src=\"assets/store/small_2.svg\"></md-icon>\n" +
    "        <h4>Aún no sigues ninguna tienda</h4>\n" +
    "        <p class=\"md-subhead\">\n" +
    "          Entra a un producto y sigue a tu tienda favorita\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </md-content>\n" +
    "  </div>\n" +
    "  <p class=\"text-center\" ng-show=\"model.sellers.length === 0\">No tienes ningún vendedor a favoritos</p>\n" +
    "</div>");
}]);

angular.module("main/profile/menu/menu.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/menu/menu.tpl.html",
    "<md-content flex class=\"profile__menu\">\n" +
    "	<md-list flex>\n" +
    "		<md-list-item ui-sref=\"main.profile.products\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-view-headline\"></md-icon>\n" +
    "			<p>Mis Productos</p>\n" +
    "		</md-list-item>\n" +
    "		<md-divider></md-divider>\n" +
    "		<md-list-item ui-sref=\"main.profile.chat\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-comments\"></md-icon>\n" +
    "			<p>Mis Mensajes</p>\n" +
    "			<md-icon ng-if=\"model.messageCount\" class=\"badge badge--warn md-secondary\">{{model.messageCount}}</md-icon>\n" +
    "		</md-list-item>\n" +
    "		<md-divider></md-divider>\n" +
    "		<!-- <md-list-item ui-sref=\"main.profile.chat\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-notifications\"></md-icon>\n" +
    "			<p>Notificaciones</p>\n" +
    "			<md-icon class=\"badge badge--warn md-secondary\">15</md-icon>\n" +
    "		</md-list-item> -->\n" +
    "		<md-list-item ui-sref=\"main.profile.favorite.list\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-favorite\"></md-icon>\n" +
    "			<p>Mis Favoritos</p>\n" +
    "		</md-list-item>\n" +
    "		<md-divider></md-divider>\n" +
    "		<md-list-item ui-sref=\"main.profile.edit\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-edit\"></md-icon>\n" +
    "			<p>Editar Mi Perfil</p>\n" +
    "		</md-list-item>\n" +
    "		<md-divider></md-divider>\n" +
    "		<md-list-item ng-click=\"model.logout()\">\n" +
    "			<md-icon md-font-icon=\"zmdi zmdi-hc-fw zmdi-sign-in zmdi-hc-flip-horizontal\"></md-icon>\n" +
    "			<p>Salir</p>\n" +
    "		</md-list-item>\n" +
    "	</md-list>\n" +
    "</md-content>\n" +
    "");
}]);

angular.module("main/profile/phone-validation-dialog/phone-validation.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/phone-validation-dialog/phone-validation.tpl.html",
    "<md-dialog>\n" +
    "    <form name=\"validationform\" novalidate ng-submit=\"vm.validatePhone(model.code)\">\n" +
    "        <md-dialog-content class=\"md-dialog-content\">\n" +
    "            <h2 class=\"md-title\">Codigo de validación</h2>\n" +
    "            <div class=\"md-dialog-content-body\">\n" +
    "                <p>Llegará una llamada al número <strong>{{vm.phone}}</strong> por favor inserte el codigo que escuche en la llamada</p>\n" +
    "            </div>\n" +
    "            <md-input-container class=\"md-prompt-input-container\">\n" +
    "                <label>Codigo de validación</label>\n" +
    "                <input ng-keypress=\"vm.errorMessage = false\" md-autofocus required type=\"text\" ng-model=\"model.code\" name=\"code\">\n" +
    "                <div ng-messages=\"validationform.code.$error\">\n" +
    "                    <div ng-message=\"required\">No olvides escribir el codigo de validación</div>\n" +
    "                </div>\n" +
    "                <div class=\"md-input-messages-animation\" aria-live=\"assertive\" ng-if=\"vm.errorMessage\">\n" +
    "  									<div class=\"md-input-message-animation\">{{vm.errorMessage}}</div>\n" +
    "  							</div>\n" +
    "            </md-input-container>\n" +
    "        </md-dialog-content>\n" +
    "        <md-dialog-actions>\n" +
    "            <md-button ng-click=\"vm.resendCode()\">Reenviar Codigo</md-button>\n" +
    "            <md-button ng-click=\"vm.cancel()\">Cancelar</md-button>\n" +
    "            <span flex></span>\n" +
    "            <md-button type=\"submit\" class=\"md-primary\">Validar</md-button>\n" +
    "        </md-dialog-actions>\n" +
    "    </form>\n" +
    "</md-dialog>\n" +
    "");
}]);

angular.module("main/profile/products/products.mobile.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/products/products.mobile.tpl.html",
    "<md-toolbar class=\"md-transparent md-border\">\n" +
    "  <div class=\"md-toolbar-tools\">\n" +
    "    <h3 flex>Mis Productos</h3>\n" +
    "    <em-search-button ng-model=\"model.searchTerm\"></em-search-button>\n" +
    "  </div>\n" +
    "</md-toolbar>\n" +
    "<div ng-show=\"model.posts && model.posts.length > 0\" class=\"profile__product-list\" flex>\n" +
    "  <md-list>\n" +
    "    <md-list-item class=\"md-2-line md-no-proxy mobile-product-list\" ng-repeat=\"post in model.posts | filter:model.searchTerm\"\n" +
    "      ui-sref=\"main.post.detail({title:post._id})\">\n" +
    "      <img thumbnail em-src-image=\"post.images[0]\" alt=\"\" class=\"md-avatar\">\n" +
    "      <div class=\"md-list-item-text\">\n" +
    "        <h3>{{post.title}}</h3>\n" +
    "        <p>{{post.status | translate}}\n" +
    "          <span ng-if=\"post.isPremium\"> - premium</span>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      <md-menu class=\"md-secondary\">\n" +
    "        <md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n" +
    "        </md-button>\n" +
    "        <md-menu-content width=\"4\">\n" +
    "\n" +
    "          <md-menu-item>\n" +
    "            <md-button ui-sref=\"main.post.detail({title:post._id})\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n" +
    "              Ver Producto\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "          <md-menu-item>\n" +
    "            <md-button ui-sref=\"main.post.edit({id:post._id})\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n" +
    "              Editar\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "          <md-menu-item ng-if=\"model.canRepublish(post)\">\n" +
    "            <md-button aria-label=\"republicar {{post.title}}\" ng-click=\"model.refreshPost(post)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n" +
    "              Republicar Producto\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "          <md-divider></md-divider>\n" +
    "          <md-menu-item>\n" +
    "            <md-button class=\"md-warn\" ng-click=\"model.delete(post)\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n" +
    "              Eliminar Producto\n" +
    "            </md-button>\n" +
    "          </md-menu-item>\n" +
    "        </md-menu-content>\n" +
    "      </md-menu>\n" +
    "    </md-list-item>\n" +
    "  </md-list>\n" +
    "</div>\n" +
    "\n" +
    "<div flex class=\"empty-state\" ng-show=\"model.showEmptyState\" layout=\"column\">\n" +
    "  <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "    <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "      <md-icon md-svg-src=\"assets/for-sale.svg\"></md-icon>\n" +
    "      <h4>Aún no tienes productos</h4>\n" +
    "      <p class=\"md-subhead\">\n" +
    "        Presiona el botón de publicar para comenzar a vender\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "</div>");
}]);

angular.module("main/profile/products/products.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/products/products.tpl.html",
    "<div class=\"loading\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"!model.showEmptyState && (!model.posts || model.posts.length === 0)\">\n" +
    "  <md-progress-circular></md-progress-circular>\n" +
    "</div>\n" +
    "<div hide-xs hide-sm flex class=\"empty-state\" ng-show=\"model.showEmptyState\" layout=\"column\">\n" +
    "  <md-content flex layout=\"row\" layout-align=\"center center\">\n" +
    "    <div flex-gt-md=\"40\" flex=\"60\" flex-sm=\"90\" flex-xs=\"90\">\n" +
    "      <md-icon md-svg-src=\"assets/for-sale.svg\"></md-icon>\n" +
    "      <h4>Aún no tienes productos</h4>\n" +
    "      <p class=\"md-subhead\">\n" +
    "        Presiona el botón de publicar para comenzar a vender\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "<div class=\"product-mobile__container\" flex=\"100\" ng-include=\"'main/profile/products/products.mobile.tpl.html'\" layout=\"column\"\n" +
    "  hide-gt-sm>\n" +
    "\n" +
    "</div>\n" +
    "<div ng-show=\"model.posts && model.posts.length > 0\" class=\"profile__product-list\" flex hide-xs hide-sm>\n" +
    "  <md-toolbar class=\"md-transparent\" ng-hide=\"model.selected.length > 0\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <h2 class=\"md-title\">Listado de Productos</h2>\n" +
    "      <span flex></span>\n" +
    "      <em-search-button ng-model=\"model.filter\"></em-search-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-toolbar class=\"md-transparent multi-action\" ng-show=\"model.selected.length > 0\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <span flex></span>\n" +
    "      <em-button class=\"md-raised md-primary\" ng-if=\"model.canRefresh\" ng-click=\"model.refreshSeveral()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n" +
    "        Republicar/Reiniciar\n" +
    "      </em-button>\n" +
    "      <em-button ng-if=\"model.hasStore\" is-loading=\"model.seasoning\" loading-text=\"'Espere...'\" class=\"md-raised md-primary\" ng-click=\"model.addSeasonPost(model.selected)\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-star-circle\"></md-icon>\n" +
    "        De Temporada\n" +
    "      </em-button>\n" +
    "      <em-button ng-if=\"model.hasStore\" is-loading=\"model.seasoning\" loading-text=\"'Espere...'\" class=\"md-raised md-primary\" ng-click=\"model.addHighlightedPost(model.selected)\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-star\"></md-icon>\n" +
    "        Destacar\n" +
    "      </em-button>\n" +
    "      <em-button is-loading=\"model.deleting\" loading-text=\"'Eliminando...'\" class=\"md-danger md-raised\" ng-click=\"model.deleteSeveral()\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n" +
    "        Eliminar\n" +
    "      </em-button>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-table-container>\n" +
    "    <table md-table ng-model=\"model.selected\" md-row-select multiple>\n" +
    "      <thead md-head>\n" +
    "        <tr md-row>\n" +
    "          <th md-column>Imagenes</th>\n" +
    "          <th md-column>Título</th>\n" +
    "          <th md-column hide-sm hide-xs>Visitas</th>\n" +
    "          <th md-column hide-sm hide-xs>Vence</th>\n" +
    "          <th md-column hide-xs>Estado</th>\n" +
    "          <th md-column>Acciones</th>\n" +
    "        </tr>\n" +
    "      </thead>\n" +
    "      <tbody md-body>\n" +
    "        <tr md-row md-select=\"post._id\" md-select-id=\"_id\" ng-repeat=\"post in model.posts | filter:model.filter\">\n" +
    "          <td md-cell>\n" +
    "            <div class=\"image__container\">\n" +
    "              <img alt=\"imagen\" em-src-image=\"post.images[0]\" thumbnail>\n" +
    "            </div>\n" +
    "\n" +
    "          </td>\n" +
    "          <td md-cell>\n" +
    "            <div layout=\"column\">\n" +
    "              <p>{{post.title}}</p>\n" +
    "              <small ng-if=\"post.prominent\">En {{post.prominent | translate}}</small>\n" +
    "            </div>\n" +
    "          </td>\n" +
    "          <td md-cell hide-sm hide-xs>\n" +
    "            <small>{{post.views}}</small>\n" +
    "          </td>\n" +
    "          <td md-cell hide-sm hide-xs>\n" +
    "            <small>{{post.endAt | date:'mediumDate'}}</small>\n" +
    "          </td>\n" +
    "          <td md-cell hide-xs>\n" +
    "            <span class=\"{{post.status}}\">\n" +
    "              {{post.status | translate}}\n" +
    "            </span>\n" +
    "            <span class=\"premium-post\" ng-if=\"post.isPremium\">\n" +
    "              premium\n" +
    "            </span>\n" +
    "\n" +
    "          </td>\n" +
    "          <td md-cell>\n" +
    "            <div layout=\"flex\">\n" +
    "              <!-- <span flex></span> -->\n" +
    "              <md-button aria-label=\"Detalles de {{post.title}}\" hide-sm hide-xs class=\"md-icon-button md-icon-button__labeled\" ui-sref=\"main.post.detail({title:post._id})\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n" +
    "                <md-tooltip md-delay=\"500\">Ver Producto</md-tooltip>\n" +
    "                <small>Ver</small>\n" +
    "              </md-button>\n" +
    "              <md-button aria-label=\"editar {{post.title}}\" hide-sm hide-xs class=\"md-icon-button md-icon-button__labeled\" ui-sref=\"main.post.edit({id:post._id})\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n" +
    "                <md-tooltip md-delay=\"500\">Editar Producto</md-tooltip>\n" +
    "                <small>Editar</small>\n" +
    "              </md-button>\n" +
    "              <em-button is-loading=\"model.refresh[post._id]\" ng-show=\"model.canRefresh\" aria-label=\"reiniciar {{post.title}}\" hide-sm\n" +
    "                hide-xs class=\"md-icon-button md-icon-button__labeled\" ng-click=\"model.refreshPost(post)\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n" +
    "                <md-tooltip md-delay=\"500\">Reiniciar Producto</md-tooltip>\n" +
    "                <small>Reiniciar</small>\n" +
    "              </em-button>\n" +
    "              <em-button is-loading=\"model.refresh[post._id]\" ng-hide=\"model.canRefresh\" disabled=\"!model.canRepublish(post)\" aria-label=\"reiniciar {{post.title}}\"\n" +
    "                hide-sm hide-xs class=\"md-icon-button md-icon-button__labeled\" ng-click=\"model.refreshPost(post)\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n" +
    "                <md-tooltip ng-if=\"model.canRepublish(post)\" md-delay=\"500\">Republicar Producto</md-tooltip>\n" +
    "                <small>publicar</small>\n" +
    "              </em-button>\n" +
    "              <!-- <md-button aria-label=\"ofertas de {{post.title}}\" ng-click=\"model.showDialogOffer(post)\" hide-sm hide-xs class=\"md-icon-button badge__container\" ng-if=\"post.isNegotiable\" aria-label=\"Ofertas\">\n" +
    "                                <md-icon md-font-icon=\"zmdi zmdi-local-offer\"></md-icon>\n" +
    "                                <md-icon class=\"badge badge--info\" ng-show=\"model.offerCount(post.offers) > 0\">{{model.offerCount(post.offers)}}</md-icon>\n" +
    "                                <md-tooltip md-delay=\"500\" ng-if=\"post.offers.length === 0\">Hasta el momento no tienes ofertas pendientes</md-tooltip>\n" +
    "                                <md-tooltip md-delay=\"500\" ng-if=\"post.offers.length > 0\">Tienes {{model.offerCount(post.offers)}} ofertas pendientes</md-tooltip>\n" +
    "                            </md-button> -->\n" +
    "              <md-menu hide-xs hide-sm ng-show=\"model.hasStore\">\n" +
    "                <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n" +
    "                  <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n" +
    "                </md-button>\n" +
    "                <md-menu-content>\n" +
    "                  <md-menu-item ng-show=\"model.canRepublish(post)\">\n" +
    "                    <md-button aria-label=\"republicar {{post.title}}\" ng-click=\"model.refreshPost(post)\">\n" +
    "                      Republicar Producto\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                  <md-menu-item ng-if=\"post.prominent!=='season'\">\n" +
    "                    <md-button aria-label=\"Agregar como producto de temporada\" ng-click=\"model.addSeasonPost(post._id)\">\n" +
    "                      Agregar como producto de temporada\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                  <md-menu-item ng-if=\"post.prominent==='season'\">\n" +
    "                    <md-button aria-label=\"Agregar como producto de temporada\" ng-click=\"model.removeSeasonPost(post._id)\">\n" +
    "                      Remover como producto de temporada\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                  <md-menu-item ng-if=\"post.prominent!=='highlighted'\">\n" +
    "                    <md-button aria-label=\"Agregar como producto destacado\" ng-click=\"model.addHighlightedPost(post._id)\">\n" +
    "                      Agregar como producto destacado\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                  <md-menu-item ng-if=\"post.prominent==='highlighted'\">\n" +
    "                    <md-button aria-label=\"Agregar como producto destacado\" ng-click=\"model.removeHighlightedPost(post._id)\">\n" +
    "                      Remover como producto destacado\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                  <md-divider></md-divider>\n" +
    "                  <md-menu-item>\n" +
    "                    <md-button class=\"md-warn\" aria-label=\"eliminar de {{post.title}}\" ng-click=\"model.delete(post, $index)\">\n" +
    "                      <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>Eliminar Producto\n" +
    "                    </md-button>\n" +
    "                  </md-menu-item>\n" +
    "                </md-menu-content>\n" +
    "              </md-menu>\n" +
    "\n" +
    "              <md-button ng-hide=\"model.hasStore\" aria-label=\"eliminar de {{post.title}}\" hide-sm hide-xs class=\"md-warn md-icon-button\"\n" +
    "                ng-click=\"model.delete(post)\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n" +
    "                <md-tooltip md-delay=\"500\">Eliminar Producto</md-tooltip>\n" +
    "              </md-button>\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </tbody>\n" +
    "    </table>\n" +
    "  </md-table-container>\n" +
    "</div>");
}]);

angular.module("main/profile/profile.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/profile.tpl.html",
    "<section class=\"profile\" flex layout=\"row\" layout-align=\"center\">\n" +
    "  <div class=\"profile-container\" layout=\"row\" flex-gt-sm=\"80\" flex>\n" +
    "    <div class=\"profile__user\" flex=\"30\" layout=\"column\" hide-sm hide-xs>\n" +
    "      <md-card class=\"profile__basic-info\">\n" +
    "        <md-card-content ng-hide=\"model.hideStatCard\">\n" +
    "          <img em-src-image=\"model.user.picture\" square class=\"img--rounded\" />\n" +
    "          <h3 class=\"md-headline\">{{model.user.displayName}}</h3>\n" +
    "          <p class=\"md-subhead\">({{model.user.username}})</p>\n" +
    "          <md-button ui-sref=\"main.profile.edit\" class=\"md-primary md-raised\">\n" +
    "            Editar Perfil\n" +
    "          </md-button>\n" +
    "        </md-card-content>\n" +
    "        <md-card-content class=\"profile__picture-edit\" ng-show=\"model.hideStatCard\">\n" +
    "          <img em-src-image=\"model.profilePicture || model.user.picture\" square class=\"img--rounded\" />\n" +
    "          <p class=\"md-body\">Tamaño recomendado:</p>\n" +
    "          <p class=\"md-subhead\">350 x 350 pixeles</p>\n" +
    "          <md-button ngf-select ngf-change=\"model.uploadProfilePicture(model.profilePicture)\" ng-model=\"model.profilePicture\" ngf-accept=\"'image/*'\"\n" +
    "            ngf-max-size=\"20MB\" ngf-fix-orientation=\"true\" ui-sref=\"main.profile.edit\" class=\"md-primary md-raised\">\n" +
    "            Cambiar Foto\n" +
    "          </md-button>\n" +
    "        </md-card-content>\n" +
    "      </md-card>\n" +
    "      <md-card class=\"profile__summary\" ng-hide=\"model.hideStatCard\">\n" +
    "        <md-card-content>\n" +
    "          <div class=\"profile__posts-count\">\n" +
    "            <h4 class=\"md-subhead\">Productos:</h4>\n" +
    "            <md-progress-linear md-mode=\"determinate\" value=\"{{model.stat.percent}}\"></md-progress-linear>\n" +
    "            <div class=\"profile__posts-count__bottom-text\" layout=\"row\" layout-align=\"space-between\">\n" +
    "              <p class=\"md-body\">Cantidad</p>\n" +
    "              <p class=\"md-body\">{{model.stat.count}}/{{model.stat.total}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <md-divider></md-divider>\n" +
    "          <div class=\"profile__plan-summary\">\n" +
    "            <h4 class=\"md-subhead\">\n" +
    "              <span> Plan:</span>\n" +
    "              <p class=\"md-body-2\">{{model.stat.planName}}</p>\n" +
    "              <md-button ui-sref=\"main.plan\" class=\"md-primary\">Adquirir</md-button>\n" +
    "            </h4>\n" +
    "            <h4 class=\"md-subhead\">\n" +
    "              <span>Balance:</span>\n" +
    "              <p class=\"md-body-2\">{{model.user.balance | currency:'$':2}}</p>\n" +
    "              <md-button ng-click=\"model.showAddBalanceDialog()\" class=\"md-primary\">Agregar</md-button>\n" +
    "            </h4>\n" +
    "\n" +
    "\n" +
    "            <h4 ng-show=\"!model.stat.isFree\" class=\"md-body-3\">Dias Restantes:</h4>\n" +
    "            <div ng-show=\"!model.stat.isFree\" layout=\"row\" layout-align=\"space-between\">\n" +
    "              <p class=\"remaining-days\">{{model.stat.remainDays}}</p>\n" +
    "              <md-button class=\"md-primary\">Renovar Plan</md-button>\n" +
    "            </div>\n" +
    "            <div flex=\"100\" class=\"md-button-wrapper\" ng-if=\"model.stat.isFree\">\n" +
    "              <md-button ui-sref=\"main.plan\" class=\"md-raised\">Adquiere tu plan ahora</md-button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </md-card-content>\n" +
    "      </md-card>\n" +
    "\n" +
    "    </div>\n" +
    "    <md-card class=\"profile__navigation\" flex layout=\"column\">\n" +
    "      <div hide-sm hide-xs ng-hide=\"model.hideNavBar\">\n" +
    "        <md-nav-bar md-selected-nav-item=\"model.currentNavItem\" nav-bar-aria-label=\"navigation links\">\n" +
    "          <md-nav-item md-nav-sref=\"main.profile.products\" name=\"main.profile.products\">Productos</md-nav-item>\n" +
    "          <md-nav-item md-nav-sref=\"main.profile.chat\" name=\"main.profile.chat\">Mensajes</md-nav-item>\n" +
    "          <md-nav-item md-nav-sref=\"main.profile.favorite.post\" name=\"main.profile.favorite.post\">Productos Favoritos</md-nav-item>\n" +
    "          <md-nav-item md-nav-sref=\"main.profile.favorite.seller\" name=\"main.profile.favorite.seller\">Tiendas Favoritos</md-nav-item>\n" +
    "\n" +
    "        </md-nav-bar>\n" +
    "        <md-divider></md-divider>\n" +
    "      </div>\n" +
    "      <ui-view name=\"profile\" class=\"profile-ui-view\" layout=\"row\" layout-align=\"start start\" flex></ui-view>\n" +
    "    </md-card>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("main/profile/transaction/add.balance.dialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/transaction/add.balance.dialog.tpl.html",
    "<md-dialog class=\"add-balance-dialog\">\n" +
    "    <form name=\"addBalanceForm\" ng-hide=\"vm.loading\" novalidate ng-submit=\"vm.createHash($event, addBalanceForm)\" id=\"addBalanceForm\"\n" +
    "        action=\"{{vm.url}}\" method=\"post\">\n" +
    "        <md-dialog-content class=\"md-dialog-content\">\n" +
    "            <h3 class=\"md-title\">Agregar Balance</h3>\n" +
    "            <div>\n" +
    "                <input type=\"hidden\" name=\"MerchantId\" value=\"{{vm.payment.MerchantId}}\">\n" +
    "                <input type=\"hidden\" name=\"MerchantName\" value=\"{{vm.payment.MerchantName}}\">\n" +
    "                <input type=\"hidden\" name=\"MerchantType\" value=\"e-commerce\">\n" +
    "                <input type=\"hidden\" name=\"CurrencyCode\" value=\"$\">\n" +
    "                <input type=\"hidden\" name=\"OrderNumber\" value=\"{{vm.payment.OrderNumber}}\" id=\"OrderNumber\">\n" +
    "            </div>\n" +
    "            <div class=\"input-containers-wrapper\" layout=\"row\" layout-wrap>\n" +
    "                <md-input-container class=\"clasic-input\" flex=\"100\">\n" +
    "                    <label for=\"\">Monto</label>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-money\"></md-icon>\n" +
    "                    <input type=\"hidden\" ng-model=\"vm.payment.ITBIS\" value=\"{{vm.payment.ITBIS}}\" class=\"form-control\" name=\"ITBIS\" id=\"ITBIS\">\n" +
    "                    <input type=\"number\" ng-model=\"vm.payment.Amount\" value=\"{{vm.payment.Amount}}\" min=\"100\" step=\"100\" class=\"form-control\"\n" +
    "                        required name=\"Amount\" id=\"Amount\">\n" +
    "                    <div ng-messages=\"addBalanceForm.Amount.$error\">\n" +
    "                        <div ng-message=\"required\">Debe de agregar un monto</div>\n" +
    "                        <div ng-message=\"min\">El monto mínimo es RD$100</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                </md-input-container>\n" +
    "                <input type=\"hidden\" name=\"ApprovedUrl\" value=\"{{vm.payment.ApprovedUrl}}\">\n" +
    "                <input type=\"hidden\" name=\"DeclinedUrl\" value=\"{{vm.payment.DeclinedUrl}}\">\n" +
    "                <input type=\"hidden\" name=\"CancelUrl\" value=\"{{vm.payment.CancelUrl}}\">\n" +
    "                <input type=\"hidden\" name=\"UseCustomField1\" value=\"0\">\n" +
    "                <input type=\"hidden\" name=\"UseCustomField2\" value=\"0\">\n" +
    "                <input type=\"hidden\" name=\"ShowTransactionResult\" value=\"1\">\n" +
    "                <input type=\"hidden\" ng-model=\"vm.payment.AuthHash\" name=\"AuthHash\" value=\"{{vm.payment.AuthHash}}\" id=\"AuthHash\">\n" +
    "\n" +
    "            </div>\n" +
    "        </md-dialog-content>\n" +
    "        <md-dialog-actions>\n" +
    "            <md-button ng-click=\"vm.close()\">Cancelar</md-button>\n" +
    "            <md-button type=\"submit\" class=\"md-primary md-raised\">Agregar</md-button>\n" +
    "        </md-dialog-actions>\n" +
    "    </form>\n" +
    "    <div layout=\"row\" flex layout-align=\"center center\" ng-show=\"vm.loading\" class=\"loading-container\">\n" +
    "        <md-progress-circular md-diameter=\"50\"></md-progress-circular>\n" +
    "    </div>\n" +
    "</md-dialog>");
}]);

angular.module("main/profile/transaction/transaction.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/profile/transaction/transaction.tpl.html",
    "<div flex layout=\"column\" layout-align=\"center center\">\n" +
    "    <p class=\"text-center\" flex>\n" +
    "        <md-progress-circular md-diameter=\"50\"></md-progress-circular>\n" +
    "        Validando...\n" +
    "    </p>\n" +
    "</div>");
}]);

angular.module("main/statics/faqs/faqs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/statics/faqs/faqs.tpl.html",
    "<div class=\"faqs\" layout=\"row\" layout-align=\"center\">\n" +
    "  <div flex=\"80\" layout=\"column\">\n" +
    "    <h3 class=\"headline\">Preguntas Frecuentes</h3>\n" +
    "    <div class=\"faqs__body\">\n" +
    "      <div class=\"faqs__topics\" flex=\"35\" layout=\"column\">\n" +
    "        <md-card ng-class=\"{active:vm.list.use}\" ng-click=\"vm.showList('use')\">\n" +
    "          <md-card-header>\n" +
    "            <md-card-avatar>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </md-card-avatar>\n" +
    "            <md-card-header-text>\n" +
    "              <span class=\"md-title\">Uso de eMarket</span>\n" +
    "              <span class=\"md-subhead\">Detalles basicos sobre prguntas generales de cosas vacanas</span>\n" +
    "            </md-card-header-text>\n" +
    "          </md-card-header>\n" +
    "        </md-card>\n" +
    "\n" +
    "        <md-card ng-class=\"{active:vm.list.general}\" ng-click=\"vm.showList('general')\">\n" +
    "          <md-card-header>\n" +
    "            <md-card-avatar>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </md-card-avatar>\n" +
    "            <md-card-header-text>\n" +
    "              <span class=\"md-title\">Preguntas Generales</span>\n" +
    "              <span class=\"md-subhead\">Detalles basicos sobre prguntas generales de cosas vacanas</span>\n" +
    "            </md-card-header-text>\n" +
    "          </md-card-header>\n" +
    "        </md-card>\n" +
    "\n" +
    "        <md-card ng-class=\"{active:vm.list.prices}\" ng-click=\"vm.showList('prices')\">\n" +
    "          <md-card-header>\n" +
    "            <md-card-avatar>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </md-card-avatar>\n" +
    "            <md-card-header-text>\n" +
    "              <span class=\"md-title\">Precios y Planes</span>\n" +
    "              <span class=\"md-subhead\">Detalles basicos sobre prguntas generales de cosas vacanas</span>\n" +
    "            </md-card-header-text>\n" +
    "          </md-card-header>\n" +
    "        </md-card>\n" +
    "\n" +
    "        <md-card ng-class=\"{active:vm.list.security}\" ng-click=\"vm.showList('security')\">\n" +
    "          <md-card-header>\n" +
    "            <md-card-avatar>\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n" +
    "            </md-card-avatar>\n" +
    "            <md-card-header-text>\n" +
    "              <span class=\"md-title\">Seguridad</span>\n" +
    "              <span class=\"md-subhead\">Detalles basicos sobre prguntas generales de cosas vacanas</span>\n" +
    "            </md-card-header-text>\n" +
    "          </md-card-header>\n" +
    "        </md-card>\n" +
    "      </div>\n" +
    "      <div class=\"faqs__details\" flex ng-show=\"vm.list.use\">\n" +
    "        <h3 class=\"md-headline\">\n" +
    "          Uso de eMarket\n" +
    "        </h3>\n" +
    "        <em-accordion>\n" +
    "          <em-accordion-expander is-visible=\"vm.open['aprende-comprar']\" title=\"Aprende a comprar en eMarket\">\n" +
    "            <ul>\n" +
    "              <li>Busque el producto en el que esta interesado ya sea por el buscador o por las categorías de productos</li>\n" +
    "              <li>Después de encontrar el producto deseado comuníquese con el vendedor o la persona que publicó el anuncio.</li>\n" +
    "              <li>Llegue a un acuerdo con el vendedor y elijan un punto de encuentro para la compra – venta del producto</li>\n" +
    "              <li>Es importante acordar precio antes de la compra del producto.</li>\n" +
    "              <li>Al momento de comprar el producto es importante acordar detalles como garantía, devoluciones, etc.</li>\n" +
    "              <li>Es importante tener una copia de la cedula del vendedor.</li>\n" +
    "              <li>No olvide guardar los datos del vendedor y del anuncio publicado.</li>\n" +
    "            </ul>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"Consejos prácticos para comprar en eMarket\">\n" +
    "            <ul>\n" +
    "              <li>Investiga sobre el producto antes de comprarlo.</li>\n" +
    "              <li>Busca el valor del producto en el mercado.</li>\n" +
    "              <li>Asegúrate de que el producto que vayas a comprar no sea robado y que sea legal.</li>\n" +
    "              <li>Asegúrate de tener los datos del anunciante.</li>\n" +
    "              <li>Asegúrate de tener el ID del anuncio donde viste el producto y el nombre de usuario.</li>\n" +
    "              <li>Es recomendable ir con una persona que conozca del tipo de producto que vas a comprar y que técnicamente te informe que este está en buenas condiciones.</li>\n" +
    "              <li>Es recomendable tomar una copia de la cedula del vendedor.</li>\n" +
    "              <li>Es recomendable que si no es a una tienda donde vayas a comprar el producto, que se encuentren en un lugar público.</li>\n" +
    "            </ul>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander is-visible=\"vm.open['aprende-vender']\" title=\"Aprende a Vender en eMarket\">\n" +
    "            <ul>\n" +
    "              <li>Lo primero que debes de hacer es regístrarte, completa tus datos personales y ya puedes publicar tus productos <a ui-sref=\"signup\">Registrate Aquí</a>.</li>\n" +
    "              <li>Previamente a publicar tus productos documéntate sobre el producto que vas a vender y el costo del mismo en el mercado y las especificaciones técnicas para que informes correctamente a tu comprador.</li>\n" +
    "              <li>Después de registrado ya puedes publicar tu anuncio después de haber accedido a tu cuenta. <a ui-sref=\"main.post.create\">Publica tu anuncio aquí</a>. Aquí podrás llenar toda la información concerniente al producto a publicar. Si deseas aprender\n" +
    "                a cómo hacerlo vista nuestra sección de Tutoriales</li>\n" +
    "              <li>Luego de publicar tu anuncio debes esperar que el comprador te contacte por los medios de contacto que publicaste en el anuncio o por mensaje directamente desde el website.</li>\n" +
    "              <li>Al momento de vender el producto es importante acordar con el comprador detalles como garantía, devoluciones, etc.</li>\n" +
    "              <li>El comprador y el vendedor deben acordar un punto de encuentro para la compra – venta del producto.</li>\n" +
    "              <li>Es importante guardar los datos del comprador en caso de emergencia.</li>\n" +
    "              <li>Si desea mayor impacto en la venta de sus productos pregunte por nuestros <a ui-sref=\"main.plans\">Planes</a>. Si deseas conocer nuestros planes visita nuestra sección de planes.</li>\n" +
    "              <li>El nuevo emarket cuenta con un nuevo buscador el cual permitirá tener una búsqueda más acertada del producto buscado.</li>\n" +
    "              <li>Mientras más características llenes al momento de crear tu anuncio más seguridad tienes de que tu anuncio será encontrado por los compradores en el buscador.</li>\n" +
    "              <li>No es recomendable publicar más de un producto por anuncio ya que esto no permite el optimo uso del filtro del buscador por lo cual tu anuncio puede no aparecer.</li>\n" +
    "            </ul>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"Consejos prácticos para vender en eMarket\">\n" +
    "            <ul>\n" +
    "              <li>Los primero que debes hacer es Regístrate.</li>\n" +
    "              <li>Luego debes publicar el anuncio que vas a vender.</li>\n" +
    "              <li>Para darle seguridad a los compradores, es recomendable que completes todos los datos de perfil requeridos al momento de crear tu usuario.</li>\n" +
    "              <li>Al momento de crear un anuncio no olvides colocar todas las especificaciones técnicas del producto.</li>\n" +
    "              <li>Complete todos los detalles y características del producto ya que esto le ayuda a que su producto se encuentre mas rápido por medio de los filtros en el buscador.</li>\n" +
    "              <li>Es de suma importancia que subas las fotos del producto, mientras más fotos mejor.</li>\n" +
    "              <li>Recuerda colocar todos tus datos de contacto (Teléfonos, emails, celular, etc.).</li>\n" +
    "              <li>Si quieres tener más impacto con tus anuncios es recomendable que coloques anuncios destacados y que obtengas una cuenta VIP.</li>\n" +
    "            </ul>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo reportar un producto?\">\n" +
    "            <p>Para reportar un producto por su contenido o cualquier motivo que usted considere solo debe presión la opción “Reportar Anuncio” esta opción aparece en el lado derecho de cada anuncio. eMarket agradece tus reportes.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo encontrar un anuncio borrado?\">\n" +
    "            <p>Los productos borrados NO pueden ser recuperados a menos que sea a favor de una investigación solicitada por las autoridades correspondientes. Para poder obtener esta información debe de solicitada formalmente.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo recuperar mi contraseña?\">\n" +
    "            <p>Para recuperar tú clave primero debes acceder a la opción \"Olvidaste tu Contraseña\" luego debes escribir tú Email o Usuario, después de proporcionar esta información debes hacer clic en el botón Recuperar. De esta manera te enviaremos un email de confirmación, este te llegara al correo que está definido en tú perfil.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como borrar un anuncio?\">\n" +
    "            <p>Para borrar un anuncio debes primeramente estar logeado en el site, luego ir a la opción “Mis Anuncios” aquí podrás seleccionar el anuncio o los anuncios que deseas borrar y debes marcar la X roja de este.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como editar un anuncio?\">\n" +
    "            <p>Para editar un anuncio debes primeramente estar logeado en el site, luego ir a la opción “Mis Anuncios” aquí podrás seleccionar el anuncio que deseas editar y debes marcar el lápiz que indica Editar. Luego esta opción te enviara al contenido del el anuncio donde podrás editar las informaciones generales del mismo.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo reiniciar la fecha de mis anuncios para que este en la primera fila?\">\n" +
    "            <p>Para reiniciar la fecha de tus anuncios debes primeramente ser usuario VIP. Si deseas conocer nuestros planes visita nuestra sección de planes. Si ya eres usuario VIP solo debes seleccionar los anuncios que deseas reiniciar y seleccionar la opción “Reiniciar Fecha”.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo modificar mis datos de contacto?\">\n" +
    "            <p>Si deseas modificar tus datos de usuario debes primeramente estar logeado en el site, luego ir a la opción “Perfil,” aquí tendrás las opción de modificar tus datos personales y tu fotografía.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Puedo compartir mis anuncios con Facebook y/o Twitter?\">\n" +
    "            <p>Si, puedes compartir tus anuncios con Facebook y Twitter, para esto solo debes ir al anuncio que deseas compartir y a la derecha tendrás las opciones para “Compartir”.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo comunicarme con un usuario de la pagina?\">\n" +
    "            <p>Puedes contactarlo a los número de contacto que a publicado en el anuncio o por medio del mismo anuncio del usuario con la opción “Enviar Mensaje a Este Vendedor”.</p>\n" +
    "          </em-accordion-expander>\n" +
    "        </em-accordion>\n" +
    "      </div>\n" +
    "      <div class=\"faqs__details\" flex ng-show=\"vm.list.general\">\n" +
    "        <h3 class=\"md-headline\">\n" +
    "          Preguntas Generales\n" +
    "        </h3>\n" +
    "        <em-accordion>\n" +
    "          <em-accordion-expander title=\"¿Que es emarket?\">\n" +
    "            <p>eMarket es un portal dedicada a la publicación de cualquier producto o servicio por medio de nuestros usuarios registrados</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo comprar un producto?\">\n" +
    "            <p>eMarket solo anuncia productos de los usuarios registrados en el portal, para comprar un producto debes comunicarte directamente con la persona que publicó el producto.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿eMarket vende productos?\">\n" +
    "            <p>No eMarket no vende <strong>Ninguno</strong> de los productos anunciados en la pagina solo somos un portal de clasificados. Para comprar un producto anunciado en la página debes comunicarte directamente con la persona que publicó el anuncio.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿eMarket es responsable de las transacciones realizadas en la pagina?\">\n" +
    "            <p>No eMarket no es responsable ni es intermediario de las transacciones comerciales que se hagan por medio de los usuarios de la página.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo tener más anuncios?\">\n" +
    "            <p>Para tener más anuncios debes actualizar tu plan, dependiendo del plan que tengas mas anuncios y más propiedades tendrás a la hora de hacer tus publicaciones. Si deseas conocer nuestros planes visita nuestra sección de planes.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Porque no se activado mi cuenta aun?\">\n" +
    "            <p>Si no se ha activado tu cuenta aun debes confirma que ya hayas recibido el Email de confirmación y hayas dado clic en el link de activación de la cuenta.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Porque no me llega mi correado de activación?\">\n" +
    "            <p>Si tu Email fue escrito correctamente al momento de crear tu usuario, el Email de activación te llegara, si no lo tienes en la “Bandeja de Entrada “puedes verificarlo en la carpeta de “Correos No Deseados”</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Puedo cambiar mi nombre de usuario?\">\n" +
    "            <p>No, por motivos de seguridad los usuarios son únicos y no pueden ser cambiados.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo obtener el IMEI de mi celuar?\">\n" +
    "            <p>Marcando *#06# desde tu celular.</p>\n" +
    "          </em-accordion-expander>\n" +
    "        </em-accordion>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"faqs__details\" flex ng-show=\"vm.list.prices\">\n" +
    "        <h3 class=\"md-headline\">\n" +
    "          Precios y Planes\n" +
    "        </h3>\n" +
    "        <em-accordion>\n" +
    "          <em-accordion-expander is-visible=\"vm.open['metodo-pago']\" title=\"Métodos de pago\">\n" +
    "            <h3>Depósito Bancario</h3>\n" +
    "\n" +
    "            <p>Haz el pago de tus servicios publicitarios por medio de depósito a una cuenta del Banco Popular con el Numero <strong>747318277</strong> a nombre de DomiNet S.A. Si deseas puedes hacer directamente depósito en las oficinas del banco o por\n" +
    "              transferencia usando Internet Banking.</p>\n" +
    "\n" +
    "            <p>Recuerda al hacer tus pagos colocar tus datos como Nombre y Usuario en Emarket.</p>\n" +
    "\n" +
    "            <h3>Vía Telefónica</h3>\n" +
    "\n" +
    "            <p>Puedes hacer el pago de tus servicios publicitarios desde la comodidad de tu teléfono. Llámanos al 809-381-2306.</p>\n" +
    "\n" +
    "            <h3>Vía Oficina Comercial</h3>\n" +
    "\n" +
    "            <p>Puedes pasar directamente a nuestra oficina comercial y hacer el pago directamente en nuestras instalaciones. Estamos ubicados en Av. 27 de Febrero No. 269, Plaza Central, 4to. Nivel, local 17, Piantini Santo Domingo, República Dominicana.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"Banners\" is-visible=\"vm.open['banners']\">\n" +
    "            <p>eMarket es el portal número uno de clasificados en República Dominicana. Logre que su inversión publicitaria en internet tenga buen retorno aprovechando el potencial de nuestro medio. Utiliza uno de nuestros Banners para publicitar tu marca</p>\n" +
    "            <p>Si quieres conocer más de nuestros Banners Contáctanos</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Cuál es el costo para publicarme en emarket?\">\n" +
    "            <p>Puedes registrarte y tener hasta 10 anuncios por 25 días totalmente GRATIS. Si deseas tener más anuncios y destacarlo puedes optar por uno de nuestros planes, puedes visitar nuestra sección de planes.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Como puedo anunciarme en las posiciones Premium?\" is-visible=\"vm.open['premiums']\">\n" +
    "            <p>Para anunciarte en las posiciones premios debes comunicarte con nosotros para confirma la disponibilidad de las mismas al 809-381-2306 ext. 122</p>\n" +
    "          </em-accordion-expander>\n" +
    "        </em-accordion>\n" +
    "      </div>\n" +
    "      <div class=\"faqs__details\" flex ng-show=\"vm.list.security\">\n" +
    "        <h3 class=\"md-headline\">\n" +
    "          Seguridad\n" +
    "        </h3>\n" +
    "        <em-accordion>\n" +
    "          <em-accordion-expander is-visible=\"vm.open.politica\" title=\"Términos y condiciones\">\n" +
    "            <ol>\n" +
    "              <li>La publicación de un anuncio en nuestro portal NO supone ni representa necesariamente la existencia de relación alguna entre eMarket y quien realiza la publicación.</li>\n" +
    "              <li>eMarket NO tiene ni asume la obligación de verificar la identidad, ni la veracidad, ni la fidelidad, ni la exactitud y/o autenticidad de los datos que el usuario proporciona sobre si mismo.</li>\n" +
    "              <li>eMarket NO garantiza ni se hace responsable de la licitud, fiabilidad, utilidad, fidelidad, veracidad, exactitud y actualidad de la información y/o contenidos publicados en el sitio web.</li>\n" +
    "              <li>eMarket NO asume responsabilidad alguna del uso que el usuario o cualquier tercero pudiera hacer de la información o de los contenidos publicados en el sitio web, ni de los daños y perjuicios que pudieran derivarse del mismo.</li>\n" +
    "              <li>eMarket se reserva el derecho de eliminar cualquier anuncio que entienda no debe estar en el sistema.</li>\n" +
    "              <li>Al publicar un anuncio, el usuario entiende y acepta los términos, condiciones y las reglas de uso de eMarket.</li>\n" +
    "            </ol>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"Reglas de uso\">\n" +
    "            <ol>\n" +
    "              <li>No esta permitido la publicación de más de un anuncio con el mismo titulo y contenido por una misma persona.</li>\n" +
    "              <li>Una persona no puede tener mas de una cuenta con el plan gratuito.</li>\n" +
    "              <li>No se permite la colocación de anuncios en categorías o sub-categorías que no correspondan al contenido del mismo.</li>\n" +
    "              <li>Los anuncios con contenido vulgar, pornográfico e ilegal según las leyes dominicanas NO son permitidos.</li>\n" +
    "              <li>No se permiten anuncios de promoción de websites.</li>\n" +
    "              <li>El titulo debe describir de manera simple y breve el articulo o servicio que se esta ofreciendo.</li>\n" +
    "              <li>El título del anuncio debe describir UN SOLO tipo de articulo o servicio.</li>\n" +
    "              <li>El contenido del anuncio debe describir en primer lugar el producto o servicio descrito en el titulo.</li>\n" +
    "              <li>El contenido del anuncio debe ser real y verídico.</li>\n" +
    "            </ol>\n" +
    "            <p>La violación de estas reglas resultará en la eliminación del anuncio y la posible eliminación y bloqueo del usuario.</p>\n" +
    "          </em-accordion-expander>\n" +
    "\n" +
    "          <em-accordion-expander title=\"¿Si fui estafado por medio de la pagina que puedo hacer?\">\n" +
    "            <p>Si fuiste estafado por medio de la página debe comunicarse con las autoridades correspondientes que en este caso es el DICAT (Departamento de Investigación de Crímenes y Delitos de Alta Tecnología.) Este es el departamento pertinente que le permitirá manejar estos inconvenientes en cooperación con eMarket.</p>\n" +
    "          </em-accordion-expander>\n" +
    "          <em-accordion-expander title=\"¿Puedo comprar artículos a extranjero?\">\n" +
    "            <p>No es recomendable comprar artículos a extranjeras debido a su dudosa procedencia. Exhortamos NO hacer ningún envió de dinero a estos usuarios ya que pueden ser usuarios fraudulentos.</p>\n" +
    "          </em-accordion-expander>\n" +
    "        </em-accordion>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/store/store.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/store/store.tpl.html",
    "<div class=\"store-list\" flex layout=\"row\" layout-align=\"center\">\n" +
    "  <div flex-gt-sm=\"80\" flex>\n" +
    "    <h3 class=\"em-title\">Listado de Tiendas</h3>\n" +
    "    <md-toolbar class=\"md-transparent md-border\">\n" +
    "      <div class=\"md-toolbar-tools\" layout-align=\"center center\">\n" +
    "        <md-input-container class=\"clasic-input\" md-no-float flex flex-xs=\"50\" flex-sm=\"50\">\n" +
    "          <input type=\"search\" ng-model=\"model.q\" ng-change=\"model.searchByName()\" placeholder=\"Buscar por nombre\">\n" +
    "        </md-input-container>\n" +
    "        <md-input-container class=\"clasic-input\" md-no-float flex>\n" +
    "          <md-select ng-change=\"model.filterByCategory(model.filter.category)\" placeholder=\"Categoria\" ng-model=\"model.filter.category\">\n" +
    "            <md-option value=\"all\">Todas las Categorias</md-option>\n" +
    "            <md-option ng-repeat=\"category in model.categories\" ng-value=\"category._id\">{{category.name}}</md-option>\n" +
    "          </md-select>\n" +
    "        </md-input-container>\n" +
    "      </div>\n" +
    "\n" +
    "    </md-toolbar>\n" +
    "    <div class=\"store-list__content\" layout=\"row\" layout-wrap>\n" +
    "      <div layout=\"row\" flex=\"100\" class=\"loading\" ng-show=\"model.loading\" layout-align=\"center\" layout-padding>\n" +
    "        <md-progress-circular md-diameter=\"40\"></md-progress-circular>\n" +
    "      </div>\n" +
    "      <a ui-sref=\"store.home({name:profile.username})\" class=\"store-grid\" flex-gt-md=\"20\" flex=\"25\" flex-xs=\"100\" flex-sm=\"100\"\n" +
    "        ng-repeat=\"profile in model.stores\" ng-hide=\"model.loading\">\n" +
    "        <div class=\"store-grid__container\">\n" +
    "          <div class=\"store-grid__header\">\n" +
    "\n" +
    "            <img em-src-image=\"profile.picture\" square alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"store-grid__details\" flex-sm flex-xs>\n" +
    "            <h4 class=\"store-name\">{{profile.displayName}}\n" +
    "              <md-tooltip md-delay=\"500\">{{profile.displayName}}</md-tooltip>\n" +
    "            </h4>\n" +
    "            <p class=\"store-category\">{{profile.store.categories[0].name || 'Generica'}}</p>\n" +
    "            <p class=\"store-description\">{{profile.store.description || 'Somos una tienda standard'}}</p>\n" +
    "\n" +
    "            <div class=\"store-grid__footer\" hide-gt-sm>\n" +
    "              <p class=\"store__location\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "                <span href=\"\">{{profile.address.province.name}}</span>\n" +
    "              </p>\n" +
    "              <!-- <p class=\"store__products\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-comment-image\"></md-icon>\n" +
    "                <strong>212</strong> productos\n" +
    "              </p> -->\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"store-grid__footer\" hide-xs hide-sm>\n" +
    "            <p class=\"store__location\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "              <span href=\"\">Santo Domingo</span>\n" +
    "            </p>\n" +
    "            <p class=\"store__products\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-comment-image\"></md-icon>\n" +
    "              <strong>{{profile.postQty}}</strong> productos</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </a>\n" +
    "      <div flex=\"100\" layout=\"row\" layout-align=\"space-between\" class=\"mobile-pagination\" ng-show=\"model.stores && model.stores.length > 0\">\n" +
    "        <md-button flex=\"45\" flex-gt-sm=\"40\" ng-click=\"model.prev()\" class=\"md-raised md-primary\" ng-disabled=\"model.hidePrev || model.loading\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "          Anterior\n" +
    "        </md-button>\n" +
    "        <md-button flex=\"45\" flex-gt-sm=\"40\" ng-click=\"model.next()\" class=\"md-raised md-primary\" ng-disabled=\"model.hideNext || model.loading\">\n" +
    "          Siguiente\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n" +
    "        </md-button>\n" +
    "      </div>\n" +
    "\n" +
    "      <h3 flex=\"100\" layout-padding class=\"md-subhead text-center\" ng-if=\"model.stores.length === 0\">No exiten tiendas con el filtro especificado</h3>\n" +
    "    </div>\n" +
    "  </div>");
}]);

angular.module("search/search.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("search/search.tpl.html",
    "<div class=\"search-state\" flex>\n" +
    "  <md-toolbar class=\"md-white md-whiteframe-1dp\">\n" +
    "    <div class=\"md-toolbar-tools\">\n" +
    "      <md-button class=\"md-icon-button\" go-back>\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n" +
    "      </md-button>\n" +
    "      <form flex ng-submit=\"model.search()\" layout=\"row\">\n" +
    "        <input autofocus placeholder=\"Escribe tu busqueda\" type=\"text\" ng-model=\"model.query\" flex>\n" +
    "        <md-button type=\"submit\" class=\"md-icon-button\">\n" +
    "          <md-icon md-font-icon=\"zmdi zmdi-forward\"></md-icon>\n" +
    "        </md-button>\n" +
    "    </form>\n" +
    "    </div>\n" +
    "  </md-toolbar>\n" +
    "  <md-content flex>\n" +
    "    <md-list>\n" +
    "      <md-list-item ui-sref=\"main.post.search({q:'iphone 5s'})\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <p>iphone 5s</p>\n" +
    "          <md-icon class=\"md-secondary zmdi-hc-flip-horizontal\" md-font-icon=\"zmdi zmdi-arrow-right-top\"></md-icon>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "      <md-divider md-inset></md-divider>\n" +
    "      <md-list-item ui-sref=\"main.post.search({q:'motorola'})\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <p>motorola</p>\n" +
    "          <md-icon class=\"md-secondary zmdi-hc-flip-horizontal\" md-font-icon=\"zmdi zmdi-arrow-right-top\"></md-icon>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "      <md-divider md-inset></md-divider>\n" +
    "      <md-list-item ui-sref=\"main.post.search({q:'honda civic'})\">\n" +
    "        <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n" +
    "        <div class=\"md-list-item-text\">\n" +
    "          <p>honda civic</p>\n" +
    "          <md-icon class=\"md-secondary zmdi-hc-flip-horizontal\" md-font-icon=\"zmdi zmdi-arrow-right-top\"></md-icon>\n" +
    "        </div>\n" +
    "      </md-list-item>\n" +
    "    </md-list>\n" +
    "  </md-content>\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/bottom.navigation.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/bottom.navigation.tpl.html",
    "<div class=\"tabs-navigation-bottom tabs-navigation-bottom--store\">\n" +
    "  <md-button ui-sref=\"store.home\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-store\"></md-icon>\n" +
    "    Portada Tienda\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"store.category\">\n" +
    "    <md-icon md-font-icon=\"zmdi zmdi-assignment\"></md-icon>\n" +
    "    Categorías\n" +
    "  </md-button>\n" +
    "  <md-button ui-sref=\"main.home\">\n" +
    "    <md-icon md-svg-src=\"../assets/logo-yb.svg\"></md-icon>\n" +
    "    Ir a eMarket\n" +
    "  </md-button>\n" +
    "</div>");
}]);

angular.module("store/breadcrumbs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/breadcrumbs.tpl.html",
    "<div class=\"store-post__breadcrumbs-container\" layout-align=\"center start\" layout=\"row\">\n" +
    "  <div class=\"store-post__breadcrumbs\" flex-gt-sm=\"80\">\n" +
    "    <p>\n" +
    "      <a ui-sref=\"store.home\">Inicio</a> >\n" +
    "      <a ui-sref=\"store.search({category:category._id})\" ng-repeat-start=\"category in model.post.categoryTree\">{{category.name}}</a>\n" +
    "      <span ng-repeat-end> > </span> {{model.post.title}}\n" +
    "    </p>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("store/home/store-home.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/home/store-home.tpl.html",
    "<div class=\"store-home\" flex>\n" +
    "    <div class=\"store-home__header\" layout=\"row\" layout-align=\"center start\">\n" +
    "        <div class=\"header__container\" flex-gt-md=\"80\" flex=\"95\">\n" +
    "            <div class=\"header__slider\" layout=\"row\">\n" +
    "                <div class=\"category-extra-space\"></div>\n" +
    "                <div class=\"header__slider-text\">\n" +
    "                    <h3>{{model.store.cover.title}}</h3>\n" +
    "                    <h5>{{model.store.cover.subtitle}}</h5>\n" +
    "                    <p>{{model.store.cover.description}}</p>\n" +
    "                    <md-button ui-sref=\"store.search({category:model.store.cover.category._id})\" class=\"md-raised\">{{model.store.cover.buttonTitle}}</md-button>\n" +
    "                </div>\n" +
    "                <div class=\"header__slider-image\">\n" +
    "                    <img em-src-image=\"model.store.cover.image\" large alt=\"\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"store-home__container\" layout=\"row\" layout-align=\"center start\">\n" +
    "        <div class=\"store-home__content\" layout=\"row\" flex-gt-md=\"80\" flex=\"95\" layout-wrap>\n" +
    "\n" +
    "            <em-store-product-list products=\"model.store.highlightedPosts\" ng-if=\"model.store.highlightedPosts && model.store.highlightedPosts.length > 0\" title=\"'Productos Destacados'\"\n" +
    "                flex=\"100\"></em-store-product-list>\n" +
    "\n" +
    "\n" +
    "            <em-store-product-list products=\"model.store.seasonPosts\" ng-if=\"model.store.seasonPosts  && model.store.seasonPosts.length > 0\" title=\"'Especiales de Temporada'\"\n" +
    "                flex=\"100\"></em-store-product-list>\n" +
    "\n" +
    "\n" +
    "            <em-store-product-list products=\"model.latest\" title=\"'Agregados Recientemente'\" flex=\"100\"></em-store-product-list>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("store/post/store-post.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/post/store-post.tpl.html",
    "<div class=\"store-post\" layout=\"column\" flex>\n" +
    "  <div hide-xs hide-sm ng-include=\"'store/breadcrumbs.tpl.html'\"></div>\n" +
    "  <div class=\"store-post__content\" layout=\"row\" layout-align=\"center start\" layout-wrap>\n" +
    "    <div class=\"store-post__header\" layout=\"row\" flex-gt-sm=\"80\">\n" +
    "      <div class=\"store-post__category\">\n" +
    "        <md-list>\n" +
    "          <md-list-item ui-sref=\"store.search({category:category._id})\" ng-repeat-start=\"category in model.categories | limitTo:6\">\n" +
    "            <p>{{category.name}}</p>\n" +
    "          </md-list-item>\n" +
    "          <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "        </md-list>\n" +
    "      </div>\n" +
    "      <div class=\"store-post__detail\" layout=\"row\">\n" +
    "        <div class=\"post-detail__pictures\" slider=\"model.post\" ng-show=\"model.post.images && model.post.images.length > 0\" flex-xs=\"100\"\n" +
    "          flex-sm=\"100\">\n" +
    "          <div class=\"pictures__main\">\n" +
    "            <div class=\"z-slide-item\" ng-repeat=\"image in model.post.images\">\n" +
    "              <img class=\"z-slide-open-large\" em-src-image=\"image\" square alt=\"\" />\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div ng-show=\"model.post.images.length > 1\" class=\"pictures__thumbnails z-slide-thumbnails\">\n" +
    "            <img data-image-id=\"{{$index}}\" ng-repeat=\"image in model.post.images\" em-src-image=\"image\" thumbnail alt=\"\" />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"store-post__info\" flex flex-xs=\"100\" flex-sm=\"100\">\n" +
    "          <h3 class=\"store-post__title\">{{model.post.title}}</h3>\n" +
    "          <span class=\"md-subhead\">Condición:\n" +
    "            <span class=\"{{model.post.condition}}\">{{model.post.condition | translate }}</span>\n" +
    "          </span>\n" +
    "          <md-divider></md-divider>\n" +
    "          <div class=\"store-post__short-description\">\n" +
    "            <p class=\"store-post__price\">{{model.post.prices.list | currency:model.post.currency.symbol: 2}}</p>\n" +
    "            <md-button class=\"md-raised\" ng-click=\"model.showContactDialog($ev)\">Contactar</md-button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div flex-gt-sm=\"80\" layout=\"row\" flex=\"100\">\n" +
    "      <!-- <em-banner size=\"300x250\"></em-banner> -->\n" +
    "      <div class=\"store-post__description\">\n" +
    "        <div class=\"store__title-container store__title--no-border\">\n" +
    "          <h4 class=\"store__title\">Descripción</h4>\n" +
    "        </div>\n" +
    "        <div class=\"store-post__body\" ng-bind-html=\"model.post.content\">\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <em-store-product-list products=\"model.related\" title=\"'Producto Relacionados'\" flex-gt-sm=\"80\" flex=\"100\"></em-store-product-list>\n" +
    "\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("store/search/search-filter.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/search/search-filter.tpl.html",
    "<div class=\"search-filter\">\n" +
    "  <h3>Filtrar Resultados</h3>\n" +
    "  <div class=\"search-filter__categories\">\n" +
    "\n" +
    "    <h4>Categorías</h4>\n" +
    "    <div class=\"store-post__category\">\n" +
    "      <md-list>\n" +
    "        <md-list-item ng-click=\"model.applyFilter('category', filter.category._id)\" ng-repeat-start=\"filter in model.metadata.filter.categories | orderBy:'total':true \">\n" +
    "          <p>{{filter.category.name}}({{filter.total}})</p>\n" +
    "        </md-list-item>\n" +
    "        <md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n" +
    "      </md-list>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"search-filter__prices\">\n" +
    "\n" +
    "    <h4>Precio</h4>\n" +
    "    <div class=\"search-filter__price\">\n" +
    "        <form ng-submit=\"model.filterPrice(model.fromPrice, model.toPrice)\">\n" +
    "            <small>De</small>\n" +
    "            <md-input-container flex>\n" +
    "                <input aria-label=\"precio desde\" type=\"number\" min=\"0\" max=\"{{model.toPrice}}\" step=\"100\" ng-model=\"model.fromPrice\">\n" +
    "            </md-input-container>\n" +
    "            <small>A</small>\n" +
    "            <md-input-container flex>\n" +
    "                <input aria-label=\"precio hasta\" type=\"number\" step=\"100\" min=\"{{model.fromPrice || 0}}\" ng-model=\"model.toPrice\">\n" +
    "            </md-input-container>\n" +
    "            <md-button type=\"submit\" class=\"md-icon-button\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n" +
    "            </md-button>\n" +
    "            <div flex=\"100\" class=\"md-button-wrapper\">\n" +
    "              <md-button ng-hide=\"!model.fromPrice && !model.toPrice\" ng-click=\"model.clearPrice()\">Limpiar Precio</md-button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"search-filter__conditions\" ng-show=\"model.metadata.filter.conditions.length > 1\">\n" +
    "    <h4>Condición</h4>\n" +
    "    <md-checkbox ng-repeat=\"filter in model.metadata.filter.conditions |orderBy:'-total'\" flex=\"100\" ng-model=\"model.filteringCondition[filter.condition]\" ng-change=\"model.applyFilter('condition', filter.condition, !model.filteringCondition[filter.condition])\" aria-label=\"condición\">\n" +
    "        {{filter.condition | translate}} ({{filter.total | currency:'':0}})\n" +
    "    </md-checkbox>\n" +
    "  </div>\n" +
    "  <div class=\"search-filter__currencies\">\n" +
    "    <h4>Moneda</h4>\n" +
    "    <md-checkbox ng-repeat=\"filter in model.metadata.filter.currencies |orderBy:'-total'\" flex=\"100\" ng-model=\"model.filteringCondition[filter.currency.symbol]\" ng-change=\"model.applyFilter('currency', filter.currency.symbol, !filteringCondition[filter.currency.symbol])\" aria-label=\"condición\">\n" +
    "        {{filter.currency.symbol }} ({{filter.total | currency:'':0}})\n" +
    "    </md-checkbox>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/search/store-search-results.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/search/store-search-results.tpl.html",
    "<div class=\"search-results\" flex layout=\"row\" layout-wrap>\n" +
    "  <em-store-product hide-xs hide-sm flex=\"25\" size=\"'small'\" ng-repeat=\"product in model.posts\" product=product></em-store-product>\n" +
    "  <em-store-product hide-gt-sm flex=\"100\" direction=\"horizontal\" size=\"'small'\" ng-repeat=\"product in model.posts\" product=product></em-store-product>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/search/store-search.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/search/store-search.tpl.html",
    "<div flex class=\"store-search\" layout=\"column\">\n" +
    "  <!-- <div hide-xs hide-sm ng-include=\"'store/breadcrumbs.tpl.html'\"></div> -->\n" +
    "  <div class=\"store-search__container\" layout=\"row\" layout-align=\"center start\">\n" +
    "    <div flex-gt-sm=\"80\" flex=\"95\" layout=\"row\">\n" +
    "      <div hide-xs hide-sm class=\"filter-container\" flex-gt-sm=\"25\" ng-include=\"'store/search/search-filter.tpl.html'\">\n" +
    "\n" +
    "      </div>\n" +
    "      <div class=\"search-result-container\" flex>\n" +
    "        <div class=\"search-sumary\">\n" +
    "          <p>Más de\n" +
    "            <strong>{{model.metadata.total}}</strong> resultados de la busqueda\n" +
    "            <strong ng-show=\"model.q\">{{model.q}}</strong>\n" +
    "          </p>\n" +
    "        </div>\n" +
    "        <md-toolbar>\n" +
    "          <div class=\"md-toolbar-tools\">\n" +
    "            <md-input-container md-no-float flex-xs flex-sm>\n" +
    "              <md-select placeholder=\"Organizar por\" ng-change=\"model.makeSort()\" ng-model=\"model.sort\">\n" +
    "                <md-option value=\"\">Relevancia</md-option>\n" +
    "                <md-option value=\"prices.list\">Más barato primero</md-option>\n" +
    "                <md-option value=\"-prices.list\">Más caro primero</md-option>\n" +
    "                <md-option value=\"createdAt\">Más antiguos primero</md-option>\n" +
    "                <md-option value=\"-createdAt\">Más reciente primero</md-option>\n" +
    "              </md-select>\n" +
    "            </md-input-container>\n" +
    "\n" +
    "            <md-button class=\"filter\" hide-gt-sm ng-hide=\"true\">\n" +
    "              <md-icon md-font-icon=\"zmdi zmdi-filter-list\"></md-icon>\n" +
    "              <span>Filtrar</span>\n" +
    "            </md-button>\n" +
    "          </div>\n" +
    "        </md-toolbar>\n" +
    "        <div layout=\"row\" class=\"search-results-content\" ng-include=\"'store/search/store-search-results.tpl.html'\">\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("store/statics/store-static-contact.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/statics/store-static-contact.tpl.html",
    "<div class=\"store-contact\" layout=\"column\" flex>  \n" +
    "  <div class=\"store-contact__content\" layout=\"row\" layout-align=\"center start\">\n" +
    "    <div flex-gt-sm=\"55\" class=\"store-contact__form\">\n" +
    "      <div class=\"store__title-container\">\n" +
    "        <h4 class=\"store__title\">Contáctanos</h4>\n" +
    "      </div>\n" +
    "      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non optio animi deserunt itaque officia qui, sed similique dignissimos veritatis voluptatem quam delectus, accusantium quos numquam aliquam, vel corrupti.</p>\n" +
    "      <form action=\"\" layout=\"row\" layout-wrap>\n" +
    "        <div flex=\"50\">\n" +
    "          <label for=\"\">Nombre:</label>\n" +
    "          <div class=\"input-container\">\n" +
    "            <input type=\"text\" required>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div flex=\"50\">\n" +
    "          <label for=\"\">Tema:</label>\n" +
    "          <div class=\"input-container\">\n" +
    "\n" +
    "            <input type=\"text\" required>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div flex=\"100\">\n" +
    "          <label for=\"\">Mensaje:</label>\n" +
    "          <div class=\"input-container\">\n" +
    "\n" +
    "            <textarea></textarea>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </form>\n" +
    "    </div>\n" +
    "    <div flex-gt-sm=\"25\">\n" +
    "      <div class=\"store__title-container\">\n" +
    "        <h4 class=\"store__title\">Nuestra Tienda</h4>\n" +
    "      </div>\n" +
    "      <iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.9318427230064!2d-69.93968198447972!3d18.441403487455155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ea5621601ff10cb%3A0x69c9d30e027c03c8!2sAv+Central%2C+Santo+Domingo!5e0!3m2!1sen!2sdo!4v1492807985764\"\n" +
    "        width=\"100%\" height=\"300\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe>\n" +
    "      <p>Respald 17. #15 Ensanche Quisqueya. Santo Domingo, Distrito Nacional. República Dominicana.</p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/statics/store-static.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/statics/store-static.tpl.html",
    "<div flex class=\"store-static\" layout=\"column\">\n" +
    "  <div class=\"store-static__container\" layout=\"row\" layout-align=\"center start\">\n" +
    "    <div flex-gt-sm=\"80\" flex>\n" +
    "      <div class=\"store__title-container\">\n" +
    "        <h4 class=\"store__title\">Descripción</h4>\n" +
    "      </div>\n" +
    "      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia temporibus officiis quas accusamus obcaecati quod adipisci sit accusantium eaque provident blanditiis a saepe voluptatum molestiae hic, recusandae sequi. Veritatis, facilis!</p>\n" +
    "\n" +
    "      <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure\n" +
    "        dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/store-categories-menu/store.categories.menu.panel.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-categories-menu/store.categories.menu.panel.tpl.html",
    "<md-list class=\"store__category-list\">\n" +
    "    <md-list-item ng-click=\"vm.close()\" ui-sref=\"store.search({category:category._id})\" ng-repeat-start=\"category in vm.categories\">\n" +
    "        <h3>{{category.name}}</h3>\n" +
    "    </md-list-item>\n" +
    "    <md-divider ng-repeat-end></md-divider>\n" +
    "</md-list>");
}]);

angular.module("store/store-categories-menu/store.categories.menu.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-categories-menu/store.categories.menu.tpl.html",
    "<div class=\"store__category\">\n" +
    "    <div class=\"store__category__title\">\n" +
    "        <h4>\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-format-list-bulleted\"></md-icon>\n" +
    "            Categorías\n" +
    "        </h4>\n" +
    "    </div>\n" +
    "    <md-list class=\"store__category-list\" ng-if=\"sticky\">\n" +
    "        <md-list-item ui-sref=\"store.search({category:category._id})\" ng-repeat-start=\"category in categories | limitTo:limit\">\n" +
    "            <h3>{{category.name}}</h3>\n" +
    "        </md-list-item>\n" +
    "        <md-divider ng-repeat-end></md-divider>\n" +
    "    </md-list>\n" +
    "</div>");
}]);

angular.module("store/store-categories/store-categories.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-categories/store-categories.tpl.html",
    "<div class=\"store__category\">\n" +
    "    <div class=\"store__category__title\">\n" +
    "        <h4>\n" +
    "            <md-icon md-font-icon=\"zmdi zmdi-format-list-bulleted\"></md-icon>\n" +
    "            Categorías\n" +
    "        </h4>\n" +
    "    </div>\n" +
    "    <md-list class=\"store__category-list\" ng-class=\"{visible:state.visible}\">\n" +
    "        <md-list-item ui-sref=\"store.search({category:category._id})\" ng-repeat-start=\"category in categories\">\n" +
    "            <h3>{{category.name}}</h3>\n" +
    "        </md-list-item>\n" +
    "        <md-divider ng-repeat-end></md-divider>\n" +
    "    </md-list>\n" +
    "</div>");
}]);

angular.module("store/store-product-list/store-product-list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-product-list/store-product-list.tpl.html",
    "<div class=\"store__product-list\">\n" +
    "    <div class=\"store__title-container\">\n" +
    "        <h4 class=\"store__title\">{{title}}</h4>\n" +
    "    </div>\n" +
    "    <div class=\"store-products\" layout=\"row\">\n" +
    "        <em-store-product ng-repeat=\"product in products\" product=\"product\" flex=\"20\"></em-store-product>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("store/store-product/store-product.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-product/store-product.tpl.html",
    "<a ui-sref=\"store.post({title:product._id})\" md-ink-ripple class=\"product-container\" ng-class=\"size\">\n" +
    "  <small class=\"product-category\">{{product.category.name}}</small>\n" +
    "  <div class=\"product\">\n" +
    "    <p class=\"product__title\">{{product.title}}</p>\n" +
    "    <img em-src-image=\"product.images[0]\" square alt=\"\">\n" +
    "    <p class=\"product__price\">{{product.prices.list | currency:product.currency.symbol:2}}</p>\n" +
    "  </div>\n" +
    "</a>\n" +
    "");
}]);

angular.module("store/store-product/store.product.horizontal.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/store-product/store.product.horizontal.tpl.html",
    "<a ui-sref=\"store.post({title:product._id})\" md-ink-ripple class=\"product-container product-container--horizontal\" ng-class=\"size\">\n" +
    "  <div class=\"image__container\">\n" +
    "    <img em-src-image=\"product.images[0]\" thumbnail alt=\"\">\n" +
    "  </div>\n" +
    "  <div class=\"product\">\n" +
    "    <small class=\"product-category\">{{product.category.name}}</small>\n" +
    "    <p class=\"product__title\">{{product.title}}</p>\n" +
    "    <p class=\"product__price\">{{product.prices.list | currency:product.currency.symbol:2}}</p>\n" +
    "  </div>\n" +
    "</a>\n" +
    "");
}]);

angular.module("store/template.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("store/template.tpl.html",
    "<div class=\"store\">\n" +
    "    <md-toolbar hide-xs hide-sm class=\"md-small md-white emarket-toolbar\" ng-controller=\"NavigationController as model\">\n" +
    "        <div class=\"md-toolbar-tools\">\n" +
    "            <md-button ui-sref=\"main.home\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n" +
    "                regresar a\n" +
    "                <img class=\"img-responsive\" src=\"assets/logo.png\" alt=\"\">\n" +
    "            </md-button>\n" +
    "            <div class=\"container\" layout=\"row\" flex=\"95\" flex-gt-md=\"80\">\n" +
    "                <!-- <a ui-sref=\"main.home\" class=\"logo\">\n" +
    "                    <img class=\"img-responsive\" src=\"assets/logo.png\" alt=\"\">\n" +
    "                </a> -->\n" +
    "                <span flex></span>\n" +
    "                <div ng-include=\"'main/navigation-bar/profile/profile.tpl.html'\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </md-toolbar>\n" +
    "    <div class=\"store__header store--border\" layout=\"row\" layout-align=\"center\" layout-wrap>\n" +
    "        <div flex-gt-md=\"80\" flex=\"95\" layout=\"row\" class=\"store__header-info\">\n" +
    "            <div class=\"store__logo\">\n" +
    "                <a ui-sref=\"store.home\" class=\"logo-wrapper\" layout=\"row\" layout-align=\"start center\">\n" +
    "                    <img ng-if=\"model.store.picture\" em-src-image=\"model.store.picture\" thumbnail />\n" +
    "                    <h3>{{model.store.displayName}}</h3>\n" +
    "                </a>\n" +
    "                <p>{{model.store.store.description}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"store__header__search\">\n" +
    "                <form ng-submit=\"model.search()\">\n" +
    "                    <md-input-container md-no-float flex>\n" +
    "                        <input type=\"search\" ng-model=\"model.q\" placeholder=\"Buscar productos\" />\n" +
    "                    </md-input-container>\n" +
    "                    <md-button aria-label=\"buscar\" type=\"submit\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "                    </md-button>\n" +
    "                    <!-- <md-button aria-label=\"buscar\" hide-gt-sm ui-sref=\"store.search-bar\">\n" +
    "                        <md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon>\n" +
    "                    </md-button> -->\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <div class=\"store__header__contact\">\n" +
    "                <p>\n" +
    "                    <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n" +
    "                    {{model.store.phones[0].number | bcTelephone:'format'}}\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"store__header__navigation\" flex-gt-md=\"80\" flex=\"95\" layout=\"row\">\n" +
    "            <em-store-categories-menu hide-xs hide-sm sticky=\"config.sticky\" compact=\"config.compact\" categories=\"model.categories\"></em-store-categories-menu>\n" +
    "            <div class=\"store__navigation\" flex>\n" +
    "                <md-nav-bar aria-label=\"navegación\" md-selected-nav-item=\"model.currentNavItem\">\n" +
    "                    <md-nav-item md-nav-sref=\"store.home\" hide-xs hide-sm aria-label=\"Navegar a inicio\" name=\"store.home\">\n" +
    "                        Inicio\n" +
    "                    </md-nav-item>\n" +
    "                    <md-nav-item md-nav-sref=\"store.static.about\" aria-label=\"Navegar a sobre nototros\" name=\"store.static.about\">\n" +
    "                        <span hide-xs hide-sm>Sobre </span>Nosotros\n" +
    "                    </md-nav-item>\n" +
    "                    <md-nav-item md-nav-sref=\"store.static.policies\" aria-label=\"Navegar a política de compra\" name=\"store.static.policies\">\n" +
    "                        Política de Compra\n" +
    "                    </md-nav-item>\n" +
    "                    <md-nav-item md-nav-sref=\"store.static.contact\" aria-label=\"Navegar a contacto\" name=\"store.static.contact\">\n" +
    "                        Contacto\n" +
    "                    </md-nav-item>\n" +
    "                </md-nav-bar>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <ui-view layout=\"row\" name=\"store\"></ui-view>\n" +
    "    <div class=\"store__footer store--border grey-section\" layout=\"row\" layout-align=\"center\">\n" +
    "        <div class=\"store__footer__container\" flex-gt-md=\"80\" flex=\"95\" layout=\"row\">\n" +
    "            <div class=\"store__logo store__footer__section\" flex>\n" +
    "                <a ui-sref=\"store.home\" class=\"logo-wrapper\" layout=\"row\" layout-align=\"start center\">\n" +
    "                    <img ng-if=\"model.store.picture\" em-src-image=\"model.store.picture\" thumbnail />\n" +
    "                    <h3>{{model.store.displayName}}</h3>\n" +
    "                </a>\n" +
    "                <p>{{model.store.store.description}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"store__footer__section\" flex=\"100\" flex-gt-sm=\"30\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n" +
    "                <div class=\"footer__section__text\" flex>\n" +
    "                    <h5>Visitanos</h5>\n" +
    "                    <p>{{model.store.address.street}} {{model.store.address.province.name}}</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"store__footer__section\" flex-gt-sm flex-xs=\"60\" flex-sm=\"60\">\n" +
    "                <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n" +
    "                <div class=\"footer__section__text\">\n" +
    "                    <h5>Llámanos</h5>\n" +
    "                    <h3>\n" +
    "                        {{model.store.phones[0].number | bcTelephone:'format'}}\n" +
    "                    </h3>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"store__footer__section\" flex-gt-sm flex-xs=\"40\" flex-sm=\"50\">\n" +
    "\n" +
    "                <div class=\"footer__section__text\">\n" +
    "                    <h5>Siguenos</h5>\n" +
    "                    <div class=\"social-buttons\">\n" +
    "                        <md-button aria-label=\"ir al perfil de twitter de Daniel Store\" class=\"md-mini md-icon-button twitter\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon>\n" +
    "                        </md-button>\n" +
    "                        <md-button aria-label=\"ir al perfil de facebook de Daniel Store\" class=\"md-mini md-icon-button facebook\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon>\n" +
    "                        </md-button>\n" +
    "                        <md-button aria-label=\"ir al perfil de youtube de Daniel Store\" class=\"md-mini md-icon-button youtube\">\n" +
    "                            <md-icon md-font-icon=\"zmdi zmdi-youtube\"></md-icon>\n" +
    "                        </md-button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div hide-gt-sm ng-include=\"'store/bottom.navigation.tpl.html'\"></div>");
}]);
